/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  UUID: { input: any; output: any };
};

export type AdditionalPermissions = {
  __typename?: 'AdditionalPermissions';
  allow_cusip?: Maybe<Scalars['Boolean']['output']>;
  contact_info?: Maybe<Scalars['Boolean']['output']>;
};

export type AdditionalPermissionsInput = {
  allow_cusip?: InputMaybe<Scalars['Boolean']['input']>;
  contact_info?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApiKey = {
  __typename?: 'ApiKey';
  apiKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum ApiKeyEndpoint {
  Contact = 'contact',
  LocationMapper = 'location_mapper',
  Query = 'query',
  ResumeEnrichmentWrapper = 'resume_enrichment_wrapper',
  ResumeParserProcessing = 'resume_parser_processing',
  ResumeParserProcessingDev = 'resume_parser_processing_dev',
  SentimentReviews = 'sentiment_reviews',
  SkillMapper = 'skill_mapper',
  Taxonomy = 'taxonomy',
}

export type ApiKeyMetadata = {
  __typename?: 'ApiKeyMetadata';
  api_key_id: Scalars['String']['output'];
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_name?: Maybe<Scalars['String']['output']>;
  endpoints: Array<ApiKeyEndpoint>;
};

export enum BadUsersVersion {
  V0 = 'V0',
  V1 = 'V1',
  V2 = 'V2',
  V3 = 'V3',
  V3_1 = 'V3_1',
}

export enum BinaryOperation {
  And = 'AND',
  Or = 'OR',
}

export type Breakdown = {
  __typename?: 'Breakdown';
  headcount: Array<BrkDataPoint>;
  id: Scalars['Int']['output'];
  long_name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  short_name: Scalars['String']['output'];
};

export type BreakdownDataPoint = {
  __typename?: 'BreakdownDataPoint';
  count?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  share?: Maybe<Scalars['Float']['output']>;
};

export type BreakdownEntity = {
  __typename?: 'BreakdownEntity';
  metadata: BreakdownMetadata;
  timeseries: Array<BreakdownDataPoint>;
};

export type BreakdownMetadata = {
  __typename?: 'BreakdownMetadata';
  id: Scalars['Int']['output'];
  long_name: Scalars['String']['output'];
  short_name: Scalars['String']['output'];
};

export type BreakdownOpt = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  selected?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type BrkCounts = {
  __typename?: 'BrkCounts';
  current_count: Scalars['Float']['output'];
  current_share: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  inflows_count: Scalars['Float']['output'];
  inflows_share: Scalars['Float']['output'];
  long_name: Scalars['String']['output'];
  outflows_count: Scalars['Float']['output'];
  outflows_share: Scalars['Float']['output'];
  short_name: Scalars['String']['output'];
};

export type BrkDataPoint = {
  __typename?: 'BrkDataPoint';
  count: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  share: Scalars['Float']['output'];
};

export type CheckApiKeyResponse = {
  __typename?: 'CheckApiKeyResponse';
  apis: Array<ApiKeyEndpoint>;
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type Client = {
  __typename?: 'Client';
  active: Scalars['Boolean']['output'];
  client_name?: Maybe<Scalars['String']['output']>;
  company_lists?: Maybe<Array<Scalars['String']['output']>>;
  custom_taxonomy?: Maybe<CustomTaxonomyEnum>;
  data_builder_configuration?: Maybe<PipelineClientConfig>;
  deliverables?: Maybe<Array<PipelineConfig>>;
  linkup_postings: Scalars['Boolean']['output'];
  live: Scalars['Boolean']['output'];
  metadata?: Maybe<Array<Maybe<KeyValueResp>>>;
  num_seats: Scalars['String']['output'];
  oidc_config?: Maybe<OidcConfig>;
  reports_configuration?: Maybe<ClientReportsConfig>;
  tabs?: Maybe<Array<Tab>>;
  unified_postings: Scalars['Boolean']['output'];
  users?: Maybe<Array<Maybe<User>>>;
};

export type ClientDeliverable = {
  __typename?: 'ClientDeliverable';
  client: Scalars['String']['output'];
  company_reference?: Maybe<Scalars['String']['output']>;
  company_sets?: Maybe<Array<Maybe<CompanySet>>>;
  dashboard_companies?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  deliverables: Array<Maybe<DeliverableOutput>>;
  lag_data?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  pipeline_input?: Maybe<Scalars['String']['output']>;
};

export type ClientDeliverableInput = {
  client: Scalars['String']['input'];
  company_reference?: InputMaybe<Scalars['String']['input']>;
  company_sets?: InputMaybe<Array<InputMaybe<CompanySet>>>;
  company_tickers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dashboard_companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  deliverables: Array<InputMaybe<Deliverable>>;
  lag_data?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  pipeline_input?: InputMaybe<Scalars['String']['input']>;
};

export type ClientDeliverableOutput = {
  __typename?: 'ClientDeliverableOutput';
  created_at?: Maybe<Scalars['String']['output']>;
  deliverable: ClientDeliverable;
  job_id: Scalars['Int']['output'];
  job_name?: Maybe<Scalars['String']['output']>;
  status: DeliveryStatus;
  updated_at?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type ClientDeliverableResponse = {
  __typename?: 'ClientDeliverableResponse';
  delivery_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type ClientReportsConfig = {
  __typename?: 'ClientReportsConfig';
  all_report_types: Array<Scalars['String']['output']>;
  defaults: Array<ReportTypeEnum>;
  report_types: Array<ReportTypeEnum>;
};

export type ClientReportsConfigInput = {
  report_types: Array<ReportTypeEnum>;
};

export type ClientRequest = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  client_name: Scalars['String']['input'];
  company_lists?: InputMaybe<Array<Scalars['String']['input']>>;
  custom_taxonomy?: InputMaybe<CustomTaxonomyEnum>;
  data_builder_configuration?: InputMaybe<PipelineClientConfigInput>;
  linkup_postings?: InputMaybe<Scalars['Boolean']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<InputMaybe<KeyValue>>>;
  num_seats?: InputMaybe<Scalars['String']['input']>;
  oidc_config?: InputMaybe<OidcConfigInput>;
  reports_configuration?: InputMaybe<ClientReportsConfigInput>;
  tabs?: InputMaybe<Array<Tab>>;
  unified_postings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ColumnInfo = {
  __typename?: 'ColumnInfo';
  name?: Maybe<Scalars['String']['output']>;
  output_name?: Maybe<Scalars['String']['output']>;
};

export type ColumnInfoInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  output_name?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyInfoConfiguration = {
  include_subsidiaries?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyInfoConfigurationOutput = {
  __typename?: 'CompanyInfoConfigurationOutput';
  include_subsidiaries?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanyList = {
  __typename?: 'CompanyList';
  clients?: Maybe<Array<Maybe<Client>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  viewable?: Maybe<Scalars['Boolean']['output']>;
};

export enum CompanyMapperVersion {
  V1 = 'V1',
  V2 = 'V2',
}

export type CompanyRefInfo = {
  __typename?: 'CompanyRefInfo';
  dataUnavailableIn?: Maybe<ManifestKind>;
  headcount?: Maybe<Scalars['Int']['output']>;
  headquarters?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  industryId?: Maybe<Scalars['ID']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  overview?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  rcid?: Maybe<Scalars['String']['output']>;
  ricksK50?: Maybe<Scalars['String']['output']>;
  ricsK50Id?: Maybe<Scalars['ID']['output']>;
  ricsK400?: Maybe<Scalars['String']['output']>;
  ricsK400Id?: Maybe<Scalars['ID']['output']>;
  sedol?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  ticker?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  yearFounded?: Maybe<Scalars['String']['output']>;
};

export type CompanyRefInfoInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  industryId?: InputMaybe<Scalars['ID']['input']>;
  isin?: InputMaybe<Scalars['String']['input']>;
  longName?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  rcid?: InputMaybe<Scalars['String']['input']>;
  sedol?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  ticker?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export enum CompanySet {
  Eurostoxx_50 = 'eurostoxx_50',
  Ftse_100 = 'ftse_100',
  Nasdaq_100 = 'nasdaq_100',
  PublicUs = 'public_us',
  RevelioShared = 'revelio_shared',
  RevelioSharedPrivate = 'revelio_shared_private',
  RevelioSharedPublic = 'revelio_shared_public',
  Russell_1000 = 'russell_1000',
  Sp_500 = 'sp_500',
}

export type CompensationCategory = {
  __typename?: 'CompensationCategory';
  metadata?: Maybe<Metadata>;
  metrics?: Maybe<CompensationMetrics>;
};

export enum CompensationDimension {
  All = 'all',
  Company = 'company',
  Geography = 'geography',
  Role = 'role',
}

export type CompensationFilters = {
  city?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  company?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contingent_workers?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  custom_role?: InputMaybe<CustomRoleFilter>;
  custom_skill?: InputMaybe<CustomSkillFilter>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  gender?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  highest_degree?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  industry?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  job_category?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  msa?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  region?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rics_k10?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rics_k50?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rics_k400?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  role_k150?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  role_k1500?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  seniority?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type CompensationMetrics = {
  __typename?: 'CompensationMetrics';
  count?: Maybe<Scalars['Int']['output']>;
  share?: Maybe<Scalars['Float']['output']>;
};

export type CompensationResponse = {
  __typename?: 'CompensationResponse';
  category?: Maybe<Array<Maybe<CompensationCategory>>>;
  dimension?: Maybe<CompensationDimension>;
  metadata?: Maybe<Metadata>;
};

export type CompositionV2BreakdownOptions = {
  Education?: InputMaybe<BreakdownOpt>;
  Ethnicity?: InputMaybe<BreakdownOpt>;
  Gender?: InputMaybe<BreakdownOpt>;
  Geography?: InputMaybe<BreakdownOpt>;
  Rics?: InputMaybe<BreakdownOpt>;
  Role?: InputMaybe<BreakdownOpt>;
  Seniority?: InputMaybe<BreakdownOpt>;
  Skill?: InputMaybe<BreakdownOpt>;
  StateOverMsa?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompositionV2EntRefs = {
  __typename?: 'CompositionV2EntRefs';
  months: Array<Scalars['String']['output']>;
};

export type CompositionV2EntResp = {
  __typename?: 'CompositionV2EntResp';
  metadata: EntMetadata;
  metrics: CompositionV2EntRespData;
};

export type CompositionV2EntRespData = {
  __typename?: 'CompositionV2EntRespData';
  attrition_rate: Array<EntityWideDataPoint>;
  education: Array<BreakdownEntity>;
  ethnicity: Array<BreakdownEntity>;
  gender: Array<BreakdownEntity>;
  geography: Array<BreakdownEntity>;
  growth_rate: Array<EntityWideDataPoint>;
  headcount: Array<EntityWideDataPoint>;
  hiring_rate: Array<EntityWideDataPoint>;
  rics: Array<BreakdownEntity>;
  role: Array<BreakdownEntity>;
  salary: Array<EntityWideDataPoint>;
  seniority: Array<BreakdownEntity>;
  skills: Array<BreakdownEntity>;
  tenure: Array<EntityWideDataPoint>;
};

export type CompositionV2Entity = {
  EntID: Scalars['Int']['input'];
  EntType: PositionsEntityKind;
};

export type CompositionV2Filters = {
  city?: InputMaybe<Array<Scalars['Int']['input']>>;
  company?: InputMaybe<Array<Scalars['Int']['input']>>;
  contingent_workers?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Array<Scalars['Int']['input']>>;
  custom_role?: InputMaybe<CustomRoleFilter>;
  custom_skill?: InputMaybe<CustomSkillFilter>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<Array<Scalars['Int']['input']>>;
  gender?: InputMaybe<Array<Scalars['Int']['input']>>;
  highest_degree?: InputMaybe<Array<Scalars['Int']['input']>>;
  industry?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  msa?: InputMaybe<Array<Scalars['Int']['input']>>;
  raw: Scalars['Boolean']['input'];
  raw_title?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  region?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k10?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k50?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k400?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_k7?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_k150?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_k1500?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_k15000?: InputMaybe<Array<Scalars['Int']['input']>>;
  seniority?: InputMaybe<Array<Scalars['Int']['input']>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CompositionV2FullSnapshotEntResp = {
  __typename?: 'CompositionV2FullSnapshotEntResp';
  metadata: EntMetadata;
  scaled: CompositionV2EntRespData;
  unscaled: CompositionV2EntRespData;
};

export type CompositionV2FullSnapshotFilters = {
  city?: InputMaybe<Array<Scalars['Int']['input']>>;
  company?: InputMaybe<Array<Scalars['Int']['input']>>;
  contingent_workers?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Array<Scalars['Int']['input']>>;
  custom_role?: InputMaybe<CustomRoleFilter>;
  custom_skill?: InputMaybe<CustomSkillFilter>;
  ethnicity?: InputMaybe<Array<Scalars['Int']['input']>>;
  gender?: InputMaybe<Array<Scalars['Int']['input']>>;
  highest_degree?: InputMaybe<Array<Scalars['Int']['input']>>;
  industry?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  msa?: InputMaybe<Array<Scalars['Int']['input']>>;
  raw_title?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  region?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k10?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k50?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k400?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_k7?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_k150?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_k1500?: InputMaybe<Array<Scalars['Int']['input']>>;
  seniority?: InputMaybe<Array<Scalars['Int']['input']>>;
  snapshot_date: Scalars['String']['input'];
  state?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CompositionV2FullSnapshotReq = {
  cache_options?: InputMaybe<ResponseCacheOptions>;
  entities: Array<CompositionV2Entity>;
  filters: CompositionV2FullSnapshotFilters;
};

export type CompositionV2FullSnapshotResp = {
  __typename?: 'CompositionV2FullSnapshotResp';
  entities: Array<CompositionV2FullSnapshotEntResp>;
  refs: CompositionV2EntRefs;
};

export type CompositionV2Req = {
  breakdown_options?: InputMaybe<CompositionV2BreakdownOptions>;
  cache_options?: InputMaybe<ResponseCacheOptions>;
  entities: Array<CompositionV2Entity>;
  filters: CompositionV2Filters;
};

export type CompositionV2Resp = {
  __typename?: 'CompositionV2Resp';
  entities: Array<CompositionV2EntResp>;
  refs: CompositionV2EntRefs;
};

export type CompositionV3BreakdownOptions = {
  education?: InputMaybe<Array<Scalars['Int']['input']>>;
  ethnicity?: InputMaybe<Array<Scalars['Int']['input']>>;
  gender?: InputMaybe<Array<Scalars['Int']['input']>>;
  geo_breakdown_level: EntKind;
  geography?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_breakdown_level: EntKind;
  role?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_breakdown_level: EntKind;
  seniority?: InputMaybe<Array<Scalars['Int']['input']>>;
  skill?: InputMaybe<Array<Scalars['Int']['input']>>;
  skill_breakdown_level: EntKind;
};

export type CompositionV3Corrections = {
  with_contingent_workers?: InputMaybe<Scalars['Boolean']['input']>;
  with_sample_weight?: InputMaybe<Scalars['Boolean']['input']>;
  with_weight?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompositionV3Ent = {
  EntID: Scalars['Int']['input'];
  EntType: EntKind;
};

export type CompositionV3Filters = {
  city?: InputMaybe<Array<Scalars['Int']['input']>>;
  company?: InputMaybe<Array<Scalars['Int']['input']>>;
  country?: InputMaybe<Array<Scalars['Int']['input']>>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<Array<Scalars['Int']['input']>>;
  gender?: InputMaybe<Array<Scalars['Int']['input']>>;
  highest_degree?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  msa?: InputMaybe<Array<Scalars['Int']['input']>>;
  raw_title?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  region?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k10?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k50?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k400?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_1?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_2?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_3?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_4?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_5?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_6?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_7?: InputMaybe<Array<Scalars['Int']['input']>>;
  seniority?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_1?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_2?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_3?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_4?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_5?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_6?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_7?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_8?: InputMaybe<Array<Scalars['Int']['input']>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CompositionV3Refs = {
  __typename?: 'CompositionV3Refs';
  months: Array<Scalars['String']['output']>;
};

export type CompositionV3Req = {
  breakdown_options: CompositionV3BreakdownOptions;
  cache_options?: InputMaybe<ResponseCacheOptions>;
  corrections: CompositionV3Corrections;
  entities: Array<CompositionV3Ent>;
  filters: CompositionV3Filters;
  force_ts_row_pipeline?: InputMaybe<Scalars['Boolean']['input']>;
  role_taxonomy: Scalars['Int']['input'];
  skill_taxonomy: Scalars['Int']['input'];
};

export type CompositionV3Resp = {
  __typename?: 'CompositionV3Resp';
  entities: Array<CompositionV3RespEnt>;
};

export type CompositionV3RespData = {
  __typename?: 'CompositionV3RespData';
  attrition_rate: Array<EntWideDataPoint>;
  education: Array<Breakdown>;
  ethnicity: Array<Breakdown>;
  gender: Array<Breakdown>;
  geography: Array<Breakdown>;
  growth_rate: Array<EntWideDataPoint>;
  headcount: Array<EntWideDataPoint>;
  hiring_rate: Array<EntWideDataPoint>;
  rics: Array<Breakdown>;
  role: Array<Breakdown>;
  salary: Array<EntWideDataPoint>;
  seniority: Array<Breakdown>;
  skills: Array<Breakdown>;
  tenure: Array<EntWideDataPoint>;
};

export type CompositionV3RespEnt = {
  __typename?: 'CompositionV3RespEnt';
  id: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
  long_name: Scalars['String']['output'];
  metrics: CompositionV3RespData;
  short_name: Scalars['String']['output'];
};

export enum ContingentWorkerVersion {
  V0 = 'V0',
  V1 = 'V1',
}

export type CreatePresetRequest = {
  default: Scalars['Boolean']['input'];
  filters: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shared: Scalars['Boolean']['input'];
  view: View;
};

export type CreateReportRequest = {
  client: Scalars['String']['input'];
  name: Scalars['String']['input'];
  reports?: InputMaybe<Array<ReportRequest>>;
};

export type CreateReportResponse = {
  __typename?: 'CreateReportResponse';
  report_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export enum CrossSectionalScalingVersion {
  V1 = 'V1',
  V1_1 = 'V1_1',
  V2 = 'V2',
  V2_1 = 'V2_1',
  V2_2 = 'V2_2',
}

export type CurrencyRefInfo = {
  __typename?: 'CurrencyRefInfo';
  code?: Maybe<Scalars['String']['output']>;
  effective_date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  record_date?: Maybe<Scalars['String']['output']>;
};

export type CustomColumn = {
  __typename?: 'CustomColumn';
  name: Scalars['String']['output'];
  step?: Maybe<Array<Maybe<CustomColumnStep>>>;
};

export type CustomColumnCase = {
  __typename?: 'CustomColumnCase';
  binary?: Maybe<BinaryOperation>;
  conditions?: Maybe<Array<Maybe<CustomColumnCondition>>>;
};

export type CustomColumnCaseInput = {
  binary?: InputMaybe<BinaryOperation>;
  conditions: Array<InputMaybe<CustomColumnConditionInput>>;
};

export type CustomColumnCondition = {
  __typename?: 'CustomColumnCondition';
  operation: OperationType;
  value: Array<Maybe<Scalars['String']['output']>>;
  variable: CustomColumnConditionVariable;
};

export type CustomColumnConditionInput = {
  operation: OperationType;
  value: Array<InputMaybe<Scalars['String']['input']>>;
  variable: CustomColumnConditionVariable;
};

export enum CustomColumnConditionVariable {
  Company = 'company',
  Country = 'country',
  DaysActive = 'days_active',
  Description = 'description',
  Enddate = 'enddate',
  Ethnicity = 'ethnicity',
  FieldOfStudy = 'field_of_study',
  Gender = 'gender',
  HighestDegree = 'highest_degree',
  MappedRole = 'mapped_role',
  MetroArea = 'metro_area',
  Month = 'month',
  Msa = 'msa',
  Prestige = 'prestige',
  Provider = 'provider',
  RatingOverall = 'rating_overall',
  Region = 'region',
  Remote = 'remote',
  RemoteSuitability = 'remote_suitability',
  ReviewCons = 'review_cons',
  ReviewPros = 'review_pros',
  RoleK7 = 'role_k7',
  RoleK10 = 'role_k10',
  RoleK25 = 'role_k25',
  RoleK50 = 'role_k50',
  RoleK100 = 'role_k100',
  RoleK150 = 'role_k150',
  RoleK250 = 'role_k250',
  RoleK300 = 'role_k300',
  RoleK500 = 'role_k500',
  RoleK1000 = 'role_k1000',
  RoleK1250 = 'role_k1250',
  RoleK1500 = 'role_k1500',
  RoleK2500 = 'role_k2500',
  RoleK5000 = 'role_k5000',
  RoleK10000 = 'role_k10000',
  RoleK15000 = 'role_k15000',
  Salary = 'salary',
  School = 'school',
  Seniority = 'seniority',
  Skill = 'skill',
  SkillExtracted = 'skill_extracted',
  SkillK15 = 'skill_k15',
  SkillK25 = 'skill_k25',
  SkillK25Extracted = 'skill_k25_extracted',
  SkillK25Predicted = 'skill_k25_predicted',
  SkillK50 = 'skill_k50',
  SkillK50Extracted = 'skill_k50_extracted',
  SkillK50Predicted = 'skill_k50_predicted',
  SkillK75 = 'skill_k75',
  SkillK75Extracted = 'skill_k75_extracted',
  SkillK75Predicted = 'skill_k75_predicted',
  SkillK150 = 'skill_k150',
  SkillK500 = 'skill_k500',
  SkillK700 = 'skill_k700',
  SkillK700Extracted = 'skill_k700_extracted',
  SkillK700Predicted = 'skill_k700_predicted',
  SkillK1500 = 'skill_k1500',
  SkillK2500 = 'skill_k2500',
  SkillK2500Extracted = 'skill_k2500_extracted',
  SkillK2500Predicted = 'skill_k2500_predicted',
  SkillK5000 = 'skill_k5000',
  SkillK15000 = 'skill_k15000',
  SkillK35000 = 'skill_k35000',
  SkillMapped = 'skill_mapped',
  SkillMappedExtracted = 'skill_mapped_extracted',
  SkillMappedPredicted = 'skill_mapped_predicted',
  SkillPredicted = 'skill_predicted',
  Soc6d = 'soc6d',
  Startdate = 'startdate',
  State = 'state',
  Title = 'title',
  TotalCompensation = 'total_compensation',
}

export type CustomColumnInput = {
  name: Scalars['String']['input'];
  step: Array<InputMaybe<CustomColumnStepInput>>;
};

export type CustomColumnStep = {
  __typename?: 'CustomColumnStep';
  case?: Maybe<CustomColumnCase>;
  then?: Maybe<Scalars['String']['output']>;
};

export type CustomColumnStepInput = {
  case?: InputMaybe<CustomColumnCaseInput>;
  then: Scalars['String']['input'];
};

export type CustomRoleFilter = {
  entities?: InputMaybe<Array<InputMaybe<CustomRoleFilterElement>>>;
  taxonomyId?: InputMaybe<CustomRoleTaxonomySelection>;
};

export type CustomRoleFilterElement = {
  id?: InputMaybe<Scalars['String']['input']>;
  levelId?: InputMaybe<Scalars['String']['input']>;
};

export type CustomRoleTaxonomySelection = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  ricsK10Id?: InputMaybe<Scalars['String']['input']>;
  ricsK50Id?: InputMaybe<Scalars['String']['input']>;
  taxonomyId?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CustomSkillEntity = {
  entity_id: Scalars['Int']['input'];
  level_id: Scalars['Int']['input'];
};

export type CustomSkillFilter = {
  entities?: InputMaybe<Array<InputMaybe<CustomSkillEntity>>>;
  from_new_refs?: InputMaybe<Scalars['Boolean']['input']>;
  taxonomy_id: Scalars['Int']['input'];
};

export enum CustomTaxonomyEnum {
  Adaptive = 'ADAPTIVE',
  Disabled = 'DISABLED',
  Generic = 'GENERIC',
  Undefined = 'UNDEFINED',
}

export enum Dataset {
  CompanyInfo = 'company_info',
  IndividualReviews = 'individual_reviews',
  PostingsIndividual = 'postings_individual',
}

export type DateFilter = {
  end_date: Scalars['String']['input'];
  start_date: Scalars['String']['input'];
};

export type DateFilterOutput = {
  __typename?: 'DateFilterOutput';
  end_date: Scalars['String']['output'];
  start_date: Scalars['String']['output'];
};

export type Deliverable = {
  company_reference?: InputMaybe<Scalars['String']['input']>;
  company_sets?: InputMaybe<Array<InputMaybe<CompanySet>>>;
  company_tickers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dashboard_companies?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  model_versions: ModelVersions;
  pipeline: Pipeline;
  pipeline_input?: InputMaybe<Scalars['String']['input']>;
  s3_delivery?: InputMaybe<S3Delivery>;
  snowflake_delivery?: InputMaybe<SnowflakeDelivery>;
};

export type DeliverableConfig = {
  __typename?: 'DeliverableConfig';
  batchTime?: Maybe<Scalars['String']['output']>;
  cacheValue?: Maybe<Scalars['String']['output']>;
  imageName?: Maybe<Scalars['String']['output']>;
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  jobUpdateInterval?: Maybe<Scalars['String']['output']>;
  namespace?: Maybe<Scalars['String']['output']>;
  reports_env?: Maybe<Scalars['String']['output']>;
  reports_image?: Maybe<Scalars['String']['output']>;
  reports_namespace?: Maybe<Scalars['String']['output']>;
  testDeliverable?: Maybe<Scalars['Boolean']['output']>;
};

export type DeliverableOutput = {
  __typename?: 'DeliverableOutput';
  company_reference?: Maybe<Scalars['String']['output']>;
  company_sets?: Maybe<Array<Maybe<CompanySet>>>;
  dashboard_companies?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  model_versions: ModelVersionsOutput;
  pipeline: PipelineOutput;
  pipeline_input?: Maybe<Scalars['String']['output']>;
  s3_delivery?: Maybe<S3DeliveryOutput>;
  snowflake_delivery?: Maybe<SnowflakeDeliveryOutput>;
};

export enum DeliveryStatus {
  Created = 'CREATED',
  Failed = 'FAILED',
  Finished = 'FINISHED',
  FinishedWithEmpty = 'FINISHED_WITH_EMPTY',
  Running = 'RUNNING',
  Scheduled = 'SCHEDULED',
  Undefined = 'UNDEFINED',
}

export enum Dimension {
  City = 'CITY',
  Company = 'COMPANY',
  Country = 'COUNTRY',
  Industry = 'INDUSTRY',
  Msa = 'MSA',
  Region = 'REGION',
  RoleK7 = 'ROLE_K7',
  RoleK150 = 'ROLE_K150',
  RoleK1500 = 'ROLE_K1500',
  State = 'STATE',
}

export enum Dimension1 {
  Company = 'company',
  Geography = 'geography',
  Role = 'role',
}

export enum EntKind {
  City = 'CITY',
  Company = 'COMPANY',
  Country = 'COUNTRY',
  Msa = 'MSA',
  Region = 'REGION',
  RicsK10 = 'RICS_K10',
  RicsK50 = 'RICS_K50',
  RicsK400 = 'RICS_K400',
  RoleLvl_1 = 'ROLE_LVL_1',
  RoleLvl_2 = 'ROLE_LVL_2',
  RoleLvl_3 = 'ROLE_LVL_3',
  RoleLvl_4 = 'ROLE_LVL_4',
  RoleLvl_5 = 'ROLE_LVL_5',
  RoleLvl_6 = 'ROLE_LVL_6',
  RoleLvl_7 = 'ROLE_LVL_7',
  SkillLvl_1 = 'SKILL_LVL_1',
  SkillLvl_2 = 'SKILL_LVL_2',
  SkillLvl_3 = 'SKILL_LVL_3',
  SkillLvl_4 = 'SKILL_LVL_4',
  SkillLvl_5 = 'SKILL_LVL_5',
  SkillLvl_6 = 'SKILL_LVL_6',
  SkillLvl_7 = 'SKILL_LVL_7',
  SkillLvl_8 = 'SKILL_LVL_8',
  State = 'STATE',
}

export type EntMetadata = {
  __typename?: 'EntMetadata';
  id: Scalars['Int']['output'];
  long_name: Scalars['String']['output'];
  short_name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type EntWideDataPoint = {
  __typename?: 'EntWideDataPoint';
  id: Scalars['Int']['output'];
  val: Scalars['Float']['output'];
};

export type EntityCompetitors = {
  __typename?: 'EntityCompetitors';
  closeness_score: Scalars['Float']['output'];
  metadata?: Maybe<Metadata>;
};

export type EntityFilters = {
  company?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  job_category?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role_k150?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role_k1500?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  top_competitors?: InputMaybe<Scalars['Int']['input']>;
};

export type EntityInfo = {
  __typename?: 'EntityInfo';
  company_info?: Maybe<ScreenerRespCompanyInfo>;
};

export type EntityInput = {
  type: EntityTypeEnum;
  values: Array<Scalars['String']['input']>;
};

export type EntityOutput = {
  __typename?: 'EntityOutput';
  id: Scalars['String']['output'];
  type: EntityTypeEnum;
  values: Array<Scalars['String']['output']>;
};

export type EntityResponse = {
  __typename?: 'EntityResponse';
  competitors?: Maybe<Array<Maybe<EntityCompetitors>>>;
  summary?: Maybe<EntitySummary>;
};

export type EntitySummary = {
  __typename?: 'EntitySummary';
  commonTitles?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  founded?: Maybe<Scalars['String']['output']>;
  headquarters?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum EntityTypeEnum {
  Company = 'company',
  CompanyOrgchart = 'company_orgchart',
  CompanyRepvue = 'company_repvue',
  Country = 'country',
  CustomSkill = 'custom_skill',
  CustomTaxonomy = 'custom_taxonomy',
  CustomTaxonomyVersion = 'custom_taxonomy_version',
  Industry = 'industry',
  JobCategory = 'job_category',
  MetroArea = 'metro_area',
  Region = 'region',
  RicsK10 = 'rics_k10',
  RicsK50 = 'rics_k50',
  RicsK400 = 'rics_k400',
  RoleK50 = 'role_k50',
  RoleK150 = 'role_k150',
  Seniority = 'seniority',
  SkillK25 = 'skill_k25',
  SkillK50 = 'skill_k50',
  SkillK75 = 'skill_k75',
  SkillK700 = 'skill_k700',
  SkillK2500 = 'skill_k2500',
  SkillMapped = 'skill_mapped',
  SkillTaxonomyName = 'skill_taxonomy_name',
  SkillTaxonomyVersion = 'skill_taxonomy_version',
  State = 'state',
}

export type EntityV2Competitors = {
  __typename?: 'EntityV2Competitors';
  closeness: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  longName: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export type EntityV2Req = {
  entID: Scalars['Int']['input'];
  entType: EntityV2Type;
  numCompetitors?: InputMaybe<Scalars['Int']['input']>;
};

export type EntityV2Resp = {
  __typename?: 'EntityV2Resp';
  competitors?: Maybe<Array<Maybe<EntityV2Competitors>>>;
  entity?: Maybe<EntitySummary>;
};

export enum EntityV2Type {
  Company = 'COMPANY',
  RoleK7 = 'ROLE_K7',
  RoleK150 = 'ROLE_K150',
  RoleK1500 = 'ROLE_K1500',
  RoleK15000 = 'ROLE_K15000',
}

export type EntityWideDataPoint = {
  __typename?: 'EntityWideDataPoint';
  id: Scalars['Int']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export enum EthnicityVersion {
  V1 = 'V1',
  V2 = 'V2',
}

export enum ExcludeRegionalaggregatorSingletonsVersion {
  V0 = 'V0',
  V1 = 'V1',
}

export type ExprAndNode = {
  children: Array<ExprNode>;
};

export type ExprNode = {
  and?: InputMaybe<ExprAndNode>;
  not?: InputMaybe<ExprNotNode>;
  or?: InputMaybe<ExprOrNode>;
  rng?: InputMaybe<ExprRangeNode>;
  txt?: InputMaybe<ExprTextNode>;
  val?: InputMaybe<ExprValueNode>;
};

export type ExprNotNode = {
  child: ExprNode;
};

export type ExprOrNode = {
  children: Array<ExprNode>;
};

export type ExprRangeNode = {
  pos_attribute?: InputMaybe<ExprRangeNodePositionAttribute>;
  user_attribute?: InputMaybe<ExprRangeNodeUserAttribute>;
};

export type ExprRangeNodePositionAttribute = {
  curr: Scalars['Boolean']['input'];
  end: Scalars['Int']['input'];
  kind: PositionRangeKind;
  start: Scalars['Int']['input'];
};

export type ExprRangeNodeUserAttribute = {
  end: Scalars['Int']['input'];
  kind: UserRangeKind;
  start: Scalars['Int']['input'];
};

export type ExprTextNode = {
  pos_attribute?: InputMaybe<ExprTextNodePositionAttribute>;
  user_attribute?: InputMaybe<ExprTextNodeUserAttribute>;
};

export type ExprTextNodePositionAttribute = {
  curr: Scalars['Boolean']['input'];
  kind: PositionTextKind;
  text: Scalars['String']['input'];
};

export type ExprTextNodeUserAttribute = {
  kind: UserExprTextKind;
  text: Scalars['String']['input'];
};

export type ExprValueNode = {
  pos_attribute?: InputMaybe<ExprValueNodePositionAttribute>;
  pos_role?: InputMaybe<ExprValueNodePositionRole>;
  user_attribute?: InputMaybe<ExprValueNodeUserAttribute>;
  user_skill?: InputMaybe<ExprValueNodeUserSkill>;
};

export type ExprValueNodePositionAttribute = {
  curr: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  kind: PositionCategoryKind;
};

export type ExprValueNodePositionRole = {
  curr: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  level: Scalars['Int']['input'];
  taxonomy_id: Scalars['Int']['input'];
};

export type ExprValueNodeUserAttribute = {
  id: Scalars['Int']['input'];
  kind: UserCategoryKind;
};

export type ExprValueNodeUserSkill = {
  id: Scalars['Int']['input'];
  level: Scalars['Int']['input'];
  taxonomy_id: Scalars['Int']['input'];
};

export type FilterSalary = {
  current: Scalars['Boolean']['input'];
  end_val: Scalars['Float']['input'];
  non_current: Scalars['Boolean']['input'];
  start_val: Scalars['Float']['input'];
};

export type FilterWithCurrent = {
  current: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};

export type FilterWithCurrentAndTag = {
  current: Scalars['Boolean']['input'];
  dim: TalentDiscoveryV2Tags;
  id: Scalars['Int']['input'];
};

export type FilterWithTag = {
  dim: TalentDiscoveryV2Tags;
  id: Scalars['Int']['input'];
};

export type FlowsCounts = {
  __typename?: 'FlowsCounts';
  count: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  long_name: Scalars['String']['output'];
  share: Scalars['Float']['output'];
  short_name: Scalars['String']['output'];
};

export type GeoRefInfo = {
  __typename?: 'GeoRefInfo';
  count: Scalars['Int']['output'];
  country?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  dataUnavailableIn?: Maybe<ManifestKind>;
  id?: Maybe<Scalars['ID']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  metro_area?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  parentId?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  region?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  shortName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export enum GeographyTaxonomy {
  RegionCountryMsaCity = 'REGION_COUNTRY_MSA_CITY',
  RegionCountryStateCity = 'REGION_COUNTRY_STATE_CITY',
  RegionCountryStateCountyZip = 'REGION_COUNTRY_STATE_COUNTY_ZIP',
}

export enum HeadcountVersion {
  V1 = 'V1',
  V2 = 'V2',
}

export type IdNamePair = {
  __typename?: 'IdNamePair';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type IdentityInput = {
  uuid: Scalars['UUID']['input'];
};

export type IndexValues = {
  __typename?: 'IndexValues';
  endMonth?: Maybe<Scalars['String']['output']>;
  endMonthIndex?: Maybe<Scalars['Int']['output']>;
  endWeek?: Maybe<Scalars['String']['output']>;
  endWeekIndex?: Maybe<Scalars['Int']['output']>;
  maxWeek?: Maybe<Scalars['String']['output']>;
  maxWeekIndex?: Maybe<Scalars['Int']['output']>;
  startMonth?: Maybe<Scalars['String']['output']>;
  startMonthIndex?: Maybe<Scalars['Int']['output']>;
  startWeek?: Maybe<Scalars['String']['output']>;
  startWeekIndex?: Maybe<Scalars['Int']['output']>;
};

export type IndividualUserConfiguration = {
  current?: InputMaybe<Scalars['Boolean']['input']>;
  full_history?: InputMaybe<Scalars['Boolean']['input']>;
  previous?: InputMaybe<Scalars['Boolean']['input']>;
  repeat_user_columns?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndividualUserConfigurationOutput = {
  __typename?: 'IndividualUserConfigurationOutput';
  current?: Maybe<Scalars['Boolean']['output']>;
  full_history?: Maybe<Scalars['Boolean']['output']>;
  previous?: Maybe<Scalars['Boolean']['output']>;
  repeat_user_columns?: Maybe<Scalars['Boolean']['output']>;
};

export type JobEmbedding = {
  __typename?: 'JobEmbedding';
  confidence: Scalars['Float']['output'];
  cosine: Scalars['Float']['output'];
  expertise: Scalars['String']['output'];
  job_description: Scalars['String']['output'];
  mapped_role: Scalars['String']['output'];
  mapped_role_distance: Scalars['Float']['output'];
  mapped_role_id: Scalars['Int']['output'];
  norm: Scalars['Float']['output'];
  role_k7: Scalars['String']['output'];
  role_k45: Scalars['String']['output'];
  role_k50: Scalars['String']['output'];
  role_k55: Scalars['String']['output'];
  role_k60: Scalars['String']['output'];
  role_k65: Scalars['String']['output'];
  role_k70: Scalars['String']['output'];
  role_k75: Scalars['String']['output'];
  role_k80: Scalars['String']['output'];
  role_k85: Scalars['String']['output'];
  role_k90: Scalars['String']['output'];
  role_k95: Scalars['String']['output'];
  role_k100: Scalars['String']['output'];
  role_k150: Scalars['String']['output'];
  role_k150_id: Scalars['Int']['output'];
  role_k200: Scalars['String']['output'];
  role_k250: Scalars['String']['output'];
  role_k300: Scalars['String']['output'];
  role_k350: Scalars['String']['output'];
  role_k400: Scalars['String']['output'];
  role_k450: Scalars['String']['output'];
  role_k500: Scalars['String']['output'];
  role_k600: Scalars['String']['output'];
  role_k700: Scalars['String']['output'];
  role_k800: Scalars['String']['output'];
  role_k900: Scalars['String']['output'];
  role_k1000: Scalars['String']['output'];
  role_k1250: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type JobEmbeddingReq = {
  jobs: Array<JobEntry>;
};

export type JobEmbeddingResp = {
  __typename?: 'JobEmbeddingResp';
  jobs: Array<JobEmbedding>;
};

export type JobEntry = {
  expertise?: InputMaybe<Scalars['String']['input']>;
  job_description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type KeyValue = {
  key?: InputMaybe<MetadataKey>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type KeyValueResp = {
  __typename?: 'KeyValueResp';
  key?: Maybe<MetadataKey>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ListApiKeyResponse = {
  __typename?: 'ListApiKeyResponse';
  api_keys: Array<ApiKeyMetadata>;
};

export enum LocationVersion {
  V1 = 'V1',
  V2 = 'V2',
  V3 = 'V3',
}

export type MsaRefInfoInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ManifestKind = {
  __typename?: 'ManifestKind';
  position?: Maybe<Scalars['Boolean']['output']>;
  posting?: Maybe<Scalars['Boolean']['output']>;
  sentiment?: Maybe<Scalars['Boolean']['output']>;
  sentimentReview?: Maybe<Scalars['Boolean']['output']>;
  transition?: Maybe<Scalars['Boolean']['output']>;
};

export type ManifestUsage = {
  __typename?: 'ManifestUsage';
  current?: Maybe<ManifestValues>;
  last?: Maybe<ManifestValues>;
  latest?: Maybe<ManifestValues>;
  must_keep?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  superset?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ManifestValues = {
  __typename?: 'ManifestValues';
  competitorsV2?: Maybe<Scalars['String']['output']>;
  positionsCountsV2?: Maybe<Scalars['String']['output']>;
  positionsV2?: Maybe<Scalars['String']['output']>;
  positionsV3?: Maybe<Scalars['String']['output']>;
  postingDiscovery?: Maybe<Scalars['String']['output']>;
  postingsV2?: Maybe<Scalars['String']['output']>;
  postingsV3?: Maybe<Scalars['String']['output']>;
  refs?: Maybe<Scalars['String']['output']>;
  screenerCompany?: Maybe<Scalars['String']['output']>;
  screenerMSA?: Maybe<Scalars['String']['output']>;
  screenerMappedRole?: Maybe<Scalars['String']['output']>;
  sentimentV2?: Maybe<Scalars['String']['output']>;
  sentimentV3?: Maybe<Scalars['String']['output']>;
  talentDiscoveryContacts?: Maybe<Scalars['String']['output']>;
  transitionsInflowsV2?: Maybe<Scalars['String']['output']>;
  transitionsOutflowsV2?: Maybe<Scalars['String']['output']>;
  transitionsV3?: Maybe<Scalars['String']['output']>;
  usersSearch?: Maybe<Scalars['String']['output']>;
  usersSearchV2?: Maybe<Scalars['String']['output']>;
  usersSearchV3?: Maybe<Scalars['String']['output']>;
};

export type ManifestVersion = {
  __typename?: 'ManifestVersion';
  date?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export enum MapCoordsGranularity {
  Country = 'COUNTRY',
  Msa = 'MSA',
  Region = 'REGION',
}

export type MapCoordsItem = {
  __typename?: 'MapCoordsItem';
  id: Scalars['Int']['output'];
  lat: Scalars['Float']['output'];
  lon: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type MapCoordsReq = {
  country?: InputMaybe<Array<MapCoordsReqId>>;
  msa?: InputMaybe<Array<MapCoordsReqId>>;
  region?: InputMaybe<Array<MapCoordsReqId>>;
};

export type MapCoordsReqId = {
  granularity: MapCoordsGranularity;
  id: Scalars['Int']['input'];
};

export type MapCoordsResp = {
  __typename?: 'MapCoordsResp';
  country?: Maybe<Array<Array<MapCoordsItem>>>;
  msa?: Maybe<Array<Array<MapCoordsItem>>>;
  region?: Maybe<Array<Array<MapCoordsItem>>>;
};

export enum MapDataKind {
  City = 'CITY',
  Country = 'COUNTRY',
  Msa = 'MSA',
  State = 'STATE',
}

export type Metadata = {
  __typename?: 'Metadata';
  id?: Maybe<Scalars['Int']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  metadata_type?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export enum MetadataKey {
  CreatedAt = 'created_at',
  CurrencyCode = 'currency_code',
  ExpirationDate = 'expiration_date',
  LimitedCompanies = 'limited_companies',
  OidcProvider = 'oidc_provider',
  OidcSubject = 'oidc_subject',
  RequestsPerMonth = 'requests_per_month',
  RequestsPerSecond = 'requests_per_second',
  SourcewhaleKey = 'sourcewhale_key',
  StepsCompleted = 'steps_completed',
  TermsAccepted = 'terms_accepted',
  TourCompleted = 'tour_completed',
  TrialType = 'trial_type',
  TrialUserAgreementAccepted = 'trial_user_agreement_accepted',
  UpdatedAt = 'updated_at',
}

export type ModelVersions = {
  company_mapper_version?: InputMaybe<CompanyMapperVersion>;
  contingent_worker_version?: InputMaybe<ContingentWorkerVersion>;
  cross_sectional_scaling_version?: InputMaybe<CrossSectionalScalingVersion>;
  ethnicity_version?: InputMaybe<EthnicityVersion>;
  exclude_regionalaggregator_singletons_version?: InputMaybe<ExcludeRegionalaggregatorSingletonsVersion>;
  headcount_version?: InputMaybe<HeadcountVersion>;
  job_taxonomy_id?: InputMaybe<Scalars['Int']['input']>;
  job_taxonomy_version?: InputMaybe<Scalars['String']['input']>;
  location_version?: InputMaybe<LocationVersion>;
  posting_scaling_version?: InputMaybe<PostingScalingVersion>;
  prestige_version?: InputMaybe<PrestigeVersion>;
  remove_bad_users?: InputMaybe<Scalars['Boolean']['input']>;
  remove_bad_users_version?: InputMaybe<BadUsersVersion>;
  salary_version?: InputMaybe<SalaryVersion>;
  seniority_version?: InputMaybe<SeniorityVersion>;
  sentiment_version?: InputMaybe<SentimentVersion>;
  skill_taxonomy_id?: InputMaybe<Scalars['Int']['input']>;
  skill_taxonomy_version?: InputMaybe<Scalars['String']['input']>;
  timescaling_version?: InputMaybe<TimescalingVersion>;
  weight_table?: InputMaybe<WeightTable>;
};

export type ModelVersionsOutput = {
  __typename?: 'ModelVersionsOutput';
  company_mapper_version?: Maybe<CompanyMapperVersion>;
  contingent_worker_version?: Maybe<ContingentWorkerVersion>;
  cross_sectional_scaling_version?: Maybe<CrossSectionalScalingVersion>;
  ethnicity_version?: Maybe<EthnicityVersion>;
  exclude_regionalaggregator_singletons_version?: Maybe<ExcludeRegionalaggregatorSingletonsVersion>;
  headcount_version?: Maybe<HeadcountVersion>;
  job_taxonomy_id?: Maybe<Scalars['Int']['output']>;
  job_taxonomy_version?: Maybe<Scalars['String']['output']>;
  location_version?: Maybe<LocationVersion>;
  posting_scaling_version?: Maybe<PostingScalingVersion>;
  prestige_version?: Maybe<PrestigeVersion>;
  remove_bad_users?: Maybe<Scalars['Boolean']['output']>;
  remove_bad_users_version?: Maybe<BadUsersVersion>;
  salary_version?: Maybe<SalaryVersion>;
  seniority_version?: Maybe<SeniorityVersion>;
  sentiment_version?: Maybe<SentimentVersion>;
  skill_taxonomy_id?: Maybe<Scalars['Int']['output']>;
  skill_taxonomy_version?: Maybe<Scalars['String']['output']>;
  timescaling_version?: Maybe<TimescalingVersion>;
  weight_table?: Maybe<WeightTable>;
};

export type ModelVersionsType = {
  __typename?: 'ModelVersionsType';
  company_mapper_version?: Maybe<CompanyMapperVersion>;
  contingent_worker_version?: Maybe<ContingentWorkerVersion>;
  cross_sectional_scaling_version?: Maybe<CrossSectionalScalingVersion>;
  ethnicity_version?: Maybe<EthnicityVersion>;
  exclude_regionalaggregator_singletons_version?: Maybe<ExcludeRegionalaggregatorSingletonsVersion>;
  headcount_version?: Maybe<HeadcountVersion>;
  job_taxonomy_id?: Maybe<Scalars['Int']['output']>;
  job_taxonomy_version?: Maybe<Scalars['String']['output']>;
  location_version?: Maybe<LocationVersion>;
  posting_scaling_version?: Maybe<PostingScalingVersion>;
  prestige_version?: Maybe<PrestigeVersion>;
  remove_bad_users?: Maybe<Scalars['Boolean']['output']>;
  remove_bad_users_version?: Maybe<BadUsersVersion>;
  salary_version?: Maybe<SalaryVersion>;
  seniority_version?: Maybe<SeniorityVersion>;
  sentiment_version?: Maybe<SentimentVersion>;
  skill_taxonomy_id?: Maybe<Scalars['Int']['output']>;
  skill_taxonomy_version?: Maybe<Scalars['String']['output']>;
  timescaling_version?: Maybe<TimescalingVersion>;
  weight_table?: Maybe<WeightTable>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createClientGroup?: Maybe<Client>;
  createDeliverables?: Maybe<ClientDeliverableResponse>;
  createPreset?: Maybe<Preset>;
  createReports?: Maybe<CreateReportResponse>;
  createUser: User;
  deletePipelineConfiguration?: Maybe<Scalars['Boolean']['output']>;
  deletePreset?: Maybe<Scalars['Boolean']['output']>;
  deleteRefValue?: Maybe<Scalars['Boolean']['output']>;
  deleteReport?: Maybe<Scalars['Boolean']['output']>;
  deleteResume: Scalars['Boolean']['output'];
  deleteUser?: Maybe<Scalars['Boolean']['output']>;
  refreshReport?: Maybe<Scalars['Boolean']['output']>;
  registerApiKey: RegisterApiKeyResponse;
  removeApiKey?: Maybe<Scalars['Boolean']['output']>;
  retryDeliverables?: Maybe<ClientDeliverableResponse>;
  savePipelineClientConfiguration?: Maybe<PipelineClientConfig>;
  savePipelineConfiguration?: Maybe<PipelineConfig>;
  saveResume: Resume;
  selectionListReload?: Maybe<Scalars['Boolean']['output']>;
  setReportsValidation: ReportsValidationResponse;
  setUserClientGroup?: Maybe<Scalars['Boolean']['output']>;
  updateClientGroup?: Maybe<Client>;
  updateDeliverableConfig?: Maybe<DeliverableConfig>;
  updateIndex?: Maybe<IndexValues>;
  updateManifests?: Maybe<Scalars['Boolean']['output']>;
  updatePreset?: Maybe<Preset>;
  updateStatusDeliverables?: Maybe<ClientDeliverableResponse>;
  updateUser?: Maybe<User>;
  useManifests?: Maybe<ManifestValues>;
};

export type MutationCreateClientGroupArgs = {
  input?: InputMaybe<ClientRequest>;
};

export type MutationCreateDeliverablesArgs = {
  input?: InputMaybe<ClientDeliverableInput>;
};

export type MutationCreatePresetArgs = {
  input: CreatePresetRequest;
};

export type MutationCreateReportsArgs = {
  input?: InputMaybe<CreateReportRequest>;
};

export type MutationCreateUserArgs = {
  input: UserRequest;
};

export type MutationDeletePipelineConfigurationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDeletePresetArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteRefValueArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  tableName: Scalars['String']['input'];
};

export type MutationDeleteReportArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteResumeArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteUserArgs = {
  input: Scalars['String']['input'];
};

export type MutationRefreshReportArgs = {
  id: Scalars['String']['input'];
};

export type MutationRegisterApiKeyArgs = {
  input: RegisterApiKeyInput;
};

export type MutationRemoveApiKeyArgs = {
  input: RemoveApiKeyInput;
};

export type MutationRetryDeliverablesArgs = {
  input?: InputMaybe<RetryDeliverableInput>;
};

export type MutationSavePipelineClientConfigurationArgs = {
  configuration?: InputMaybe<PipelineClientConfigInput>;
};

export type MutationSavePipelineConfigurationArgs = {
  configuration?: InputMaybe<PipelineConfigInput>;
};

export type MutationSaveResumeArgs = {
  input: ResumeRequest;
};

export type MutationSetReportsValidationArgs = {
  input: SetReportsValidationRequest;
};

export type MutationSetUserClientGroupArgs = {
  input: SetUserClientGroupRequest;
};

export type MutationUpdateClientGroupArgs = {
  input?: InputMaybe<ClientRequest>;
};

export type MutationUpdateDeliverableConfigArgs = {
  input?: InputMaybe<UpdateDeliverableConfigRequest>;
};

export type MutationUpdateIndexArgs = {
  input?: InputMaybe<UpdateIndexRequest>;
};

export type MutationUpdateManifestsArgs = {
  input?: InputMaybe<UpdateManifestValues>;
};

export type MutationUpdatePresetArgs = {
  input: UpdatePresetRequest;
};

export type MutationUpdateStatusDeliverablesArgs = {
  input?: InputMaybe<UpdateStatusDeliverableInput>;
};

export type MutationUpdateUserArgs = {
  input: UserRequest;
};

export type MutationUseManifestsArgs = {
  version: Scalars['String']['input'];
};

export type NameRecommendation = {
  __typename?: 'NameRecommendation';
  user_name: Scalars['String']['output'];
};

export type OidcConfig = {
  __typename?: 'OidcConfig';
  client_group: Scalars['String']['output'];
  oidc_client_id: Scalars['String']['output'];
  well_known_provider_url: Scalars['String']['output'];
};

export type OidcConfigInput = {
  oidc_client_id: Scalars['String']['input'];
  well_known_provider_url: Scalars['String']['input'];
};

export enum OperationType {
  ContainsAll = 'CONTAINS_ALL',
  ContainsAllCaseSensitive = 'CONTAINS_ALL_CASE_SENSITIVE',
  ContainsAllExact = 'CONTAINS_ALL_EXACT',
  ContainsAnyOfCaseSensitive = 'CONTAINS_ANY_OF_CASE_SENSITIVE',
  ContainsAtLeastOne = 'CONTAINS_AT_LEAST_ONE',
  ContainsAtLeastOneCaseSensitive = 'CONTAINS_AT_LEAST_ONE_CASE_SENSITIVE',
  ContainsAtLeastOneExact = 'CONTAINS_AT_LEAST_ONE_EXACT',
  DoesNotContainAll = 'DOES_NOT_CONTAIN_ALL',
  DoesNotContainAllCaseSensitive = 'DOES_NOT_CONTAIN_ALL_CASE_SENSITIVE',
  DoesNotContainAllExact = 'DOES_NOT_CONTAIN_ALL_EXACT',
  DoesNotContainAnyOfCaseSensitive = 'DOES_NOT_CONTAIN_ANY_OF_CASE_SENSITIVE',
  DoesNotContainAtLeastOne = 'DOES_NOT_CONTAIN_AT_LEAST_ONE',
  DoesNotContainAtLeastOneCaseSensitive = 'DOES_NOT_CONTAIN_AT_LEAST_ONE_CASE_SENSITIVE',
  DoesNotContainAtLeastOneExact = 'DOES_NOT_CONTAIN_AT_LEAST_ONE_EXACT',
  DoesNotEqual = 'DOES_NOT_EQUAL',
  EqualTo = 'EQUAL_TO',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  InBetween = 'IN_BETWEEN',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
}

export type PayV2EntResp = {
  __typename?: 'PayV2EntResp';
  metadata: EntMetadata;
  metrics: PayV2EntRespData;
};

export type PayV2EntRespData = {
  __typename?: 'PayV2EntRespData';
  histogram: PayV2EntRespHistogram;
  overtime: PayV2EntRespOvertime;
  top_companies: Array<PayV2EntRespHistogram>;
  top_geos: Array<PayV2EntRespHistogram>;
  top_roles: Array<PayV2EntRespHistogram>;
};

export type PayV2EntRespHistogram = {
  __typename?: 'PayV2EntRespHistogram';
  base: Array<Scalars['Float']['output']>;
  hourly: Array<Scalars['Float']['output']>;
  index: Scalars['Int']['output'];
  longName: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  total: Array<Scalars['Float']['output']>;
};

export type PayV2EntRespOvertime = {
  __typename?: 'PayV2EntRespOvertime';
  SalaryBase: Array<Scalars['Float']['output']>;
  SalaryHourly: Array<Scalars['Float']['output']>;
  SalaryTotal: Array<Scalars['Float']['output']>;
  counts: Array<Scalars['Float']['output']>;
};

export type PayV2Entity = {
  EntID: Scalars['Int']['input'];
  EntType: PositionsEntityKind;
};

export type PayV2Options = {
  geo_breakdown_state_over_msa?: InputMaybe<Scalars['Boolean']['input']>;
  required_top_companies_length?: InputMaybe<Scalars['Int']['input']>;
  required_top_geos_length?: InputMaybe<Scalars['Int']['input']>;
  required_top_roles_length?: InputMaybe<Scalars['Int']['input']>;
};

export type PayV2Req = {
  cache_options?: InputMaybe<ResponseCacheOptions>;
  entities: Array<PayV2Entity>;
  filters: CompositionV2Filters;
  options?: InputMaybe<PayV2Options>;
};

export type PayV2Resp = {
  __typename?: 'PayV2Resp';
  entities: Array<PayV2EntResp>;
  refs: CompositionV2EntRefs;
};

export type Pipeline = {
  aggregations?: InputMaybe<Array<InputMaybe<PipelineAggregationInput>>>;
  columns?: InputMaybe<Array<InputMaybe<PipelineColumnType>>>;
  company_info_configuration?: InputMaybe<CompanyInfoConfiguration>;
  custom_columns?: InputMaybe<Array<InputMaybe<CustomColumnInput>>>;
  date_filter?: InputMaybe<DateFilter>;
  end_at_count_long?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Array<InputMaybe<PipelineFilterInput>>>;
  groups?: InputMaybe<Array<InputMaybe<PipelineGroupInput>>>;
  individual_user_configuration?: InputMaybe<IndividualUserConfiguration>;
  pipeline_type: PipelineType;
  posting_configuration?: InputMaybe<PostingConfiguration>;
  sorts?: InputMaybe<Array<InputMaybe<PipelineSortInput>>>;
  source?: InputMaybe<PostingSource>;
  transition_configuration?: InputMaybe<TransitionConfiguration>;
};

export type PipelineAggregationInput = {
  column: PipelineColumnType;
  type: PipelineAggregationType;
};

export enum PipelineAggregationType {
  Average = 'average',
  Count = 'count',
  Max = 'max',
  Min = 'min',
  Sum = 'sum',
}

export type PipelineClientConfig = {
  __typename?: 'PipelineClientConfig';
  additional_permissions?: Maybe<AdditionalPermissions>;
  client_group?: Maybe<Scalars['String']['output']>;
  pipeline_type?: Maybe<Array<Maybe<PipelineType>>>;
  posting_source?: Maybe<Array<Maybe<PostingSource>>>;
  s3_location?: Maybe<S3DeliveryOutput>;
  snowflake_location?: Maybe<SnowflakeDeliveryOutput>;
};

export type PipelineClientConfigInput = {
  additional_permissions?: InputMaybe<AdditionalPermissionsInput>;
  client_group?: InputMaybe<Scalars['String']['input']>;
  pipeline_type?: InputMaybe<Array<InputMaybe<PipelineType>>>;
  posting_source?: InputMaybe<Array<InputMaybe<PostingSource>>>;
  s3_location?: InputMaybe<S3Delivery>;
  snowflake_location?: InputMaybe<SnowflakeDelivery>;
};

export enum PipelineColumnType {
  ActivePosting = 'active_posting',
  ActiveSalaryAvg = 'active_salary_avg',
  ActiveSalaryCount = 'active_salary_count',
  ApiProb = 'api_prob',
  Attrition = 'attrition',
  BlackProb = 'black_prob',
  Campus = 'campus',
  CareerAdvancementSentiment = 'career_advancement_sentiment',
  Cik = 'cik',
  City = 'city',
  Company = 'company',
  CompanyAndDivisionSizeSentiment = 'company_and_division_size_sentiment',
  CompanyCleaned = 'company_cleaned',
  CompanyId = 'company_id',
  CompanyName = 'company_name',
  CompanyPriname = 'company_priname',
  CompanyRaw = 'company_raw',
  Companyurl = 'companyurl',
  CompensationSentiment = 'compensation_sentiment',
  Count = 'count',
  Country = 'country',
  CoworkersSentiment = 'coworkers_sentiment',
  CultureSentiment = 'culture_sentiment',
  Cusip = 'cusip',
  Degree = 'degree',
  DegreeRaw = 'degree_raw',
  Description = 'description',
  DiversityAndInclusionSentiment = 'diversity_and_inclusion_sentiment',
  Duration = 'duration',
  EducationEnddate = 'education_enddate',
  EducationRn = 'education_rn',
  EducationStartdate = 'education_startdate',
  EndMeanSampledSalary = 'end_mean_sampled_salary',
  Enddate = 'enddate',
  Ethnicity = 'ethnicity',
  EthnicityPredicted = 'ethnicity_predicted',
  Exchange = 'exchange',
  ExpectedHires = 'expected_hires',
  ExternalInflow = 'external_inflow',
  ExternalOutflow = 'external_outflow',
  FProb = 'f_prob',
  FactsetEntityId = 'factset_entity_id',
  Field = 'field',
  FieldRaw = 'field_raw',
  FillingTimeAvg = 'filling_time_avg',
  FinalParentFactsetId = 'final_parent_factset_id',
  FinalParentFactsetName = 'final_parent_factset_name',
  Firstname = 'firstname',
  FlightRiskLabel = 'flight_risk_label',
  FlightRiskScore = 'flight_risk_score',
  Fullname = 'fullname',
  Gender = 'gender',
  Gvkey = 'gvkey',
  HighestDegree = 'highest_degree',
  Hiring = 'hiring',
  HispanicProb = 'hispanic_prob',
  Inflation = 'inflation',
  Inflow = 'inflow',
  InnovativeTechnologySentiment = 'innovative_technology_sentiment',
  Isin = 'isin',
  JobCategory = 'job_category',
  JobId = 'job_id',
  JobTitleRaw = 'job_title_raw',
  Jobtitle = 'jobtitle',
  JobtitleRaw = 'jobtitle_raw',
  JobtitleTranslated = 'jobtitle_translated',
  Lastname = 'lastname',
  LayoffDate = 'layoff_date',
  Lei = 'lei',
  LinkedinUrl = 'linkedin_url',
  Location = 'location',
  LocationRaw = 'location_raw',
  MProb = 'm_prob',
  ManagementSentiment = 'management_sentiment',
  MappedRole = 'mapped_role',
  MentorshipSentiment = 'mentorship_sentiment',
  MetroArea = 'metro_area',
  Msa = 'msa',
  MultipleProb = 'multiple_prob',
  Naics = 'naics',
  Naics2d = 'naics2d',
  Naics3d = 'naics3d',
  NaicsDesc = 'naics_desc',
  NativeProb = 'native_prob',
  NewPosting = 'new_posting',
  NewSalaryAvg = 'new_salary_avg',
  NewSalaryCount = 'new_salary_count',
  NumEmployees = 'num_employees',
  NumReviews = 'num_reviews',
  Numconnections = 'numconnections',
  OnboardingSentiment = 'onboarding_sentiment',
  OnetCode = 'onet_code',
  OnetTitle = 'onet_title',
  Outflow = 'outflow',
  PerksAndBenefitsSentiment = 'perks_and_benefits_sentiment',
  PersonalEmail = 'personal_email',
  PhoneNumber = 'phone_number',
  PositionId = 'position_id',
  PostDate = 'post_date',
  Prestige = 'prestige',
  PrestigeWeight = 'prestige_weight',
  ProfileLinkedinUrl = 'profile_linkedin_url',
  ProfileSummary = 'profile_summary',
  ProfileTitle = 'profile_title',
  RatingBusinessOutlook = 'rating_business_outlook',
  RatingCareerOpportunities = 'rating_career_opportunities',
  RatingCeo = 'rating_ceo',
  RatingCompensationAndBenefits = 'rating_compensation_and_benefits',
  RatingCultureAndValues = 'rating_culture_and_values',
  RatingDiversityAndInclusion = 'rating_diversity_and_inclusion',
  RatingOverall = 'rating_overall',
  RatingRecommendToFriend = 'rating_recommend_to_friend',
  RatingSeniorLeadership = 'rating_senior_leadership',
  RatingWorkLifeBalance = 'rating_work_life_balance',
  RawCount = 'raw_count',
  RawInflow = 'raw_inflow',
  RawOutflow = 'raw_outflow',
  Rcid = 'rcid',
  Recommenders = 'recommenders',
  Region = 'region',
  RemoteSuitability = 'remote_suitability',
  RemoteWorkSentiment = 'remote_work_sentiment',
  RemoveDate = 'remove_date',
  RemovedPosting = 'removed_posting',
  RemovedSalaryAvg = 'removed_salary_avg',
  RemovedSalaryCount = 'removed_salary_count',
  ReviewAdvice = 'review_advice',
  ReviewCons = 'review_cons',
  ReviewCountHelpful = 'review_count_helpful',
  ReviewCountNotHelpful = 'review_count_not_helpful',
  ReviewDateTime = 'review_date_time',
  ReviewId = 'review_id',
  ReviewIscovid19 = 'review_iscovid19',
  ReviewLanguageId = 'review_language_id',
  ReviewPros = 'review_pros',
  ReviewSummary = 'review_summary',
  ReviewerCurrentJob = 'reviewer_current_job',
  ReviewerEmploymentStatus = 'reviewer_employment_status',
  ReviewerJobEndingYear = 'reviewer_job_ending_year',
  ReviewerLengthOfEmployment = 'reviewer_length_of_employment',
  RicsK50 = 'rics_k50',
  RicsK100 = 'rics_k100',
  RicsK150 = 'rics_k150',
  RicsK200 = 'rics_k200',
  RicsK400 = 'rics_k400',
  Rn = 'rn',
  RoleK7 = 'role_k7',
  RoleK10 = 'role_k10',
  RoleK25 = 'role_k25',
  RoleK50 = 'role_k50',
  RoleK100 = 'role_k100',
  RoleK150 = 'role_k150',
  RoleK250 = 'role_k250',
  RoleK300 = 'role_k300',
  RoleK500 = 'role_k500',
  RoleK1000 = 'role_k1000',
  RoleK1250 = 'role_k1250',
  RoleK1500 = 'role_k1500',
  RoleK2500 = 'role_k2500',
  RoleK5000 = 'role_k5000',
  RoleK10000 = 'role_k10000',
  RoleK15000 = 'role_k15000',
  Salary = 'salary',
  SalaryMax = 'salary_max',
  SalaryMin = 'salary_min',
  SalaryReported = 'salary_reported',
  ScaledCount = 'scaled_count',
  ScaledInflow = 'scaled_inflow',
  ScaledOutflow = 'scaled_outflow',
  Sedol = 'sedol',
  Seniority = 'seniority',
  SentimentBenefits = 'sentiment_benefits',
  SentimentBusinessOutlook = 'sentiment_business_outlook',
  SentimentCareerGrowth = 'sentiment_career_growth',
  SentimentChildcare = 'sentiment_childcare',
  SentimentClientsAndCustomers = 'sentiment_clients_and_customers',
  SentimentCommission = 'sentiment_commission',
  SentimentCommitment = 'sentiment_commitment',
  SentimentCommute = 'sentiment_commute',
  SentimentCompanyGrowth = 'sentiment_company_growth',
  SentimentCompensation = 'sentiment_compensation',
  SentimentCompliance = 'sentiment_compliance',
  SentimentCoworkers = 'sentiment_coworkers',
  SentimentCulture = 'sentiment_culture',
  SentimentDiversityAndInclusion = 'sentiment_diversity_and_inclusion',
  SentimentEducationAssistance = 'sentiment_education_assistance',
  SentimentEfficiencyAndBureaucracy = 'sentiment_efficiency_and_bureaucracy',
  SentimentEthics = 'sentiment_ethics',
  SentimentFamilySupport = 'sentiment_family_support',
  SentimentHarassment = 'sentiment_harassment',
  SentimentHealthcare = 'sentiment_healthcare',
  SentimentHonesty = 'sentiment_honesty',
  SentimentIndependence = 'sentiment_independence',
  SentimentIntegrity = 'sentiment_integrity',
  SentimentInternalCommunication = 'sentiment_internal_communication',
  SentimentJobSecurity = 'sentiment_job_security',
  SentimentLeadership = 'sentiment_leadership',
  SentimentMentorship = 'sentiment_mentorship',
  SentimentMissionAndVision = 'sentiment_mission_and_vision',
  SentimentOfficePolitics = 'sentiment_office_politics',
  SentimentOnboarding = 'sentiment_onboarding',
  SentimentOvertime = 'sentiment_overtime',
  SentimentPaidTimeOff = 'sentiment_paid_time_off',
  SentimentPrestige = 'sentiment_prestige',
  SentimentProductAndServiceQuality = 'sentiment_product_and_service_quality',
  SentimentPromotionOpportunities = 'sentiment_promotion_opportunities',
  SentimentRatingOverall = 'sentiment_rating_overall',
  SentimentRemoteWork = 'sentiment_remote_work',
  SentimentRetirementPension = 'sentiment_retirement_pension',
  SentimentSafety = 'sentiment_safety',
  SentimentScheduleFlexibility = 'sentiment_schedule_flexibility',
  SentimentTechnology = 'sentiment_technology',
  SentimentTraining = 'sentiment_training',
  SentimentTransparency = 'sentiment_transparency',
  SentimentWellnessPrograms = 'sentiment_wellness_programs',
  SentimentWorkLifeBalance = 'sentiment_work_life_balance',
  SentimentWorkplaceFacilities = 'sentiment_workplace_facilities',
  SexPredicted = 'sex_predicted',
  Sic = 'sic',
  SkillK15 = 'skill_k15',
  SkillK25 = 'skill_k25',
  SkillK50 = 'skill_k50',
  SkillK75 = 'skill_k75',
  SkillK150 = 'skill_k150',
  SkillK500 = 'skill_k500',
  SkillK1500 = 'skill_k1500',
  SkillK5000 = 'skill_k5000',
  SkillK15000 = 'skill_k15000',
  SkillK35000 = 'skill_k35000',
  SkillMapped = 'skill_mapped',
  SkillRaw = 'skill_raw',
  Soc6d = 'soc6d',
  Source = 'source',
  StartMeanSampledSalary = 'start_mean_sampled_salary',
  Startdate = 'startdate',
  State = 'state',
  StreetAddress = 'street_address',
  Ticker = 'ticker',
  Title = 'title',
  TitleParsedTranslated = 'title_parsed_translated',
  TitleRaw = 'title_raw',
  TitleTranslated = 'title_translated',
  TotalCompensation = 'total_compensation',
  TotalPrestige = 'total_prestige',
  Transition = 'transition',
  UltParPrimaryName = 'ult_par_primary_name',
  UltParRcid = 'ult_par_rcid',
  UltimateParentCompanyName = 'ultimate_parent_company_name',
  UltimateParentRcid = 'ultimate_parent_rcid',
  UniversityCountry = 'university_country',
  UniversityLocation = 'university_location',
  UniversityName = 'university_name',
  Universityurl = 'universityurl',
  UpdatedDt = 'updated_dt',
  UsLogSalary = 'us_log_salary',
  UsRank = 'us_rank',
  UserCountry = 'user_country',
  UserId = 'user_id',
  UserLocation = 'user_location',
  UserPrestige = 'user_prestige',
  Website = 'website',
  Weight = 'weight',
  WhiteProb = 'white_prob',
  WorkEmail = 'work_email',
  WorkLifeBalanceSentiment = 'work_life_balance_sentiment',
  WorldRank = 'world_rank',
  YearFounded = 'year_founded',
}

export type PipelineConfig = {
  __typename?: 'PipelineConfig';
  client_id?: Maybe<Scalars['String']['output']>;
  dashboard_global?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  model_versions?: Maybe<ModelVersionsType>;
  name?: Maybe<Scalars['String']['output']>;
  pipeline?: Maybe<PipelineOutput>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type PipelineConfigInput = {
  client_id?: InputMaybe<Scalars['String']['input']>;
  dashboard_global?: InputMaybe<Scalars['Boolean']['input']>;
  model_versions?: InputMaybe<ModelVersions>;
  name?: InputMaybe<Scalars['String']['input']>;
  pipeline?: InputMaybe<Pipeline>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type PipelineFilter = {
  __typename?: 'PipelineFilter';
  binary?: Maybe<BinaryOperation>;
  conditions?: Maybe<Array<CustomColumnCondition>>;
  name: Scalars['String']['output'];
};

export type PipelineFilterInput = {
  binary?: InputMaybe<BinaryOperation>;
  conditions?: InputMaybe<Array<InputMaybe<CustomColumnConditionInput>>>;
  name: Scalars['String']['input'];
};

export type PipelineGroupInput = {
  column: PipelineColumnType;
};

export enum PipelineOrderType {
  Asc = 'asc',
  Desc = 'desc',
}

export type PipelineOutput = {
  __typename?: 'PipelineOutput';
  columns?: Maybe<Array<Maybe<PipelineColumnType>>>;
  company_info_configuration?: Maybe<CompanyInfoConfigurationOutput>;
  custom_columns?: Maybe<Array<Maybe<CustomColumn>>>;
  date_filter?: Maybe<DateFilterOutput>;
  end_at_count_long?: Maybe<Scalars['Boolean']['output']>;
  filters?: Maybe<Array<Maybe<PipelineFilter>>>;
  individual_user_configuration?: Maybe<IndividualUserConfigurationOutput>;
  pipeline_type: PipelineType;
  posting_configuration?: Maybe<PostingConfigurationOutput>;
  source?: Maybe<PostingSource>;
  transition_configuration?: Maybe<TransitionConfigurationOutput>;
};

export type PipelineSortInput = {
  column: Scalars['String']['input'];
  order: PipelineOrderType;
};

export enum PipelineType {
  CompanyInfo = 'company_info',
  Individual = 'individual',
  IndividualReviews = 'individual_reviews',
  Layoffs = 'layoffs',
  Posting = 'posting',
  PostingsIndividual = 'postings_individual',
  ReviewTrends = 'review_trends',
  SentimentScores = 'sentiment_scores',
  SkillDynam = 'skill_dynam',
  Transition = 'transition',
  WfDynam = 'wf_dynam',
}

export enum PositionCategoryKind {
  City = 'CITY',
  CompanyId = 'COMPANY_ID',
  Contingent = 'CONTINGENT',
  Country = 'COUNTRY',
  EmploymentRelationship = 'EMPLOYMENT_RELATIONSHIP',
  FlightRisk = 'FLIGHT_RISK',
  Msa = 'MSA',
  Prestige = 'PRESTIGE',
  Region = 'REGION',
  RemoteSuitability = 'REMOTE_SUITABILITY',
  RicsK10 = 'RICS_K10',
  RicsK50 = 'RICS_K50',
  RicsK400 = 'RICS_K400',
  RoleK7 = 'ROLE_K7',
  RoleK150 = 'ROLE_K150',
  RoleK1500 = 'ROLE_K1500',
  RoleK15000 = 'ROLE_K15000',
  RoleK17000 = 'ROLE_K17000',
  Rsid = 'RSID',
  Seniority = 'SENIORITY',
  WorkSchedule = 'WORK_SCHEDULE',
}

export enum PositionRangeKind {
  SalaryBase = 'SALARY_BASE',
  SalaryTotal = 'SALARY_TOTAL',
}

export enum PositionTextKind {
  Title = 'TITLE',
}

export type PositionsCountsReq = {
  cache_options?: InputMaybe<ResponseCacheOptions>;
  dim: Dimension;
  ent_id: Scalars['Int']['input'];
  filters: PositionsCountsReqFilters;
  params: PositionsCountsReqParams;
};

export type PositionsCountsReqFilters = {
  city?: InputMaybe<Array<Scalars['Int']['input']>>;
  company?: InputMaybe<Array<Scalars['Int']['input']>>;
  country?: InputMaybe<Array<Scalars['Int']['input']>>;
  custom_role?: InputMaybe<CustomRoleFilter>;
  custom_skill?: InputMaybe<CustomSkillFilter>;
  end_date?: InputMaybe<Scalars['Int']['input']>;
  ethnicity?: InputMaybe<Array<Scalars['Int']['input']>>;
  gender?: InputMaybe<Array<Scalars['Int']['input']>>;
  highest_degree?: InputMaybe<Array<Scalars['Int']['input']>>;
  industry?: InputMaybe<Array<Scalars['Int']['input']>>;
  msa?: InputMaybe<Array<Scalars['Int']['input']>>;
  region?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k10?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k50?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k400?: InputMaybe<Array<Scalars['Int']['input']>>;
  roleK7?: InputMaybe<Array<Scalars['Int']['input']>>;
  roleK150?: InputMaybe<Array<Scalars['Int']['input']>>;
  roleK1500?: InputMaybe<Array<Scalars['Int']['input']>>;
  seniority?: InputMaybe<Array<Scalars['Int']['input']>>;
  start_date?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PositionsCountsReqParams = {
  companies_num: Scalars['Int']['input'];
  geo_num: Scalars['Int']['input'];
  role_num: Scalars['Int']['input'];
};

export type PositionsCountsResp = {
  __typename?: 'PositionsCountsResp';
  companies_tot: Scalars['Float']['output'];
  geo_tot: Scalars['Float']['output'];
  role_tot: Scalars['Float']['output'];
  top_companies?: Maybe<Array<PositionsCountsRespEntity>>;
  top_geos?: Maybe<Array<PositionsCountsRespEntity>>;
  top_roles?: Maybe<Array<PositionsCountsRespEntity>>;
};

export type PositionsCountsRespEntity = {
  __typename?: 'PositionsCountsRespEntity';
  count: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  long_name: Scalars['String']['output'];
  share: Scalars['Float']['output'];
  short_name: Scalars['String']['output'];
};

export enum PositionsEntityKind {
  City = 'CITY',
  Company = 'COMPANY',
  Country = 'COUNTRY',
  Msa = 'MSA',
  Region = 'REGION',
  RicsK10 = 'RICS_K10',
  RicsK50 = 'RICS_K50',
  RicsK400 = 'RICS_K400',
  RoleK7 = 'ROLE_K7',
  RoleK150 = 'ROLE_K150',
  RoleK1500 = 'ROLE_K1500',
  RoleK15000 = 'ROLE_K15000',
  State = 'STATE',
}

export type Posting1dResponse = {
  __typename?: 'Posting1dResponse';
  metadata?: Maybe<Metadata>;
  metrics?: Maybe<PostingMetric>;
};

export type Posting2dResponse = {
  __typename?: 'Posting2dResponse';
  category?: Maybe<Array<Maybe<Posting1dResponse>>>;
  metadata?: Maybe<Metadata>;
};

export type PostingAndNode = {
  children: Array<PostingNode>;
};

export enum PostingCategoryKind {
  City = 'CITY',
  CompanyId = 'COMPANY_ID',
  Country = 'COUNTRY',
  Msa = 'MSA',
  Rcid = 'RCID',
  Region = 'REGION',
  RemoteType = 'REMOTE_TYPE',
  RicsK10 = 'RICS_K10',
  RicsK50 = 'RICS_K50',
  RicsK400 = 'RICS_K400',
  Seniority = 'SENIORITY',
  State = 'STATE',
}

export type PostingConfiguration = {
  frequency?: InputMaybe<PostingFrequency>;
  source?: InputMaybe<PostingSource>;
};

export type PostingConfigurationOutput = {
  __typename?: 'PostingConfigurationOutput';
  frequency?: Maybe<PostingFrequency>;
  source?: Maybe<PostingSource>;
};

export enum PostingDimension {
  Company = 'company',
  Date = 'date',
  Geography = 'geography',
  Role = 'role',
  Top = 'top',
  TopRole = 'top_role',
}

export type PostingDiscoveryByIdReq = {
  job_ids: Array<Scalars['Int']['input']>;
};

export type PostingDiscoveryByIdResp = {
  __typename?: 'PostingDiscoveryByIdResp';
  postings: Array<PostingDiscoveryRow>;
};

export type PostingDiscoveryGeoData = {
  __typename?: 'PostingDiscoveryGeoData';
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
  map_data_kind: MapDataKind;
  share: Scalars['Float']['output'];
};

export type PostingDiscoveryReq = {
  cache_options?: InputMaybe<ResponseCacheOptions>;
  filters: PostingDiscoveryReqFilters;
  options?: InputMaybe<PostingDiscoveryReqOptions>;
  pagination: PostingDiscoveryReqPage;
};

export type PostingDiscoveryReqFilters = {
  expr: PostingNode;
  roles_tax: Scalars['Int']['input'];
  skills_tax: Scalars['Int']['input'];
};

export type PostingDiscoveryReqOptions = {
  include_descriptions: Scalars['Boolean']['input'];
};

export type PostingDiscoveryReqPage = {
  page_num: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
};

export type PostingDiscoveryResp = {
  __typename?: 'PostingDiscoveryResp';
  columns: Array<Scalars['String']['output']>;
  map_data: Array<PostingDiscoveryGeoData>;
  pagination?: Maybe<PostingDiscoveryRespPage>;
  postings: Array<PostingDiscoveryRow>;
};

export type PostingDiscoveryRespPage = {
  __typename?: 'PostingDiscoveryRespPage';
  tot_pages_num: Scalars['Int']['output'];
  tot_postings_num: Scalars['Int']['output'];
};

export type PostingDiscoveryRow = {
  __typename?: 'PostingDiscoveryRow';
  city: Scalars['String']['output'];
  company_id: Scalars['Int']['output'];
  company_name: Scalars['String']['output'];
  country: Scalars['String']['output'];
  description: Scalars['String']['output'];
  expected_hires: Scalars['Float']['output'];
  job_id: Scalars['Int']['output'];
  jobtitle: Scalars['String']['output'];
  location: Scalars['String']['output'];
  msa: Scalars['String']['output'];
  post_date: Scalars['String']['output'];
  posting_url: Scalars['String']['output'];
  rcid: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  remote_type: Scalars['String']['output'];
  rics_k10: Scalars['String']['output'];
  rics_k50: Scalars['String']['output'];
  rics_k400: Scalars['String']['output'];
  role_v3_id: Scalars['Int']['output'];
  salary: Scalars['Float']['output'];
  seniority: Scalars['String']['output'];
  skills: Array<Scalars['String']['output']>;
  state: Scalars['String']['output'];
};

export type PostingExprAndNode = {
  children: Array<PostingExprNode>;
};

export type PostingExprNode = {
  and?: InputMaybe<PostingExprAndNode>;
  not?: InputMaybe<PostingExprNotNode>;
  or?: InputMaybe<PostingExprOrNode>;
  rng?: InputMaybe<PostingExprRangeNode>;
  txt?: InputMaybe<PostingExprTextNode>;
  val?: InputMaybe<PostingExprValueNode>;
};

export type PostingExprNotNode = {
  child: PostingExprNode;
};

export type PostingExprOrNode = {
  children: Array<PostingExprNode>;
};

export type PostingExprRangeAttribute = {
  end: Scalars['Int']['input'];
  kind: PostingRangeKind;
  start: Scalars['Int']['input'];
};

export type PostingExprRangeNode = {
  attribute?: InputMaybe<PostingExprRangeAttribute>;
};

export type PostingExprTextAttribute = {
  kind: PostingTextKind;
  text: Scalars['String']['input'];
};

export type PostingExprTextNode = {
  attribute?: InputMaybe<PostingExprTextAttribute>;
};

export type PostingExprValueAttribute = {
  id: Scalars['Int']['input'];
  kind: PostingCategoryKind;
};

export type PostingExprValueNode = {
  attribute?: InputMaybe<PostingExprValueAttribute>;
  role?: InputMaybe<PostingExprValueRole>;
  skill?: InputMaybe<PostingExprValueSkill>;
};

export type PostingExprValueRole = {
  id: Scalars['Int']['input'];
  level: Scalars['Int']['input'];
  taxonomy_id: Scalars['Int']['input'];
};

export type PostingExprValueSkill = {
  id: Scalars['Int']['input'];
  level: Scalars['Int']['input'];
  taxonomy_id: Scalars['Int']['input'];
};

export type PostingFilters = {
  city?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  company?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  country?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  custom_role?: InputMaybe<CustomRoleFilter>;
  custom_skill?: InputMaybe<CustomSkillFilter>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  job_category?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  keywords_v2?: InputMaybe<
    Array<InputMaybe<Array<Scalars['String']['input']>>>
  >;
  metric_mode?: InputMaybe<Scalars['String']['input']>;
  msa?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  provider?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rcid?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  region?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  rics_k10?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  rics_k50?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  rics_k400?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role_k50?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role_k150?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role_k1500?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  seniority?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title_raw?: InputMaybe<Array<Scalars['String']['input']>>;
  title_raw_v2?: InputMaybe<
    Array<InputMaybe<Array<Scalars['String']['input']>>>
  >;
};

export enum PostingFrequency {
  Day = 'day',
  Month = 'month',
  Week = 'week',
}

export type PostingMetric = {
  __typename?: 'PostingMetric';
  active?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  expected_hires?: Maybe<Scalars['Float']['output']>;
  new?: Maybe<Scalars['Int']['output']>;
  removed?: Maybe<Scalars['Int']['output']>;
  salary?: Maybe<Scalars['Int']['output']>;
  share?: Maybe<Scalars['Float']['output']>;
  time_to_fill?: Maybe<Scalars['Float']['output']>;
};

export type PostingNode = {
  posting_and?: InputMaybe<PostingAndNode>;
  posting_not?: InputMaybe<PostingNotNode>;
  posting_or?: InputMaybe<PostingOrNode>;
  posting_value?: InputMaybe<PostingValNode>;
};

export type PostingNotNode = {
  child: PostingNode;
};

export type PostingOrNode = {
  children: Array<PostingNode>;
};

export enum PostingRangeKind {
  PostDate = 'POST_DATE',
  Salary = 'SALARY',
}

export type PostingRequestOptions = {
  cache_options?: InputMaybe<ResponseCacheOptions>;
  required_top_companies_length?: InputMaybe<Scalars['Int']['input']>;
  required_top_roles_length?: InputMaybe<Scalars['Int']['input']>;
};

export enum PostingScalingVersion {
  V0 = 'V0',
  V2 = 'V2',
}

export enum PostingSource {
  Companysites = 'companysites',
  Ghr = 'ghr',
  Indeed = 'indeed',
  Linkup = 'linkup',
  Mixrank = 'mixrank',
  Revelio = 'revelio',
  Unified = 'unified',
}

export enum PostingTextKind {
  Description = 'DESCRIPTION',
  Jobtitle = 'JOBTITLE',
}

export type PostingValNode = {
  child: PostingExprNode;
};

export type PostingsV3CountItem = {
  __typename?: 'PostingsV3CountItem';
  count: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  long_name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  share: Scalars['Float']['output'];
  short_name: Scalars['String']['output'];
};

export type PostingsV3DataPoint = {
  __typename?: 'PostingsV3DataPoint';
  id: Scalars['Int']['output'];
  val: Scalars['Float']['output'];
};

export type PostingsV3Ent = {
  EntID: Scalars['Int']['input'];
  EntType: EntKind;
};

export type PostingsV3Filters = {
  city?: InputMaybe<Array<Scalars['Int']['input']>>;
  company?: InputMaybe<Array<Scalars['Int']['input']>>;
  country?: InputMaybe<Array<Scalars['Int']['input']>>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  msa?: InputMaybe<Array<Scalars['Int']['input']>>;
  provider?: InputMaybe<Array<Scalars['Int']['input']>>;
  region?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k10?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k50?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k400?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_1?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_2?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_3?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_4?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_5?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_6?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_7?: InputMaybe<Array<Scalars['Int']['input']>>;
  seniority?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_1?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_2?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_3?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_4?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_5?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_6?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_7?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_8?: InputMaybe<Array<Scalars['Int']['input']>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

export enum PostingsV3Mode {
  Hires = 'HIRES',
  Normal = 'NORMAL',
}

export type PostingsV3Options = {
  mode: PostingsV3Mode;
  roles_counts_level: EntKind;
};

export type PostingsV3Req = {
  cache_options?: InputMaybe<ResponseCacheOptions>;
  entities: Array<PostingsV3Ent>;
  filters: PostingsV3Filters;
  options: PostingsV3Options;
  role_taxonomy: Scalars['Int']['input'];
  skill_taxonomy: Scalars['Int']['input'];
};

export type PostingsV3Resp = {
  __typename?: 'PostingsV3Resp';
  entities: Array<PostingsV3RespEnt>;
};

export type PostingsV3RespData = {
  __typename?: 'PostingsV3RespData';
  active: Array<PostingsV3DataPoint>;
  added: Array<PostingsV3DataPoint>;
  company_counts: Array<PostingsV3CountItem>;
  hires: Array<PostingsV3DataPoint>;
  removed: Array<PostingsV3DataPoint>;
  role_counts: Array<PostingsV3CountItem>;
  salary: Array<PostingsV3DataPoint>;
  time_to_fill: Array<PostingsV3DataPoint>;
};

export type PostingsV3RespEnt = {
  __typename?: 'PostingsV3RespEnt';
  id: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
  long_name: Scalars['String']['output'];
  metrics: PostingsV3RespData;
  short_name: Scalars['String']['output'];
};

export type Preset = {
  __typename?: 'Preset';
  default?: Maybe<Scalars['Boolean']['output']>;
  filters?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  view?: Maybe<View>;
};

export enum PrestigeVersion {
  V1 = 'V1',
  V2 = 'V2',
}

export type Query = {
  __typename?: 'Query';
  availableApiKeyEndpoints: Array<ApiKeyEndpoint>;
  checkApiKey: CheckApiKeyResponse;
  cityInMsaInfo?: Maybe<Array<Maybe<GeoRefInfo>>>;
  clients?: Maybe<Array<Maybe<Client>>>;
  clientsDeliConfig?: Maybe<DeliverableConfig>;
  clientsDeliverable?: Maybe<Array<ClientDeliverableOutput>>;
  compensation?: Maybe<Array<Maybe<CompensationResponse>>>;
  composition_v2?: Maybe<CompositionV2Resp>;
  composition_v2_tooltip?: Maybe<CompositionV2FullSnapshotResp>;
  composition_v3?: Maybe<CompositionV3Resp>;
  decryptString: Scalars['String']['output'];
  employmentRelationship: Array<Maybe<IdNamePair>>;
  entityV2?: Maybe<EntityV2Resp>;
  ethnicity: Array<Maybe<IdNamePair>>;
  gender: Array<Maybe<IdNamePair>>;
  getResume: Resume;
  highestDegree: Array<Maybe<IdNamePair>>;
  index?: Maybe<IndexValues>;
  jobEmbedding: JobEmbeddingResp;
  legacy_users?: Maybe<Array<Maybe<User>>>;
  listApiKeys: ListApiKeyResponse;
  manifest?: Maybe<ManifestValues>;
  manifest_versions?: Maybe<Array<Maybe<ManifestVersion>>>;
  mapCoords: MapCoordsResp;
  pay_v2?: Maybe<PayV2Resp>;
  pipelineConfiguration?: Maybe<Array<Maybe<PipelineConfig>>>;
  posting?: Maybe<Array<Maybe<Posting2dResponse>>>;
  posting_discovery_search: PostingDiscoveryResp;
  posting_discovery_search_by_id: PostingDiscoveryByIdResp;
  postings_v3?: Maybe<PostingsV3Resp>;
  presets?: Maybe<Array<Maybe<Preset>>>;
  remoteType: Array<Maybe<IdNamePair>>;
  reports_validation: Array<Maybe<ReportsValidationResponse>>;
  roleTaxonomies: Array<RoleTaxonomyMetadata>;
  schoolInfo?: Maybe<Array<Maybe<SchoolRefInfo>>>;
  screener: ScreenerResp;
  selectionList?: Maybe<SelectionList>;
  seniority: Array<Maybe<IdNamePair>>;
  sentiment?: Maybe<Array<Maybe<SentimentResponseEntity>>>;
  sentiment_v3?: Maybe<SentimentV3Resp>;
  talent_discovery_name_recommendations_v2: TalentDiscoveryV2NameRecommendationResp;
  talent_discovery_name_recommendations_v3: TalentDiscoveryNameRecRespV3;
  talent_discovery_search_by_id_v3: TalentDiscoveryByIdRespV3;
  talent_discovery_search_v2: TalentDiscoveryV2SearchResp;
  talent_discovery_search_v3: TalentDiscoveryRespV3;
  taxonomy: TaxonomyResponse;
  taxonomyLatestVersion: TaxonomyLatestVersionResponse;
  taxonomyList: TaxonomyListResponse;
  taxonomyVersions: TaxonomyVersionsResponse;
  transitionsV2?: Maybe<TransitionsRespV2>;
  transitions_v3?: Maybe<TransitionsV3Resp>;
  userSSOClient?: Maybe<SsoClientResponse>;
  userSearch?: Maybe<Array<Maybe<User>>>;
  users?: Maybe<Array<Maybe<User>>>;
  workSchedule: Array<Maybe<IdNamePair>>;
};

export type QueryCityInMsaInfoArgs = {
  in: MsaRefInfoInput;
};

export type QueryClientsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryClientsDeliverableArgs = {
  client_name?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCompensationArgs = {
  dim1?: InputMaybe<Dimension1>;
  dim2?: InputMaybe<CompensationDimension>;
  filters?: InputMaybe<CompensationFilters>;
};

export type QueryComposition_V2Args = {
  req?: InputMaybe<CompositionV2Req>;
};

export type QueryComposition_V2_TooltipArgs = {
  req?: InputMaybe<CompositionV2FullSnapshotReq>;
};

export type QueryComposition_V3Args = {
  req?: InputMaybe<CompositionV3Req>;
};

export type QueryDecryptStringArgs = {
  input: Scalars['String']['input'];
};

export type QueryEntityV2Args = {
  req?: InputMaybe<EntityV2Req>;
};

export type QueryGetResumeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryJobEmbeddingArgs = {
  input: JobEmbeddingReq;
};

export type QueryLegacy_UsersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryListApiKeysArgs = {
  input: IdentityInput;
};

export type QueryMapCoordsArgs = {
  req: MapCoordsReq;
};

export type QueryPay_V2Args = {
  req?: InputMaybe<PayV2Req>;
};

export type QueryPipelineConfigurationArgs = {
  configuration?: InputMaybe<PipelineConfigInput>;
};

export type QueryPostingArgs = {
  dim1?: InputMaybe<Dimension1>;
  dim2?: InputMaybe<PostingDimension>;
  filters?: InputMaybe<PostingFilters>;
  options?: InputMaybe<PostingRequestOptions>;
  skip_share_of_postings_scaling?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPosting_Discovery_SearchArgs = {
  query?: InputMaybe<PostingDiscoveryReq>;
};

export type QueryPosting_Discovery_Search_By_IdArgs = {
  query?: InputMaybe<PostingDiscoveryByIdReq>;
};

export type QueryPostings_V3Args = {
  req?: InputMaybe<PostingsV3Req>;
};

export type QueryPresetsArgs = {
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<View>;
};

export type QuerySchoolInfoArgs = {
  in: SchoolRefInfoInput;
};

export type QueryScreenerArgs = {
  filters: ScreenerReq;
};

export type QuerySentimentArgs = {
  dim1?: InputMaybe<Dimension1>;
  filters?: InputMaybe<SentimentV2Filters>;
};

export type QuerySentiment_V3Args = {
  req?: InputMaybe<SentimentV3Req>;
};

export type QueryTalent_Discovery_Name_Recommendations_V2Args = {
  query?: InputMaybe<TalentDiscoveryV2SearchReq>;
};

export type QueryTalent_Discovery_Name_Recommendations_V3Args = {
  query?: InputMaybe<TalentDiscoveryReqV3>;
};

export type QueryTalent_Discovery_Search_By_Id_V3Args = {
  query?: InputMaybe<TalentDiscoveryByIdReqV3>;
};

export type QueryTalent_Discovery_Search_V2Args = {
  query?: InputMaybe<TalentDiscoveryV2SearchReq>;
};

export type QueryTalent_Discovery_Search_V3Args = {
  query?: InputMaybe<TalentDiscoveryReqV3>;
};

export type QueryTaxonomyArgs = {
  req: TaxonomyRequest;
};

export type QueryTaxonomyLatestVersionArgs = {
  req: TaxonomyLatestVersionRequest;
};

export type QueryTaxonomyListArgs = {
  req: TaxonomyListRequest;
};

export type QueryTaxonomyVersionsArgs = {
  req: TaxonomyVersionsRequest;
};

export type QueryTransitionsV2Args = {
  req?: InputMaybe<TransitionsReqV2>;
};

export type QueryTransitions_V3Args = {
  req?: InputMaybe<TransitionsV3Req>;
};

export type QueryUserSsoClientArgs = {
  input: Scalars['String']['input'];
};

export type QueryUserSearchArgs = {
  input: Scalars['String']['input'];
};

export type QueryUsersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Range = {
  end_val?: InputMaybe<Scalars['Float']['input']>;
  start_val?: InputMaybe<Scalars['Float']['input']>;
};

export type Recommendation = {
  __typename?: 'Recommendation';
  original: Scalars['String']['output'];
  suggestions: Array<Scalars['String']['output']>;
  tokenized: Scalars['String']['output'];
};

export type RecommendationRequest = {
  prefix: Array<Scalars['String']['input']>;
};

export type RecommendationResponse = {
  __typename?: 'RecommendationResponse';
  recommendations: Array<Recommendation>;
};

export type RefInfo = {
  __typename?: 'RefInfo';
  dataUnavailableIn?: Maybe<ManifestKind>;
  id?: Maybe<Scalars['ID']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export type RefMetadataInput = {
  RefName?: InputMaybe<Scalars['String']['input']>;
  Rows?: InputMaybe<Scalars['Int']['input']>;
  UpdateTime?: InputMaybe<Scalars['String']['input']>;
  Version?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterApiKeyInput = {
  apis: Array<ApiKeyEndpoint>;
  uuid: Scalars['UUID']['input'];
};

export type RegisterApiKeyResponse = {
  __typename?: 'RegisterApiKeyResponse';
  api_key?: Maybe<Scalars['String']['output']>;
  api_key_id?: Maybe<Scalars['String']['output']>;
};

export type RemoveApiKeyInput = {
  api_key_id: Scalars['String']['input'];
  uuid: Scalars['UUID']['input'];
};

export type Report = {
  __typename?: 'Report';
  client?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  job_id: Scalars['Int']['output'];
  job_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  report: ReportResponse;
  status: DeliveryStatus;
  updated_at?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export enum ReportFilterId {
  Geography = 'geography',
  Role = 'role',
  Skill = 'skill',
}

export type ReportFilterInput = {
  id: Scalars['String']['input'];
  type: ReportFilterType;
  values: Array<Scalars['String']['input']>;
};

export type ReportFilterOutput = {
  __typename?: 'ReportFilterOutput';
  id: Scalars['String']['output'];
  type: ReportFilterType;
  values: Array<Scalars['String']['output']>;
};

export enum ReportFilterType {
  Country = 'country',
  CustomSkill = 'custom_skill',
  Industry = 'industry',
  JobCategory = 'job_category',
  MetroArea = 'metro_area',
  Region = 'region',
  RicsK10 = 'rics_k10',
  RicsK50 = 'rics_k50',
  RicsK400 = 'rics_k400',
  RoleK10 = 'role_k10',
  RoleK50 = 'role_k50',
  RoleK150 = 'role_k150',
  RoleK300 = 'role_k300',
  RoleK500 = 'role_k500',
  RoleK700 = 'role_k700',
  RoleK1000 = 'role_k1000',
  RoleK1250 = 'role_k1250',
  RoleK1500 = 'role_k1500',
  RoleK5000 = 'role_k5000',
  RoleK15000 = 'role_k15000',
  Seniority = 'seniority',
  SkillK25 = 'skill_k25',
  SkillK50 = 'skill_k50',
  SkillK75 = 'skill_k75',
  SkillK700 = 'skill_k700',
  SkillK2500 = 'skill_k2500',
  SkillMapped = 'skill_mapped',
  State = 'state',
}

export type ReportRequest = {
  comparisonEntities?: InputMaybe<Array<EntityInput>>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  mainEntities: Array<EntityInput>;
  reportType: ReportTypeEnum;
};

export type ReportResponse = {
  __typename?: 'ReportResponse';
  comparisonEntities?: Maybe<Array<EntityOutput>>;
  filters?: Maybe<Array<ReportFilterOutput>>;
  mainEntities: Array<EntityOutput>;
  reportType: ReportTypeEnum;
};

export enum ReportTypeEnum {
  AiAdoptionExposure = 'AiAdoptionExposure',
  Attrition = 'Attrition',
  Compensation = 'Compensation',
  CompensationBenchmarking = 'CompensationBenchmarking',
  DynamicCompanyReport = 'DynamicCompanyReport',
  GenderDiversity = 'GenderDiversity',
  HcDisclosure = 'HCDisclosure',
  JobComparison = 'JobComparison',
  MarketDiscovery = 'MarketDiscovery',
  MarketIntelligence = 'MarketIntelligence',
  MarketTightness = 'MarketTightness',
  MarketTightnessAlt = 'MarketTightnessAlt',
  OrgStructure = 'OrgStructure',
  Prestige = 'Prestige',
  Regulations = 'Regulations',
  SalesCompensation = 'SalesCompensation',
  Sentiment = 'Sentiment',
  Skills = 'Skills',
  TimeToFill = 'TimeToFill',
}

export type ReportValidation = {
  __typename?: 'ReportValidation';
  category: Array<Scalars['String']['output']>;
  comparison_entities?: Maybe<Array<Maybe<ReportValidationEntity>>>;
  description: Scalars['String']['output'];
  filters?: Maybe<Array<Maybe<ReportValidationEntity>>>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  main_entity: Array<Maybe<ReportValidationEntity>>;
  report_type: ReportTypeEnum;
  sample_link?: Maybe<Scalars['String']['output']>;
};

export type ReportValidationEntity = {
  __typename?: 'ReportValidationEntity';
  description: Scalars['String']['output'];
  label: Scalars['String']['output'];
  limit: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  selection_list: Array<Scalars['String']['output']>;
};

export type ReportValidationEntityInput = {
  description: Scalars['String']['input'];
  label: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  required: Scalars['Boolean']['input'];
  selection_list: Array<Scalars['String']['input']>;
};

export type ReportValidationInput = {
  category: Array<Scalars['String']['input']>;
  comparison_entities?: InputMaybe<
    Array<InputMaybe<ReportValidationEntityInput>>
  >;
  description: Scalars['String']['input'];
  filters?: InputMaybe<Array<InputMaybe<ReportValidationEntityInput>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  label: Scalars['String']['input'];
  main_entity: Array<InputMaybe<ReportValidationEntityInput>>;
  report_type: ReportTypeEnum;
  sample_link?: InputMaybe<Scalars['String']['input']>;
};

export type ReportsValidationRequest = {
  report_type: ReportTypeEnum;
};

export type ReportsValidationResponse = {
  __typename?: 'ReportsValidationResponse';
  report_validation?: Maybe<ReportValidation>;
};

export type ResponseCacheOptions = {
  skip_dbe_cache?: InputMaybe<Scalars['Boolean']['input']>;
  skip_mw_cache?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Resume = {
  __typename?: 'Resume';
  download_link?: Maybe<Scalars['String']['output']>;
  enriched_data?: Maybe<Scalars['String']['output']>;
  excel_location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  resume_id: Scalars['String']['output'];
  s3_location?: Maybe<Scalars['String']['output']>;
};

export type ResumeRequest = {
  download_link?: InputMaybe<Scalars['String']['input']>;
  enriched_data?: InputMaybe<Scalars['String']['input']>;
  excel_location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  resume_id: Scalars['String']['input'];
  s3_location?: InputMaybe<Scalars['String']['input']>;
};

export type RetryDeliverableInput = {
  delivery_id: Scalars['Int']['input'];
};

export type RicsRefInfo = {
  __typename?: 'RicsRefInfo';
  headcount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  rics_k10?: Maybe<Scalars['String']['output']>;
  rics_k50?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export enum Role {
  ClientAdmin = 'CLIENT_ADMIN',
  ClientUser = 'CLIENT_USER',
  RevelioAdmin = 'REVELIO_ADMIN',
  SuperAdmin = 'SUPER_ADMIN',
}

export type RoleRefInfo = {
  __typename?: 'RoleRefInfo';
  dataUnavailableIn?: Maybe<ManifestKind>;
  id?: Maybe<Scalars['ID']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  roleK7?: Maybe<Scalars['ID']['output']>;
  roleK50?: Maybe<Scalars['ID']['output']>;
  roleK150?: Maybe<Scalars['ID']['output']>;
  roleK300?: Maybe<Scalars['ID']['output']>;
  roleK500?: Maybe<Scalars['ID']['output']>;
  roleK1000?: Maybe<Scalars['ID']['output']>;
  roleK1250?: Maybe<Scalars['ID']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  topCleanedTitles?: Maybe<Scalars['String']['output']>;
  topRawTitles?: Maybe<Scalars['String']['output']>;
};

export type RoleTaxonomyMetadata = {
  __typename?: 'RoleTaxonomyMetadata';
  isLatest: Scalars['Boolean']['output'];
  taxonomyId: Scalars['Int']['output'];
  taxonomyName: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type RoleTaxonomyRefInfo = {
  __typename?: 'RoleTaxonomyRefInfo';
  id?: Maybe<Scalars['ID']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  rawTitles: Array<Scalars['String']['output']>;
  role_k10?: Maybe<Scalars['ID']['output']>;
  role_k50?: Maybe<Scalars['ID']['output']>;
  role_k150?: Maybe<Scalars['ID']['output']>;
  role_k500?: Maybe<Scalars['ID']['output']>;
  role_k1500?: Maybe<Scalars['ID']['output']>;
  role_k5000?: Maybe<Scalars['ID']['output']>;
  role_k10000?: Maybe<Scalars['ID']['output']>;
  role_k15000?: Maybe<Scalars['ID']['output']>;
  role_k17000?: Maybe<Scalars['ID']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export type S3Delivery = {
  s3_bucket: Scalars['String']['input'];
  s3_file_prefix: Scalars['String']['input'];
  s3_format: S3Format;
};

export type S3DeliveryOutput = {
  __typename?: 'S3DeliveryOutput';
  s3_bucket: Scalars['String']['output'];
  s3_file_prefix: Scalars['String']['output'];
  s3_format: S3Format;
};

export enum S3Format {
  Csv = 'csv',
  Parquet = 'parquet',
  Zip = 'zip',
}

export type SsoClientResponse = {
  __typename?: 'SSOClientResponse';
  client_group?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
};

export enum SalaryVersion {
  V2 = 'V2',
  V2_1 = 'V2_1',
}

export type SchoolRefInfo = {
  __typename?: 'SchoolRefInfo';
  dataUnavailableIn?: Maybe<ManifestKind>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rsid?: Maybe<Scalars['ID']['output']>;
  userCount?: Maybe<Scalars['Int']['output']>;
};

export type SchoolRefInfoInput = {
  name: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};

export enum ScreenerDimension {
  Company = 'COMPANY',
  Geography = 'GEOGRAPHY',
  Role = 'ROLE',
}

export type ScreenerEntityInfoSelectors = {
  company_info_selectors?: InputMaybe<ScreenerReqCompanyInfoFilters>;
};

export type ScreenerReq = {
  contingent_workers?: InputMaybe<Scalars['Boolean']['input']>;
  dim: ScreenerDimension;
  entity_info_selectors?: InputMaybe<ScreenerEntityInfoSelectors>;
  pagination: ScreenerReqPagination;
  primary_selector: ScreenerReqFilters;
  segments: ScreenerReqSegments;
  sorting?: InputMaybe<ScreenerReqSorting>;
};

export type ScreenerReqCompanyInfoFilters = {
  competitors_of?: InputMaybe<Array<Scalars['Int']['input']>>;
  founder_api?: InputMaybe<Scalars['Boolean']['input']>;
  founder_black?: InputMaybe<Scalars['Boolean']['input']>;
  founder_female?: InputMaybe<Scalars['Boolean']['input']>;
  founder_hispanic?: InputMaybe<Scalars['Boolean']['input']>;
  founder_male?: InputMaybe<Scalars['Boolean']['input']>;
  founder_multiple?: InputMaybe<Scalars['Boolean']['input']>;
  founder_native?: InputMaybe<Scalars['Boolean']['input']>;
  founder_prev_company?: InputMaybe<Array<Scalars['Int']['input']>>;
  founder_prev_university?: InputMaybe<Array<Scalars['Int']['input']>>;
  founder_white?: InputMaybe<Scalars['Boolean']['input']>;
  funding_stage?: InputMaybe<Array<Scalars['Int']['input']>>;
  hq_country?: InputMaybe<Array<Scalars['Int']['input']>>;
  hq_msa?: InputMaybe<Array<Scalars['Int']['input']>>;
  hq_region?: InputMaybe<Array<Scalars['Int']['input']>>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  is_subsidiary?: InputMaybe<Scalars['Boolean']['input']>;
  is_subsidiary_of_rcids?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  keywords_v2?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  last_funding_amount?: InputMaybe<Array<Range>>;
  last_funding_year?: InputMaybe<Array<Range>>;
  total_funding_amount?: InputMaybe<Array<Range>>;
  valuation?: InputMaybe<Array<Range>>;
  year_founded?: InputMaybe<Array<Range>>;
};

export type ScreenerReqFilters = {
  country?: InputMaybe<Array<Scalars['Int']['input']>>;
  ethnicity?: InputMaybe<Array<Scalars['Int']['input']>>;
  gender?: InputMaybe<Array<Scalars['Int']['input']>>;
  highest_degree?: InputMaybe<Array<Scalars['Int']['input']>>;
  industry?: InputMaybe<Array<Scalars['Int']['input']>>;
  job_category?: InputMaybe<Array<Scalars['Int']['input']>>;
  metro_area?: InputMaybe<Array<Scalars['Int']['input']>>;
  region?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k10?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k50?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k400?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_k150?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_k1500?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_k15000?: InputMaybe<Array<Scalars['Int']['input']>>;
  seniority?: InputMaybe<Array<Scalars['Int']['input']>>;
  state?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ScreenerReqPagination = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type ScreenerReqSegmentSelector = {
  end_val?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<ScreenerReqFilters>;
  start_val?: InputMaybe<Scalars['Float']['input']>;
};

export type ScreenerReqSegments = {
  attrition?: InputMaybe<Array<ScreenerReqSegmentSelector>>;
  growth?: InputMaybe<Array<ScreenerReqSegmentSelector>>;
  growth_yoy?: InputMaybe<Array<ScreenerReqSegmentSelector>>;
  headcount?: InputMaybe<Array<ScreenerReqSegmentSelector>>;
  hiring?: InputMaybe<Array<ScreenerReqSegmentSelector>>;
  inflow?: InputMaybe<Array<ScreenerReqSegmentSelector>>;
  outflow?: InputMaybe<Array<ScreenerReqSegmentSelector>>;
  salary?: InputMaybe<Array<ScreenerReqSegmentSelector>>;
  tenure?: InputMaybe<Array<ScreenerReqSegmentSelector>>;
};

export type ScreenerReqSorting = {
  ascending: Scalars['Boolean']['input'];
  num_col: Scalars['Int']['input'];
  sort_by: ScreenerSortCol;
};

export type ScreenerResp = {
  __typename?: 'ScreenerResp';
  entities: Array<ScreenerRespEntity>;
  pagination: ScreenerRespPagination;
};

export type ScreenerRespCompanyInfo = {
  __typename?: 'ScreenerRespCompanyInfo';
  description: Scalars['String']['output'];
  email: Scalars['String']['output'];
  founder_api: Scalars['Boolean']['output'];
  founder_black: Scalars['Boolean']['output'];
  founder_female: Scalars['Boolean']['output'];
  founder_hispanic: Scalars['Boolean']['output'];
  founder_male: Scalars['Boolean']['output'];
  founder_multiple: Scalars['Boolean']['output'];
  founder_native: Scalars['Boolean']['output'];
  founder_white: Scalars['Boolean']['output'];
  funding_stage: Scalars['String']['output'];
  hq_country: Scalars['String']['output'];
  hq_metro_area: Scalars['String']['output'];
  hq_region: Scalars['String']['output'];
  hq_state: Scalars['String']['output'];
  is_public: Scalars['Boolean']['output'];
  last_funding_amount?: Maybe<Scalars['Int']['output']>;
  last_funding_year?: Maybe<Scalars['Int']['output']>;
  linkedin_url: Scalars['String']['output'];
  phone_number: Scalars['String']['output'];
  rcid: Scalars['Int']['output'];
  rics_k10: Scalars['String']['output'];
  rics_k50: Scalars['String']['output'];
  rics_k400: Scalars['String']['output'];
  total_funding_amount?: Maybe<Scalars['Int']['output']>;
  ultimate_parent_name?: Maybe<Scalars['String']['output']>;
  ultimate_parent_rcid?: Maybe<Scalars['Int']['output']>;
  valuation?: Maybe<Scalars['Int']['output']>;
  website: Scalars['String']['output'];
  year_founded: Scalars['Int']['output'];
};

export type ScreenerRespEntity = {
  __typename?: 'ScreenerRespEntity';
  attrition: Array<Scalars['Float']['output']>;
  attrition_rate: Array<Scalars['Float']['output']>;
  entity_id: Scalars['Int']['output'];
  entity_info: EntityInfo;
  growth: Array<Scalars['Float']['output']>;
  growth_yoy: Array<Scalars['Float']['output']>;
  headcount: Array<Scalars['Float']['output']>;
  hiring: Array<Scalars['Float']['output']>;
  inflow: Array<Scalars['Float']['output']>;
  long_name: Scalars['String']['output'];
  outflow: Array<Scalars['Float']['output']>;
  salary: Array<Scalars['Float']['output']>;
  short_name: Scalars['String']['output'];
  tenure: Array<Scalars['Float']['output']>;
};

export type ScreenerRespPagination = {
  __typename?: 'ScreenerRespPagination';
  total_results: Scalars['Int']['output'];
};

export enum ScreenerSortCol {
  SortByAttrition = 'SORT_BY_ATTRITION',
  SortByGrowth = 'SORT_BY_GROWTH',
  SortByGrowthYoy = 'SORT_BY_GROWTH_YOY',
  SortByHeadcount = 'SORT_BY_HEADCOUNT',
  SortByHiring = 'SORT_BY_HIRING',
  SortByInflow = 'SORT_BY_INFLOW',
  SortByOutflow = 'SORT_BY_OUTFLOW',
  SortBySalary = 'SORT_BY_SALARY',
  SortByTenure = 'SORT_BY_TENURE',
}

export type SelectionList = {
  __typename?: 'SelectionList';
  city?: Maybe<Array<Maybe<GeoRefInfo>>>;
  company?: Maybe<Array<Maybe<CompanyRefInfo>>>;
  company_report?: Maybe<Array<Maybe<CompanyRefInfo>>>;
  country?: Maybe<Array<Maybe<GeoRefInfo>>>;
  currency?: Maybe<Array<Maybe<CurrencyRefInfo>>>;
  ethnicity?: Maybe<Array<Maybe<RefInfo>>>;
  gender?: Maybe<Array<Maybe<RefInfo>>>;
  highest_degree?: Maybe<Array<Maybe<RefInfo>>>;
  industry?: Maybe<Array<Maybe<RefInfo>>>;
  job_category?: Maybe<Array<Maybe<RoleRefInfo>>>;
  month?: Maybe<Array<Maybe<RefInfo>>>;
  msa?: Maybe<Array<Maybe<GeoRefInfo>>>;
  region?: Maybe<Array<Maybe<GeoRefInfo>>>;
  rics_k10?: Maybe<Array<Maybe<RicsRefInfo>>>;
  rics_k50?: Maybe<Array<Maybe<RicsRefInfo>>>;
  rics_k400?: Maybe<Array<Maybe<RicsRefInfo>>>;
  role_k50?: Maybe<Array<Maybe<RoleRefInfo>>>;
  role_k150?: Maybe<Array<Maybe<RoleRefInfo>>>;
  role_k300?: Maybe<Array<Maybe<RoleRefInfo>>>;
  role_k500?: Maybe<Array<Maybe<RoleRefInfo>>>;
  role_k1000?: Maybe<Array<Maybe<RoleRefInfo>>>;
  role_k1250?: Maybe<Array<Maybe<RoleRefInfo>>>;
  role_k1500?: Maybe<Array<Maybe<RoleRefInfo>>>;
  role_taxonomy_k10?: Maybe<Array<Maybe<RoleTaxonomyRefInfo>>>;
  role_taxonomy_k50?: Maybe<Array<Maybe<RoleTaxonomyRefInfo>>>;
  role_taxonomy_k150?: Maybe<Array<Maybe<RoleTaxonomyRefInfo>>>;
  role_taxonomy_k500?: Maybe<Array<Maybe<RoleTaxonomyRefInfo>>>;
  role_taxonomy_k1500?: Maybe<Array<Maybe<RoleTaxonomyRefInfo>>>;
  role_taxonomy_k5000?: Maybe<Array<Maybe<RoleTaxonomyRefInfo>>>;
  role_taxonomy_k10000?: Maybe<Array<Maybe<RoleTaxonomyRefInfo>>>;
  role_taxonomy_k15000?: Maybe<Array<Maybe<RoleTaxonomyRefInfo>>>;
  role_taxonomy_k17000?: Maybe<Array<Maybe<RoleTaxonomyRefInfo>>>;
  seniority?: Maybe<Array<Maybe<RefInfo>>>;
  skill_k25?: Maybe<Array<Maybe<SkillRefInfo>>>;
  skill_k50?: Maybe<Array<Maybe<SkillRefInfo>>>;
  skill_k75?: Maybe<Array<Maybe<SkillRefInfo>>>;
  skill_k700?: Maybe<Array<Maybe<SkillRefInfo>>>;
  skill_k2500?: Maybe<Array<Maybe<SkillRefInfo>>>;
  skill_k3000?: Maybe<Array<Maybe<SkillRefInfo>>>;
  skill_mapped?: Maybe<Array<Maybe<SkillRefInfo>>>;
  skill_taxonomies: SkillTaxs;
  skill_taxonomy: SkillLevel;
  state?: Maybe<Array<Maybe<GeoRefInfo>>>;
  week?: Maybe<Array<Maybe<WeekRefInfo>>>;
};

export type SelectionListRole_Taxonomy_K10Args = {
  taxonomy_id?: InputMaybe<CustomRoleTaxonomySelection>;
};

export type SelectionListRole_Taxonomy_K50Args = {
  taxonomy_id?: InputMaybe<CustomRoleTaxonomySelection>;
};

export type SelectionListRole_Taxonomy_K150Args = {
  taxonomy_id?: InputMaybe<CustomRoleTaxonomySelection>;
};

export type SelectionListRole_Taxonomy_K500Args = {
  taxonomy_id?: InputMaybe<CustomRoleTaxonomySelection>;
};

export type SelectionListRole_Taxonomy_K1500Args = {
  taxonomy_id?: InputMaybe<CustomRoleTaxonomySelection>;
};

export type SelectionListRole_Taxonomy_K5000Args = {
  taxonomy_id?: InputMaybe<CustomRoleTaxonomySelection>;
};

export type SelectionListRole_Taxonomy_K10000Args = {
  taxonomy_id?: InputMaybe<CustomRoleTaxonomySelection>;
};

export type SelectionListRole_Taxonomy_K15000Args = {
  taxonomy_id?: InputMaybe<CustomRoleTaxonomySelection>;
};

export type SelectionListRole_Taxonomy_K17000Args = {
  taxonomy_id?: InputMaybe<CustomRoleTaxonomySelection>;
};

export type SelectionListSkill_TaxonomyArgs = {
  taxonomy_select: SkillTaxSelect;
};

export enum SeniorityVersion {
  V1 = 'V1',
  V2_1 = 'V2_1',
}

export type SentimentDataPoint = {
  __typename?: 'SentimentDataPoint';
  count?: Maybe<Scalars['Int']['output']>;
  month_id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type SentimentMetrics = {
  __typename?: 'SentimentMetrics';
  benefits?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  business_outlook?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  career_growth?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  childcare?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  clients_and_customers?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  commission?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  commitment?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  commute?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  company_growth?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  compensation?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  compliance?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  coworkers?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  culture?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  diversity_and_inclusion?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  education_assistance?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  efficiency_and_bureaucracy?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  ethics?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  family_support?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  harassment?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  healthcare?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  honesty?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  independence?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  integrity?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  internal_communication?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  job_security?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  leadership?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  mentorship?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  mission_and_vision?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  office_politics?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  onboarding?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  overall?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  overtime?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  paid_time_off?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  prestige?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  product_and_service_quality?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  promotion_opportunities?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  remote_work?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  retirement_pension?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  safety?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  schedule_flexibility?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  technology?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  training?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  transparency?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  wellness_programs?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  work_life_balance?: Maybe<Array<Maybe<SentimentDataPoint>>>;
  workplace_facilities?: Maybe<Array<Maybe<SentimentDataPoint>>>;
};

export type SentimentResponseEntity = {
  __typename?: 'SentimentResponseEntity';
  metadata?: Maybe<Metadata>;
  months_refs?: Maybe<Array<Maybe<Metadata>>>;
  result?: Maybe<SentimentResult>;
};

export type SentimentResult = {
  __typename?: 'SentimentResult';
  scores?: Maybe<SentimentMetrics>;
};

export type SentimentV2Filters = {
  city?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  company?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  country?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  custom_role?: InputMaybe<CustomRoleFilter>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  job_category?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  min_reviews?: InputMaybe<Scalars['Int']['input']>;
  msa?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  overall?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  region?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  rics_k10?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  rics_k50?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  rics_k400?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role_k50?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role_k150?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role_k1500?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role_k15000?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  seniority?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type SentimentV3DataPoint = {
  __typename?: 'SentimentV3DataPoint';
  count: Scalars['Int']['output'];
  month_id: Scalars['Int']['output'];
  value?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type SentimentV3Ent = {
  EntID: Scalars['Int']['input'];
  EntType: EntKind;
};

export type SentimentV3Filters = {
  city?: InputMaybe<Array<Scalars['Int']['input']>>;
  company?: InputMaybe<Array<Scalars['Int']['input']>>;
  country?: InputMaybe<Array<Scalars['Int']['input']>>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  min_reviews?: InputMaybe<Scalars['Int']['input']>;
  msa?: InputMaybe<Array<Scalars['Int']['input']>>;
  overall?: InputMaybe<Array<Scalars['Int']['input']>>;
  region?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k10?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k50?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k400?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_1?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_2?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_3?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_4?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_5?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_6?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_7?: InputMaybe<Array<Scalars['Int']['input']>>;
  seniority?: InputMaybe<Array<Scalars['Int']['input']>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SentimentV3Req = {
  cache_options?: InputMaybe<ResponseCacheOptions>;
  entities: Array<SentimentV3Ent>;
  filters: SentimentV3Filters;
  role_taxonomy: Scalars['Int']['input'];
  skill_taxonomy: Scalars['Int']['input'];
};

export type SentimentV3Resp = {
  __typename?: 'SentimentV3Resp';
  entities: Array<SentimentV3RespEnt>;
};

export type SentimentV3RespData = {
  __typename?: 'SentimentV3RespData';
  benefits: Array<SentimentV3DataPoint>;
  business_outlook: Array<SentimentV3DataPoint>;
  career_growth: Array<SentimentV3DataPoint>;
  childcare: Array<SentimentV3DataPoint>;
  clients_and_customers: Array<SentimentV3DataPoint>;
  commission: Array<SentimentV3DataPoint>;
  commitment: Array<SentimentV3DataPoint>;
  commute: Array<SentimentV3DataPoint>;
  company_growth: Array<SentimentV3DataPoint>;
  compensation: Array<SentimentV3DataPoint>;
  compliance: Array<SentimentV3DataPoint>;
  coworkers: Array<SentimentV3DataPoint>;
  culture: Array<SentimentV3DataPoint>;
  diversity_and_inclusion: Array<SentimentV3DataPoint>;
  education_assistance: Array<SentimentV3DataPoint>;
  efficiency_and_bureaucracy: Array<SentimentV3DataPoint>;
  ethics: Array<SentimentV3DataPoint>;
  family_support: Array<SentimentV3DataPoint>;
  harassment: Array<SentimentV3DataPoint>;
  healthcare: Array<SentimentV3DataPoint>;
  honesty: Array<SentimentV3DataPoint>;
  independence: Array<SentimentV3DataPoint>;
  integrity: Array<SentimentV3DataPoint>;
  internal_communication: Array<SentimentV3DataPoint>;
  job_security: Array<SentimentV3DataPoint>;
  leadership: Array<SentimentV3DataPoint>;
  mentorship: Array<SentimentV3DataPoint>;
  mission_and_vision: Array<SentimentV3DataPoint>;
  office_politics: Array<SentimentV3DataPoint>;
  onboarding: Array<SentimentV3DataPoint>;
  overall: Array<SentimentV3DataPoint>;
  overtime: Array<SentimentV3DataPoint>;
  paid_time_off: Array<SentimentV3DataPoint>;
  prestige: Array<SentimentV3DataPoint>;
  product_and_service_quality: Array<SentimentV3DataPoint>;
  promotion_opportunities: Array<SentimentV3DataPoint>;
  remote_work: Array<SentimentV3DataPoint>;
  retirement_pension: Array<SentimentV3DataPoint>;
  safety: Array<SentimentV3DataPoint>;
  schedule_flexibility: Array<SentimentV3DataPoint>;
  technology: Array<SentimentV3DataPoint>;
  training: Array<SentimentV3DataPoint>;
  transparency: Array<SentimentV3DataPoint>;
  wellness_programs: Array<SentimentV3DataPoint>;
  work_life_balance: Array<SentimentV3DataPoint>;
  workplace_facilities: Array<SentimentV3DataPoint>;
};

export type SentimentV3RespEnt = {
  __typename?: 'SentimentV3RespEnt';
  id: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
  long_name: Scalars['String']['output'];
  metrics: SentimentV3RespData;
  short_name: Scalars['String']['output'];
};

export enum SentimentVersion {
  V0 = 'V0',
  V2 = 'V2',
}

export type SetReportsValidationRequest = {
  report_validation?: InputMaybe<ReportValidationInput>;
};

export type SetUserClientGroupRequest = {
  client_id: Scalars['String']['input'];
  identity_id: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type SkillLabel = {
  __typename?: 'SkillLabel';
  label: Scalars['String']['output'];
  level_id: Scalars['Int']['output'];
  tag: Scalars['String']['output'];
};

export type SkillLevel = {
  __typename?: 'SkillLevel';
  label: SkillLabel;
  refs: Array<SkillRef>;
  tax_id: Scalars['Int']['output'];
  tax_name: Scalars['String']['output'];
  tax_version: Scalars['String']['output'];
};

export type SkillRef = {
  __typename?: 'SkillRef';
  id: Scalars['Int']['output'];
  long_name: Scalars['String']['output'];
  parents: Array<Scalars['Int']['output']>;
  short_name: Scalars['String']['output'];
  titles: Array<Scalars['String']['output']>;
};

export type SkillRefInfo = {
  __typename?: 'SkillRefInfo';
  dataUnavailableIn?: Maybe<ManifestKind>;
  id?: Maybe<Scalars['ID']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  parentID?: Maybe<Scalars['ID']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  skillMappedIndex?: Maybe<Scalars['ID']['output']>;
  skill_k25?: Maybe<Scalars['ID']['output']>;
  skill_k50?: Maybe<Scalars['ID']['output']>;
  skill_k75?: Maybe<Scalars['ID']['output']>;
  skill_k700?: Maybe<Scalars['ID']['output']>;
  skill_k2500?: Maybe<Scalars['ID']['output']>;
  skill_k3000?: Maybe<Scalars['ID']['output']>;
  skill_mapped?: Maybe<Scalars['ID']['output']>;
  topSkills?: Maybe<Scalars['String']['output']>;
};

export type SkillTaxInfo = {
  __typename?: 'SkillTaxInfo';
  id: Scalars['Int']['output'];
  is_latest: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type SkillTaxSelect = {
  level_id: Scalars['Int']['input'];
  taxonomy_id: Scalars['Int']['input'];
};

export type SkillTaxs = {
  __typename?: 'SkillTaxs';
  labels_by_level: Array<SkillLabel>;
  taxs: Array<SkillTaxInfo>;
};

export type SnowflakeDelivery = {
  snowflake_db: Scalars['String']['input'];
  snowflake_file_prefix: Scalars['String']['input'];
  snowflake_schema: Scalars['String']['input'];
};

export type SnowflakeDeliveryOutput = {
  __typename?: 'SnowflakeDeliveryOutput';
  snowflake_db: Scalars['String']['output'];
  snowflake_file_prefix: Scalars['String']['output'];
  snowflake_schema: Scalars['String']['output'];
};

export enum Tab {
  Compensation = 'compensation',
  CustomPages = 'custom_pages',
  DataDictionary = 'data_dictionary',
  DataEnrichment = 'data_enrichment',
  Deliverables = 'deliverables',
  EntitySummary = 'entity_summary',
  JobAnalysis = 'job_analysis',
  JobAnalysisOverview = 'job_analysis_overview',
  JobEmbedding = 'job_embedding',
  Layoff = 'layoff',
  Overview = 'overview',
  Posting = 'posting',
  Reports = 'reports',
  ResumeParsing = 'resume_parsing',
  Screener = 'screener',
  Sentiment = 'sentiment',
  TalentDiscovery = 'talent_discovery',
  TalentDiscoveryV2 = 'talent_discovery_v2',
  TaxonomyApi = 'taxonomy_api',
  TaxonomyVisualizer = 'taxonomy_visualizer',
  Transition = 'transition',
}

export type TalentDiscoveryByIdReqFiltersV3 = {
  roles_tax?: InputMaybe<Scalars['String']['input']>;
  roles_tax_id?: InputMaybe<Scalars['Int']['input']>;
  skills_tax?: InputMaybe<Scalars['Int']['input']>;
  skills_tax_id?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentDiscoveryByIdReqV3 = {
  filters: TalentDiscoveryByIdReqFiltersV3;
  original_users_ids: Array<Scalars['Int']['input']>;
};

export type TalentDiscoveryByIdRespV3 = {
  __typename?: 'TalentDiscoveryByIdRespV3';
  users: Array<TalentDiscoveryByIdUserV3>;
};

export type TalentDiscoveryByIdUserV3 = {
  __typename?: 'TalentDiscoveryByIdUserV3';
  education: Scalars['String']['output'];
  education_history: Array<TalentDiscoveryEduHistoryItemV3>;
  first_name: Scalars['String']['output'];
  graduation_year?: Maybe<Scalars['Int']['output']>;
  last_name: Scalars['String']['output'];
  original_user_id: Scalars['Int']['output'];
  shard: Scalars['Int']['output'];
  user_id: Scalars['Int']['output'];
  user_location: Scalars['String']['output'];
  work_history: Array<TalentDiscoveryWorkHistoryItemV3>;
};

export type TalentDiscoveryEduHistoryItemV3 = {
  __typename?: 'TalentDiscoveryEduHistoryItemV3';
  end_date?: Maybe<Scalars['String']['output']>;
  rsid?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  university_name?: Maybe<Scalars['String']['output']>;
};

export type TalentDiscoveryEducation = {
  __typename?: 'TalentDiscoveryEducation';
  end_date?: Maybe<Scalars['String']['output']>;
  rsid?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  university_name?: Maybe<Scalars['String']['output']>;
};

export type TalentDiscoveryEntity = {
  __typename?: 'TalentDiscoveryEntity';
  RCID: Scalars['Int']['output'];
  current_company: Scalars['String']['output'];
  current_title: Scalars['String']['output'];
  email: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
  ethnicity: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  flight_risk: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  highest_degree: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  linkedin_url: Scalars['String']['output'];
  location: Scalars['String']['output'];
  longitude: Scalars['Float']['output'];
  personal_email: Scalars['String']['output'];
  phone_number?: Maybe<Scalars['String']['output']>;
  prestige: Scalars['String']['output'];
  remote_suitability: Scalars['String']['output'];
  salary_base: Scalars['Float']['output'];
  salary_total: Scalars['Float']['output'];
  start_date: Scalars['String']['output'];
  years_of_experience: Scalars['Float']['output'];
};

export type TalentDiscoveryNameRecNameV3 = {
  __typename?: 'TalentDiscoveryNameRecNameV3';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TalentDiscoveryNameRecRespV3 = {
  __typename?: 'TalentDiscoveryNameRecRespV3';
  names: Array<TalentDiscoveryNameRecNameV3>;
};

export type TalentDiscoveryReqFiltersV3 = {
  expr: UserNode;
  map_data_kind?: InputMaybe<MapDataKind>;
  roles_tax?: InputMaybe<Scalars['String']['input']>;
  skills_tax?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentDiscoveryReqOptionsV3 = {
  include_descriptions: Scalars['Boolean']['input'];
};

export type TalentDiscoveryReqPageV3 = {
  page_num: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
};

export type TalentDiscoveryReqV3 = {
  cache_options?: InputMaybe<ResponseCacheOptions>;
  filters: TalentDiscoveryReqFiltersV3;
  options?: InputMaybe<TalentDiscoveryReqOptionsV3>;
  pagination: TalentDiscoveryReqPageV3;
};

export type TalentDiscoveryRespGeoDataV3 = {
  __typename?: 'TalentDiscoveryRespGeoDataV3';
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
  map_data_kind: MapDataKind;
  share: Scalars['Float']['output'];
  type: Scalars['Int']['output'];
};

export type TalentDiscoveryRespPageV3 = {
  __typename?: 'TalentDiscoveryRespPageV3';
  tot_pages_num: Scalars['Int']['output'];
  tot_users_num: Scalars['Int']['output'];
};

export type TalentDiscoveryRespUserV3 = {
  __typename?: 'TalentDiscoveryRespUserV3';
  RCID: Scalars['Int']['output'];
  current_company: Scalars['String']['output'];
  current_title: Scalars['String']['output'];
  description: Scalars['String']['output'];
  education: Scalars['String']['output'];
  education_history: Array<TalentDiscoveryEduHistoryItemV3>;
  email: Scalars['String']['output'];
  employment_relationship: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
  ethnicity: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  flight_risk: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  graduation_year?: Maybe<Scalars['Int']['output']>;
  highest_degree: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  linkedin_url: Scalars['String']['output'];
  location: Scalars['String']['output'];
  longitude: Scalars['Float']['output'];
  original_user_id: Scalars['Int']['output'];
  personal_email: Scalars['String']['output'];
  phone_number: Scalars['String']['output'];
  prestige: Scalars['String']['output'];
  remote_suitability: Scalars['String']['output'];
  salary_base: Scalars['Float']['output'];
  salary_total: Scalars['Float']['output'];
  shard: Scalars['Int']['output'];
  skills: Array<Scalars['String']['output']>;
  start_date: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
  user_location: Scalars['String']['output'];
  work_history: Array<TalentDiscoveryWorkHistoryItemV3>;
  work_schedule: Scalars['String']['output'];
  years_of_experience: Scalars['Float']['output'];
};

export type TalentDiscoveryRespV3 = {
  __typename?: 'TalentDiscoveryRespV3';
  columns: Array<Scalars['String']['output']>;
  map_data?: Maybe<Array<Maybe<TalentDiscoveryRespGeoDataV3>>>;
  pagination?: Maybe<TalentDiscoveryRespPageV3>;
  users?: Maybe<Array<Maybe<TalentDiscoveryRespUserV3>>>;
};

export type TalentDiscoveryUser = {
  __typename?: 'TalentDiscoveryUser';
  RCID: Scalars['Int']['output'];
  current_company: Scalars['String']['output'];
  current_title: Scalars['String']['output'];
  education: Scalars['String']['output'];
  education_history?: Maybe<Array<Maybe<TalentDiscoveryEducation>>>;
  email: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
  ethnicity: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  flight_risk: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  graduation_year?: Maybe<Scalars['Int']['output']>;
  highest_degree: Scalars['String']['output'];
  history: Array<TalentDiscoveryEntity>;
  last_name: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  linkedin_url: Scalars['String']['output'];
  location: Scalars['String']['output'];
  longitude: Scalars['Float']['output'];
  personal_email: Scalars['String']['output'];
  phone_number?: Maybe<Scalars['String']['output']>;
  prestige: Scalars['String']['output'];
  remote_suitability: Scalars['String']['output'];
  salary_base?: Maybe<Scalars['Float']['output']>;
  salary_total?: Maybe<Scalars['Float']['output']>;
  start_date: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
  user_location: Scalars['String']['output'];
  years_of_experience: Scalars['Float']['output'];
};

export type TalentDiscoveryV2CustomRoleFilter = {
  current: Scalars['Boolean']['input'];
  entities?: InputMaybe<Array<InputMaybe<CustomRoleFilterElement>>>;
  taxonomyId?: InputMaybe<CustomRoleTaxonomySelection>;
};

export type TalentDiscoveryV2CustomSkillFilter = {
  entities?: InputMaybe<
    Array<InputMaybe<Array<InputMaybe<CustomSkillEntity>>>>
  >;
  from_new_refs?: InputMaybe<Scalars['Boolean']['input']>;
  taxonomy_id: Scalars['Int']['input'];
};

export type TalentDiscoveryV2EduHistoryItem = {
  __typename?: 'TalentDiscoveryV2EduHistoryItem';
  end_date?: Maybe<Scalars['String']['output']>;
  rsid?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  university_name?: Maybe<Scalars['String']['output']>;
};

export type TalentDiscoveryV2NameRecommendationResp = {
  __typename?: 'TalentDiscoveryV2NameRecommendationResp';
  names?: Maybe<Array<Scalars['String']['output']>>;
  num_results: Scalars['Int']['output'];
};

export type TalentDiscoveryV2ReqFilters = {
  company_id?: InputMaybe<Array<FilterWithCurrent>>;
  custom_role?: InputMaybe<TalentDiscoveryV2CustomRoleFilter>;
  custom_skill?: InputMaybe<TalentDiscoveryV2CustomSkillFilter>;
  ethnicity?: InputMaybe<Array<Scalars['Int']['input']>>;
  flight_risk?: InputMaybe<Array<FilterWithCurrent>>;
  free_texts?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  gender?: InputMaybe<Array<Scalars['Int']['input']>>;
  geo_group?: InputMaybe<Array<FilterWithCurrentAndTag>>;
  graduation_year?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
  highest_degree?: InputMaybe<Array<Scalars['Int']['input']>>;
  industry?: InputMaybe<Array<FilterWithCurrent>>;
  name?: InputMaybe<Scalars['String']['input']>;
  prestige?: InputMaybe<Array<FilterWithCurrent>>;
  rcid?: InputMaybe<Array<FilterWithCurrent>>;
  remote_suitability?: InputMaybe<Array<FilterWithCurrent>>;
  rics_group?: InputMaybe<Array<FilterWithCurrentAndTag>>;
  role_group?: InputMaybe<Array<FilterWithCurrentAndTag>>;
  rsid?: InputMaybe<Array<Scalars['Int']['input']>>;
  salary_base?: InputMaybe<FilterSalary>;
  salary_total?: InputMaybe<FilterSalary>;
  seniority?: InputMaybe<Array<FilterWithCurrent>>;
  titles?: InputMaybe<Array<TitleSet>>;
  user_geo_group?: InputMaybe<Array<FilterWithTag>>;
  years_of_experience?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
};

export type TalentDiscoveryV2ReqPagination = {
  page_num: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
};

export type TalentDiscoveryV2RespGeoData = {
  __typename?: 'TalentDiscoveryV2RespGeoData';
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
  share: Scalars['Float']['output'];
  type: Scalars['Int']['output'];
};

export type TalentDiscoveryV2RespPagination = {
  __typename?: 'TalentDiscoveryV2RespPagination';
  tot_pages_num: Scalars['Int']['output'];
};

export type TalentDiscoveryV2RespUser = {
  __typename?: 'TalentDiscoveryV2RespUser';
  RCID: Scalars['Int']['output'];
  current_company: Scalars['String']['output'];
  current_title: Scalars['String']['output'];
  education: Scalars['String']['output'];
  education_history: Array<TalentDiscoveryV2EduHistoryItem>;
  email: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
  ethnicity: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  flight_risk: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  graduation_year?: Maybe<Scalars['Int']['output']>;
  highest_degree: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  linkedin_url: Scalars['String']['output'];
  location: Scalars['String']['output'];
  longitude: Scalars['Float']['output'];
  personal_email: Scalars['String']['output'];
  phone_number: Scalars['String']['output'];
  prestige: Scalars['String']['output'];
  remote_suitability: Scalars['String']['output'];
  salary_base: Scalars['Float']['output'];
  salary_total: Scalars['Float']['output'];
  start_date: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
  user_location: Scalars['String']['output'];
  work_history: Array<TalentDiscoveryV2WorkHistoryItem>;
  years_of_experience: Scalars['Float']['output'];
};

export type TalentDiscoveryV2SearchReq = {
  filters: TalentDiscoveryV2ReqFilters;
  pagination: TalentDiscoveryV2ReqPagination;
};

export type TalentDiscoveryV2SearchResp = {
  __typename?: 'TalentDiscoveryV2SearchResp';
  columns: Array<Scalars['String']['output']>;
  map_data?: Maybe<Array<Maybe<TalentDiscoveryV2RespGeoData>>>;
  pagination?: Maybe<TalentDiscoveryV2RespPagination>;
  users?: Maybe<Array<Maybe<TalentDiscoveryV2RespUser>>>;
};

export enum TalentDiscoveryV2Tags {
  City = 'CITY',
  Country = 'COUNTRY',
  MappedRole = 'MAPPED_ROLE',
  Msa = 'MSA',
  Region = 'REGION',
  RicsK10 = 'RICS_K10',
  RicsK50 = 'RICS_K50',
  RicsK400 = 'RICS_K400',
  RoleK7 = 'ROLE_K7',
  RoleK150 = 'ROLE_K150',
  RoleK1500 = 'ROLE_K1500',
  RoleK15000 = 'ROLE_K15000',
  UserCity = 'USER_CITY',
  UserCountry = 'USER_COUNTRY',
  UserMsa = 'USER_MSA',
  UserRegion = 'USER_REGION',
  UserState = 'USER_STATE',
}

export type TalentDiscoveryV2WorkHistoryItem = {
  __typename?: 'TalentDiscoveryV2WorkHistoryItem';
  RCID: Scalars['Int']['output'];
  current_company: Scalars['String']['output'];
  current_title: Scalars['String']['output'];
  email: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
  ethnicity: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  flight_risk: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  highest_degree: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  linkedin_url: Scalars['String']['output'];
  location: Scalars['String']['output'];
  longitude: Scalars['Float']['output'];
  personal_email: Scalars['String']['output'];
  phone_number: Scalars['String']['output'];
  prestige: Scalars['String']['output'];
  remote_suitability: Scalars['String']['output'];
  salary_base: Scalars['Float']['output'];
  salary_total: Scalars['Float']['output'];
  start_date: Scalars['String']['output'];
  years_of_experience: Scalars['Float']['output'];
};

export type TalentDiscoveryWorkHistoryItemV3 = {
  __typename?: 'TalentDiscoveryWorkHistoryItemV3';
  RCID: Scalars['Int']['output'];
  current_company: Scalars['String']['output'];
  current_title: Scalars['String']['output'];
  description: Scalars['String']['output'];
  email: Scalars['String']['output'];
  employment_relationship: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
  ethnicity: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  flight_risk: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  highest_degree: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  linkedin_url: Scalars['String']['output'];
  location: Scalars['String']['output'];
  longitude: Scalars['Float']['output'];
  personal_email: Scalars['String']['output'];
  phone_number: Scalars['String']['output'];
  prestige: Scalars['String']['output'];
  remote_suitability: Scalars['String']['output'];
  salary_base: Scalars['Float']['output'];
  salary_total: Scalars['Float']['output'];
  skills: Array<Scalars['String']['output']>;
  start_date: Scalars['String']['output'];
  work_schedule: Scalars['String']['output'];
  years_of_experience: Scalars['Float']['output'];
};

export type Taxonomy = {
  __typename?: 'Taxonomy';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type TaxonomyLatestVersionRequest = {
  taxonomy_type: TaxonomyType;
};

export type TaxonomyLatestVersionResponse = {
  __typename?: 'TaxonomyLatestVersionResponse';
  version: Scalars['String']['output'];
};

export type TaxonomyLevel = {
  __typename?: 'TaxonomyLevel';
  default_ids?: Maybe<Array<Scalars['Int']['output']>>;
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type TaxonomyListRequest = {
  taxonomy_type: TaxonomyType;
  taxonomy_version?: InputMaybe<Scalars['String']['input']>;
};

export type TaxonomyListResponse = {
  __typename?: 'TaxonomyListResponse';
  taxonomies: Array<Taxonomy>;
};

export type TaxonomyNode = {
  __typename?: 'TaxonomyNode';
  children?: Maybe<Array<TaxonomyNode>>;
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  titles?: Maybe<Array<Scalars['String']['output']>>;
};

export type TaxonomyRequest = {
  levels?: InputMaybe<Array<Scalars['Int']['input']>>;
  taxonomy_id: Scalars['Int']['input'];
  taxonomy_type: TaxonomyType;
  taxonomy_version?: InputMaybe<Scalars['String']['input']>;
};

export type TaxonomyResponse = {
  __typename?: 'TaxonomyResponse';
  levels: Array<TaxonomyLevel>;
  nodes: Array<TaxonomyNode>;
};

export enum TaxonomyType {
  Geography = 'GEOGRAPHY',
  Rics = 'RICS',
  Role = 'ROLE',
  Skill = 'SKILL',
}

export type TaxonomyVersionsRequest = {
  taxonomy_type: TaxonomyType;
};

export type TaxonomyVersionsResponse = {
  __typename?: 'TaxonomyVersionsResponse';
  versions: Array<Scalars['String']['output']>;
};

export enum TimescalingVersion {
  V3_1 = 'V3_1',
  V3_2 = 'V3_2',
  V3_3 = 'V3_3',
}

export type TitleSet = {
  curr: Scalars['Boolean']['input'];
  titles: Array<Scalars['String']['input']>;
};

export type TransitionConfiguration = {
  exclude_external?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_internal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TransitionConfigurationOutput = {
  __typename?: 'TransitionConfigurationOutput';
  exclude_external?: Maybe<Scalars['Boolean']['output']>;
  exclude_internal?: Maybe<Scalars['Boolean']['output']>;
};

export type TransitionsBreakdowns = {
  __typename?: 'TransitionsBreakdowns';
  education: Array<BrkCounts>;
  ethnicity: Array<BrkCounts>;
  gender: Array<BrkCounts>;
  geography: Array<BrkCounts>;
  rics: Array<BrkCounts>;
  role: Array<BrkCounts>;
  seniority: Array<BrkCounts>;
};

export type TransitionsEntRespV2 = {
  __typename?: 'TransitionsEntRespV2';
  metadata: EntMetadata;
  metrics: TransitionsV2EntData;
};

export enum TransitionsEntityKind {
  City = 'CITY',
  Company = 'COMPANY',
  Country = 'COUNTRY',
  Msa = 'MSA',
  Region = 'REGION',
  RicsK10 = 'RICS_K10',
  RicsK50 = 'RICS_K50',
  RicsK400 = 'RICS_K400',
  RoleK7 = 'ROLE_K7',
  RoleK150 = 'ROLE_K150',
  RoleK1500 = 'ROLE_K1500',
  RoleK15000 = 'ROLE_K15000',
  State = 'STATE',
}

export type TransitionsFiltersV2 = {
  city?: InputMaybe<Array<Scalars['Int']['input']>>;
  company?: InputMaybe<Array<Scalars['Int']['input']>>;
  contingent_workers?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Array<Scalars['Int']['input']>>;
  custom_role?: InputMaybe<CustomRoleFilter>;
  custom_skill?: InputMaybe<CustomSkillFilter>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<Array<Scalars['Int']['input']>>;
  gender?: InputMaybe<Array<Scalars['Int']['input']>>;
  highest_degree?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  msa?: InputMaybe<Array<Scalars['Int']['input']>>;
  raw_title?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  region?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k10?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k50?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k400?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_k7?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_k150?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_k1500?: InputMaybe<Array<Scalars['Int']['input']>>;
  seniority?: InputMaybe<Array<Scalars['Int']['input']>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TransitionsFlows = {
  __typename?: 'TransitionsFlows';
  inflows: Array<FlowsCounts>;
  inflows_remaining: FlowsCounts;
  outflows: Array<FlowsCounts>;
  outflows_remaining: FlowsCounts;
};

export type TransitionsOptions = {
  geo_breakdown_state_over_msa?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TransitionsReqEntV2 = {
  EntID: Scalars['Int']['input'];
  EntType: TransitionsEntityKind;
};

export type TransitionsReqV2 = {
  cache_options?: InputMaybe<ResponseCacheOptions>;
  entities: Array<TransitionsReqEntV2>;
  filters: TransitionsFiltersV2;
  options?: InputMaybe<TransitionsOptions>;
};

export type TransitionsRespV2 = {
  __typename?: 'TransitionsRespV2';
  entities: Array<TransitionsEntRespV2>;
};

export type TransitionsV2EntData = {
  __typename?: 'TransitionsV2EntData';
  breakdowns: TransitionsBreakdowns;
  flows: TransitionsFlows;
};

export type TransitionsV3BreakdownOptions = {
  geo_breakdown_level: EntKind;
  rics_breakdown_level: EntKind;
  role_breakdown_level: EntKind;
  with_contingent_workers: Scalars['Boolean']['input'];
};

export type TransitionsV3Breakdowns = {
  __typename?: 'TransitionsV3Breakdowns';
  education: Array<TransitionsV3BrkItem>;
  ethnicity: Array<TransitionsV3BrkItem>;
  gender: Array<TransitionsV3BrkItem>;
  geography: Array<TransitionsV3BrkItem>;
  rics: Array<TransitionsV3BrkItem>;
  role: Array<TransitionsV3BrkItem>;
  seniority: Array<TransitionsV3BrkItem>;
};

export type TransitionsV3BrkItem = {
  __typename?: 'TransitionsV3BrkItem';
  count: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  long_name: Scalars['String']['output'];
  share: Scalars['Float']['output'];
  short_name: Scalars['String']['output'];
};

export type TransitionsV3Ent = {
  EntID: Scalars['Int']['input'];
  EntType: EntKind;
};

export type TransitionsV3Filters = {
  city?: InputMaybe<Array<Scalars['Int']['input']>>;
  company?: InputMaybe<Array<Scalars['Int']['input']>>;
  country?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<Array<Scalars['Int']['input']>>;
  gender?: InputMaybe<Array<Scalars['Int']['input']>>;
  highest_degree?: InputMaybe<Array<Scalars['Int']['input']>>;
  msa?: InputMaybe<Array<Scalars['Int']['input']>>;
  region?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k10?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k50?: InputMaybe<Array<Scalars['Int']['input']>>;
  rics_k400?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_1?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_2?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_3?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_4?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_5?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_6?: InputMaybe<Array<Scalars['Int']['input']>>;
  role_level_7?: InputMaybe<Array<Scalars['Int']['input']>>;
  seniority?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_1?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_2?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_3?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_4?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_5?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_6?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_7?: InputMaybe<Array<Scalars['Int']['input']>>;
  skills_level_8?: InputMaybe<Array<Scalars['Int']['input']>>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

export type TransitionsV3Flows = {
  __typename?: 'TransitionsV3Flows';
  items: Array<TransitionsV3FlowsItem>;
};

export type TransitionsV3FlowsItem = {
  __typename?: 'TransitionsV3FlowsItem';
  count: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  long_name: Scalars['String']['output'];
  share: Scalars['Float']['output'];
  short_name: Scalars['String']['output'];
};

export type TransitionsV3Req = {
  breakdown_options: TransitionsV3BreakdownOptions;
  cache_options?: InputMaybe<ResponseCacheOptions>;
  entities: Array<TransitionsV3Ent>;
  filters: TransitionsV3Filters;
  role_taxonomy: Scalars['Int']['input'];
  skill_taxonomy: Scalars['Int']['input'];
};

export type TransitionsV3Resp = {
  __typename?: 'TransitionsV3Resp';
  entities: Array<TransitionsV3RespEnt>;
};

export type TransitionsV3RespData = {
  __typename?: 'TransitionsV3RespData';
  breakdowns_current: TransitionsV3Breakdowns;
  breakdowns_inflows: TransitionsV3Breakdowns;
  breakdowns_outflows: TransitionsV3Breakdowns;
  flows_inflows: TransitionsV3Flows;
  flows_outflows: TransitionsV3Flows;
};

export type TransitionsV3RespEnt = {
  __typename?: 'TransitionsV3RespEnt';
  id: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
  long_name: Scalars['String']['output'];
  metrics: TransitionsV3RespData;
  short_name: Scalars['String']['output'];
};

export type UpdateDeliverableConfigRequest = {
  batchTime?: InputMaybe<Scalars['String']['input']>;
  cacheValue?: InputMaybe<Scalars['String']['input']>;
  imageName?: InputMaybe<Scalars['String']['input']>;
  isLocal?: InputMaybe<Scalars['Boolean']['input']>;
  jobUpdateInterval?: InputMaybe<Scalars['String']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  reports_env?: InputMaybe<Scalars['String']['input']>;
  reports_image?: InputMaybe<Scalars['String']['input']>;
  reports_namespace?: InputMaybe<Scalars['String']['input']>;
  testDeliverable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateIndexRequest = {
  endMonthIndex?: InputMaybe<Scalars['Int']['input']>;
  endWeekIndex?: InputMaybe<Scalars['Int']['input']>;
  maxWeekIndex?: InputMaybe<Scalars['Int']['input']>;
  startMonthIndex?: InputMaybe<Scalars['Int']['input']>;
  startWeekIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateManifestValues = {
  competitorsV2?: InputMaybe<Scalars['String']['input']>;
  delay?: InputMaybe<Scalars['Int']['input']>;
  positionsCountsV2?: InputMaybe<Scalars['String']['input']>;
  positionsV2?: InputMaybe<Scalars['String']['input']>;
  positionsV3?: InputMaybe<Scalars['String']['input']>;
  postingDiscovery?: InputMaybe<Scalars['String']['input']>;
  postingsV2?: InputMaybe<Scalars['String']['input']>;
  postingsV3?: InputMaybe<Scalars['String']['input']>;
  refs?: InputMaybe<Scalars['String']['input']>;
  screenerCompany?: InputMaybe<Scalars['String']['input']>;
  screenerMSA?: InputMaybe<Scalars['String']['input']>;
  screenerMappedRole?: InputMaybe<Scalars['String']['input']>;
  sentimentV2?: InputMaybe<Scalars['String']['input']>;
  sentimentV3?: InputMaybe<Scalars['String']['input']>;
  talentDiscoveryContacts?: InputMaybe<Scalars['String']['input']>;
  transitionsInflowsV2?: InputMaybe<Scalars['String']['input']>;
  transitionsOutflowsV2?: InputMaybe<Scalars['String']['input']>;
  transitionsV3?: InputMaybe<Scalars['String']['input']>;
  usersSearch?: InputMaybe<Scalars['String']['input']>;
  usersSearchV2?: InputMaybe<Scalars['String']['input']>;
  usersSearchV3?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePresetRequest = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  view?: InputMaybe<View>;
};

export type UpdateStatusDeliverableInput = {
  delivery_id: Scalars['Int']['input'];
  status: DeliveryStatus;
};

export type User = {
  __typename?: 'User';
  active?: Maybe<Scalars['Boolean']['output']>;
  client_metadata?: Maybe<Array<Maybe<KeyValueResp>>>;
  client_name?: Maybe<Scalars['String']['output']>;
  company_lists?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  currency_data?: Maybe<CurrencyRefInfo>;
  custom_taxonomy?: Maybe<CustomTaxonomyEnum>;
  deliverables?: Maybe<Array<ClientDeliverableOutput>>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  legacy_id?: Maybe<Scalars['String']['output']>;
  linkup_postings?: Maybe<Scalars['Boolean']['output']>;
  live?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Array<Maybe<KeyValueResp>>>;
  name?: Maybe<Scalars['String']['output']>;
  num_seats?: Maybe<Scalars['String']['output']>;
  reports?: Maybe<Array<Report>>;
  resumes?: Maybe<Array<Resume>>;
  role?: Maybe<Role>;
  tabs?: Maybe<Array<Tab>>;
  unified_postings?: Maybe<Scalars['Boolean']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserAndNode = {
  children: Array<UserNode>;
};

export enum UserCategoryKind {
  Ethnicity = 'ETHNICITY',
  Gender = 'GENDER',
  HighestDegree = 'HIGHEST_DEGREE',
  SkillLvl_1 = 'SKILL_LVL_1',
  SkillLvl_2 = 'SKILL_LVL_2',
  SkillLvl_3 = 'SKILL_LVL_3',
  SkillLvl_4 = 'SKILL_LVL_4',
  SkillLvl_5 = 'SKILL_LVL_5',
  UserCity = 'USER_CITY',
  UserCountry = 'USER_COUNTRY',
  UserMsa = 'USER_MSA',
  UserRegion = 'USER_REGION',
  UserState = 'USER_STATE',
}

export enum UserExprTextKind {
  Desc = 'DESC',
  Name = 'NAME',
}

export type UserNode = {
  user_and?: InputMaybe<UserAndNode>;
  user_not?: InputMaybe<UserNotNode>;
  user_or?: InputMaybe<UserOrNode>;
  user_value?: InputMaybe<UserValNode>;
};

export type UserNotNode = {
  child: UserNode;
};

export type UserOrNode = {
  children: Array<UserNode>;
};

export enum UserRangeKind {
  GraduationYear = 'GRADUATION_YEAR',
  YearsOfExp = 'YEARS_OF_EXP',
}

export type UserRequest = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  client_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  legacy_id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<InputMaybe<KeyValue>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserValNode = {
  child: ExprNode;
};

export enum View {
  Company = 'company',
  CompanyScreener = 'company_screener',
  Geography = 'geography',
  GeographyScreener = 'geography_screener',
  Role = 'role',
  RoleScreener = 'role_screener',
  TalentDiscovery = 'talent_discovery',
}

export type WeekRefInfo = {
  __typename?: 'WeekRefInfo';
  dataUnavailableIn?: Maybe<ManifestKind>;
  id?: Maybe<Scalars['ID']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  monthId?: Maybe<Scalars['ID']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export enum WeightTable {
  V2 = 'V2',
  V2_1 = 'V2_1',
}

export type GetUserSimpleDetailsQueryVariables = Exact<{
  ids?: InputMaybe<
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type GetUserSimpleDetailsQuery = {
  __typename?: 'Query';
  users?: Array<{
    __typename?: 'User';
    id?: string | null;
    active?: boolean | null;
    name?: string | null;
    username?: string | null;
    role?: Role | null;
  } | null> | null;
};

export type GetBasicUserDetailsQueryVariables = Exact<{
  ids?: InputMaybe<
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type GetBasicUserDetailsQuery = {
  __typename?: 'Query';
  users?: Array<{
    __typename?: 'User';
    id?: string | null;
    client_name?: string | null;
    active?: boolean | null;
  } | null> | null;
};

export type AllClientsQueryVariables = Exact<{ [key: string]: never }>;

export type AllClientsQuery = {
  __typename?: 'Query';
  clients?: Array<{
    __typename?: 'Client';
    client_name?: string | null;
  } | null> | null;
};

export type GetAllClientAndUsersQueryVariables = Exact<{
  ids:
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>;
}>;

export type GetAllClientAndUsersQuery = {
  __typename?: 'Query';
  clients?: Array<{
    __typename?: 'Client';
    live: boolean;
    active: boolean;
    client_name?: string | null;
    num_seats: string;
    users?: Array<{
      __typename?: 'User';
      email?: string | null;
      live?: boolean | null;
      active?: boolean | null;
    } | null> | null;
  } | null> | null;
};

export type DecryptTalentDiscoveryDataQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;

export type DecryptTalentDiscoveryDataQuery = {
  __typename?: 'Query';
  decryptString: string;
};

export type GetNameRecommendationsQueryVariables = Exact<{
  query?: InputMaybe<TalentDiscoveryReqV3>;
}>;

export type GetNameRecommendationsQuery = {
  __typename?: 'Query';
  talent_discovery_name_recommendations_v3: {
    __typename?: 'TalentDiscoveryNameRecRespV3';
    names: Array<{
      __typename?: 'TalentDiscoveryNameRecNameV3';
      id: number;
      name: string;
    }>;
  };
};

export type DeliverablesUserSearchQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;

export type DeliverablesUserSearchQuery = {
  __typename?: 'Query';
  userSearch?: Array<{
    __typename?: 'User';
    id?: string | null;
    name?: string | null;
    email?: string | null;
    client_name?: string | null;
    active?: boolean | null;
    live?: boolean | null;
  } | null> | null;
};

export type AllClientsTableQueryVariables = Exact<{ [key: string]: never }>;

export type AllClientsTableQuery = {
  __typename?: 'Query';
  clients?: Array<{
    __typename?: 'Client';
    client_name?: string | null;
    active: boolean;
    num_seats: string;
    users?: Array<{ __typename?: 'User'; id?: string | null } | null> | null;
  } | null> | null;
};

export type CreateClientRewriteMutationVariables = Exact<{
  client_name: Scalars['String']['input'];
  tabs: Array<Tab> | Tab;
  live: Scalars['Boolean']['input'];
  active: Scalars['Boolean']['input'];
  linkup_postings: Scalars['Boolean']['input'];
  num_seats: Scalars['String']['input'];
  company_lists?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  metadata?: InputMaybe<Array<InputMaybe<KeyValue>> | InputMaybe<KeyValue>>;
  reports_configuration?: InputMaybe<ClientReportsConfigInput>;
  custom_taxonomy: CustomTaxonomyEnum;
}>;

export type CreateClientRewriteMutation = {
  __typename?: 'Mutation';
  createClientGroup?: {
    __typename?: 'Client';
    client_name?: string | null;
  } | null;
};

export type AdminUserClientSearchQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;

export type AdminUserClientSearchQuery = {
  __typename?: 'Query';
  userSearch?: Array<{
    __typename?: 'User';
    id?: string | null;
    name?: string | null;
    email?: string | null;
    client_name?: string | null;
    active?: boolean | null;
    live?: boolean | null;
  } | null> | null;
};

export type AdminImpersonationUserSearchQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;

export type AdminImpersonationUserSearchQuery = {
  __typename?: 'Query';
  userSearch?: Array<{
    __typename?: 'User';
    id?: string | null;
    name?: string | null;
    username?: string | null;
    email?: string | null;
    client_name?: string | null;
    active?: boolean | null;
    live?: boolean | null;
    metadata?: Array<{
      __typename?: 'KeyValueResp';
      key?: MetadataKey | null;
      value?: string | null;
    } | null> | null;
  } | null> | null;
};

export type GetAllClientUsersQueryVariables = Exact<{
  clientName: Scalars['String']['input'];
}>;

export type GetAllClientUsersQuery = {
  __typename?: 'Query';
  clients?: Array<{
    __typename?: 'Client';
    users?: Array<{
      __typename?: 'User';
      id?: string | null;
      name?: string | null;
      username?: string | null;
      email?: string | null;
      live?: boolean | null;
      active?: boolean | null;
      legacy_id?: string | null;
    } | null> | null;
  } | null> | null;
};

export type GetAllClientsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllClientsQuery = {
  __typename?: 'Query';
  clients?: Array<{
    __typename?: 'Client';
    client_name?: string | null;
  } | null> | null;
};

export type GetClientDetailsQueryVariables = Exact<{
  ids:
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>;
}>;

export type GetClientDetailsQuery = {
  __typename?: 'Query';
  clients?: Array<{
    __typename?: 'Client';
    client_name?: string | null;
    company_lists?: Array<string> | null;
    active: boolean;
    tabs?: Array<Tab> | null;
    live: boolean;
    linkup_postings: boolean;
    num_seats: string;
    custom_taxonomy?: CustomTaxonomyEnum | null;
    metadata?: Array<{
      __typename?: 'KeyValueResp';
      key?: MetadataKey | null;
      value?: string | null;
    } | null> | null;
    data_builder_configuration?: {
      __typename?: 'PipelineClientConfig';
      client_group?: string | null;
      pipeline_type?: Array<PipelineType | null> | null;
      posting_source?: Array<PostingSource | null> | null;
      additional_permissions?: {
        __typename?: 'AdditionalPermissions';
        allow_cusip?: boolean | null;
        contact_info?: boolean | null;
      } | null;
      s3_location?: {
        __typename?: 'S3DeliveryOutput';
        s3_bucket: string;
        s3_file_prefix: string;
        s3_format: S3Format;
      } | null;
      snowflake_location?: {
        __typename?: 'SnowflakeDeliveryOutput';
        snowflake_db: string;
        snowflake_schema: string;
        snowflake_file_prefix: string;
      } | null;
    } | null;
    reports_configuration?: {
      __typename?: 'ClientReportsConfig';
      defaults: Array<ReportTypeEnum>;
      report_types: Array<ReportTypeEnum>;
      all_report_types: Array<string>;
    } | null;
  } | null> | null;
};

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  client_name?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<InputMaybe<KeyValue>> | InputMaybe<KeyValue>>;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser?: {
    __typename?: 'User';
    id?: string | null;
    name?: string | null;
    username?: string | null;
    email?: string | null;
    role?: Role | null;
    client_name?: string | null;
    live?: boolean | null;
    active?: boolean | null;
    tabs?: Array<Tab> | null;
    company_lists?: Array<string | null> | null;
    linkup_postings?: boolean | null;
    num_seats?: string | null;
    metadata?: Array<{
      __typename?: 'KeyValueResp';
      key?: MetadataKey | null;
      value?: string | null;
    } | null> | null;
  } | null;
};

export type AddUserMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  role: Role;
  client_name: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  metadata?: InputMaybe<Array<InputMaybe<KeyValue>> | InputMaybe<KeyValue>>;
}>;

export type AddUserMutation = {
  __typename?: 'Mutation';
  createUser: {
    __typename?: 'User';
    id?: string | null;
    name?: string | null;
    username?: string | null;
    email?: string | null;
    role?: Role | null;
    client_name?: string | null;
    live?: boolean | null;
    active?: boolean | null;
    tabs?: Array<Tab> | null;
    company_lists?: Array<string | null> | null;
    linkup_postings?: boolean | null;
    num_seats?: string | null;
    metadata?: Array<{
      __typename?: 'KeyValueResp';
      key?: MetadataKey | null;
      value?: string | null;
    } | null> | null;
  };
};

export type UpdateClientGroupRewriteMutationVariables = Exact<{
  client_name: Scalars['String']['input'];
  tabs: Array<Tab> | Tab;
  live: Scalars['Boolean']['input'];
  active: Scalars['Boolean']['input'];
  linkup_postings: Scalars['Boolean']['input'];
  num_seats: Scalars['String']['input'];
  metadata?: InputMaybe<Array<InputMaybe<KeyValue>> | InputMaybe<KeyValue>>;
  custom_taxonomy: CustomTaxonomyEnum;
  reports_configuration?: InputMaybe<ClientReportsConfigInput>;
}>;

export type UpdateClientGroupRewriteMutation = {
  __typename?: 'Mutation';
  updateClientGroup?: {
    __typename?: 'Client';
    client_name?: string | null;
    company_lists?: Array<string> | null;
    active: boolean;
    tabs?: Array<Tab> | null;
    live: boolean;
    linkup_postings: boolean;
    num_seats: string;
    custom_taxonomy?: CustomTaxonomyEnum | null;
  } | null;
};

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteUserMutation = {
  __typename?: 'Mutation';
  deleteUser?: boolean | null;
};

export type ApiKeyManagementQueryVariables = Exact<{
  input: IdentityInput;
}>;

export type ApiKeyManagementQuery = {
  __typename?: 'Query';
  availableApiKeyEndpoints: Array<ApiKeyEndpoint>;
  listApiKeys: {
    __typename?: 'ListApiKeyResponse';
    api_keys: Array<{
      __typename?: 'ApiKeyMetadata';
      api_key_id: string;
      created_at?: string | null;
      created_by?: string | null;
      created_by_name?: string | null;
      endpoints: Array<ApiKeyEndpoint>;
    }>;
  };
};

export type AvailableApiKeyEndpointsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AvailableApiKeyEndpointsQuery = {
  __typename?: 'Query';
  availableApiKeyEndpoints: Array<ApiKeyEndpoint>;
};

export type RegisterApiKeyMutationVariables = Exact<{
  input: RegisterApiKeyInput;
}>;

export type RegisterApiKeyMutation = {
  __typename?: 'Mutation';
  registerApiKey: {
    __typename?: 'RegisterApiKeyResponse';
    api_key?: string | null;
    api_key_id?: string | null;
  };
};

export type RemoveApiKeyMutationVariables = Exact<{
  input: RemoveApiKeyInput;
}>;

export type RemoveApiKeyMutation = {
  __typename?: 'Mutation';
  removeApiKey?: boolean | null;
};

export type GetGameResultsStatsV2QueryVariables = Exact<{
  entities: Array<CompositionV3Ent> | CompositionV3Ent;
  filters: CompositionV3Filters;
  corrections: CompositionV3Corrections;
  role_taxonomy: Scalars['Int']['input'];
  skill_taxonomy: Scalars['Int']['input'];
  breakdown_options: CompositionV3BreakdownOptions;
  filtersSentV2?: InputMaybe<SentimentV2Filters>;
  msa?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  role_k150?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  seniority?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  payReq?: InputMaybe<PayV2Req>;
}>;

export type GetGameResultsStatsV2Query = {
  __typename?: 'Query';
  rawComposition?: {
    __typename?: 'CompositionV3Resp';
    entities: Array<{
      __typename?: 'CompositionV3RespEnt';
      id: number;
      short_name: string;
      long_name: string;
      metrics: {
        __typename?: 'CompositionV3RespData';
        headcount: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        tenure: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        salary: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        growth_rate: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        hiring_rate: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        attrition_rate: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
      };
    }>;
  } | null;
  posting?: Array<{
    __typename: 'Posting2dResponse';
    metadata?: {
      __typename: 'Metadata';
      id?: number | null;
      shortName?: string | null;
      longName?: string | null;
    } | null;
    category?: Array<{
      __typename: 'Posting1dResponse';
      metadata?: {
        __typename: 'Metadata';
        id?: number | null;
        shortName?: string | null;
        longName?: string | null;
      } | null;
      metrics?: {
        __typename: 'PostingMetric';
        time_to_fill?: number | null;
        active?: number | null;
      } | null;
    } | null> | null;
  } | null> | null;
  sentiment?: Array<{
    __typename?: 'SentimentResponseEntity';
    result?: {
      __typename?: 'SentimentResult';
      scores?: {
        __typename?: 'SentimentMetrics';
        overall?: Array<{
          __typename: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
      } | null;
    } | null;
  } | null> | null;
  pay_v2?: {
    __typename?: 'PayV2Resp';
    entities: Array<{
      __typename?: 'PayV2EntResp';
      metadata: {
        __typename?: 'EntMetadata';
        id: number;
        short_name: string;
        long_name: string;
      };
      metrics: {
        __typename?: 'PayV2EntRespData';
        histogram: {
          __typename?: 'PayV2EntRespHistogram';
          index: number;
          total: Array<number>;
        };
      };
    }>;
  } | null;
};

export type CurrencySelectionListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CurrencySelectionListQuery = {
  __typename?: 'Query';
  selectionList?: {
    __typename?: 'SelectionList';
    currency?: Array<{
      __typename?: 'CurrencyRefInfo';
      id?: string | null;
      code?: string | null;
      name?: string | null;
      rate?: number | null;
      record_date?: string | null;
      effective_date?: string | null;
    } | null> | null;
  } | null;
};

export type CreateReportsMutationVariables = Exact<{
  input: CreateReportRequest;
}>;

export type CreateReportsMutation = {
  __typename?: 'Mutation';
  createReports?: {
    __typename?: 'CreateReportResponse';
    user_id?: string | null;
    report_id?: number | null;
  } | null;
};

export type DeleteReportMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteReportMutation = {
  __typename?: 'Mutation';
  deleteReport?: boolean | null;
};

export type RefreshReportMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type RefreshReportMutation = {
  __typename?: 'Mutation';
  refreshReport?: boolean | null;
};

export type GetUserResumesQueryVariables = Exact<{
  ids?: InputMaybe<
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type GetUserResumesQuery = {
  __typename?: 'Query';
  users?: Array<{
    __typename?: 'User';
    id?: string | null;
    resumes?: Array<{
      __typename?: 'Resume';
      resume_id: string;
      name: string;
      enriched_data?: string | null;
      download_link?: string | null;
    }> | null;
  } | null> | null;
};

export type GetResumeQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetResumeQuery = {
  __typename?: 'Query';
  getResume: {
    __typename?: 'Resume';
    resume_id: string;
    name: string;
    download_link?: string | null;
    enriched_data?: string | null;
  };
};

export type SaveResumeMutationVariables = Exact<{
  input: ResumeRequest;
}>;

export type SaveResumeMutation = {
  __typename?: 'Mutation';
  saveResume: {
    __typename?: 'Resume';
    resume_id: string;
    name: string;
    download_link?: string | null;
    excel_location?: string | null;
  };
};

export type DeleteResumeMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteResumeMutation = {
  __typename?: 'Mutation';
  deleteResume: boolean;
};

export type GetClientDetailsServerQueryVariables = Exact<{
  input?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
}>;

export type GetClientDetailsServerQuery = {
  __typename?: 'Query';
  clients?: Array<{
    __typename?: 'Client';
    client_name?: string | null;
    users?: Array<{
      __typename?: 'User';
      id?: string | null;
      email?: string | null;
    } | null> | null;
  } | null> | null;
};

export type UpdateUserServerMutationVariables = Exact<{
  input: UserRequest;
}>;

export type UpdateUserServerMutation = {
  __typename?: 'Mutation';
  updateUser?: { __typename?: 'User'; id?: string | null } | null;
};

export type UserSsoClientQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;

export type UserSsoClientQuery = {
  __typename?: 'Query';
  userSSOClient?: {
    __typename?: 'SSOClientResponse';
    client_group?: string | null;
    provider?: string | null;
  } | null;
};

export type CreateUserServerMutationVariables = Exact<{
  input: UserRequest;
}>;

export type CreateUserServerMutation = {
  __typename?: 'Mutation';
  createUser: { __typename?: 'User'; id?: string | null };
};

export type EntityV2HealthCheckQueryVariables = Exact<{
  req?: InputMaybe<EntityV2Req>;
}>;

export type EntityV2HealthCheckQuery = {
  __typename?: 'Query';
  entityV2?: {
    __typename?: 'EntityV2Resp';
    entity?: {
      __typename?: 'EntitySummary';
      name?: string | null;
      description?: string | null;
      founded?: string | null;
      headquarters?: string | null;
    } | null;
    competitors?: Array<{
      __typename?: 'EntityV2Competitors';
      id: number;
      shortName: string;
      longName: string;
      closeness: number;
    } | null> | null;
  } | null;
};

export type CompositionV3HealthCheckQueryVariables = Exact<{
  entities: Array<CompositionV3Ent> | CompositionV3Ent;
  filters: CompositionV3Filters;
  corrections: CompositionV3Corrections;
  role_taxonomy: Scalars['Int']['input'];
  skill_taxonomy: Scalars['Int']['input'];
  breakdown_options: CompositionV3BreakdownOptions;
}>;

export type CompositionV3HealthCheckQuery = {
  __typename?: 'Query';
  composition_v3?: {
    __typename?: 'CompositionV3Resp';
    entities: Array<{
      __typename?: 'CompositionV3RespEnt';
      id: number;
      short_name: string;
      long_name: string;
      metrics: {
        __typename?: 'CompositionV3RespData';
        headcount: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        growth_rate: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        hiring_rate: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        attrition_rate: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
      };
    }>;
  } | null;
};

export type TransitionsV2HealthCheckQueryVariables = Exact<{
  req?: InputMaybe<TransitionsReqV2>;
}>;

export type TransitionsV2HealthCheckQuery = {
  __typename?: 'Query';
  transitionsV2?: {
    __typename?: 'TransitionsRespV2';
    entities: Array<{
      __typename?: 'TransitionsEntRespV2';
      metadata: {
        __typename?: 'EntMetadata';
        id: number;
        short_name: string;
        long_name: string;
        type: string;
      };
      metrics: {
        __typename?: 'TransitionsV2EntData';
        flows: {
          __typename?: 'TransitionsFlows';
          inflows: Array<{
            __typename?: 'FlowsCounts';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          outflows: Array<{
            __typename?: 'FlowsCounts';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          inflows_remaining: {
            __typename?: 'FlowsCounts';
            count: number;
            share: number;
          };
          outflows_remaining: {
            __typename?: 'FlowsCounts';
            count: number;
            share: number;
          };
        };
      };
    }>;
  } | null;
};

export type SentimentHealthCheckQueryVariables = Exact<{
  filters?: InputMaybe<SentimentV2Filters>;
  dim1?: InputMaybe<Dimension1>;
}>;

export type SentimentHealthCheckQuery = {
  __typename?: 'Query';
  sentiment?: Array<{
    __typename?: 'SentimentResponseEntity';
    metadata?: {
      __typename?: 'Metadata';
      id?: number | null;
      shortName?: string | null;
      longName?: string | null;
      metadata_type?: string | null;
    } | null;
    result?: {
      __typename?: 'SentimentResult';
      scores?: {
        __typename?: 'SentimentMetrics';
        overall?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        business_outlook?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        career_growth?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
      } | null;
    } | null;
    months_refs?: Array<{
      __typename?: 'Metadata';
      id?: number | null;
      shortName?: string | null;
      longName?: string | null;
    } | null> | null;
  } | null> | null;
};

export type AuthHealthCheckQueryVariables = Exact<{
  ids?: InputMaybe<
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type AuthHealthCheckQuery = {
  __typename?: 'Query';
  users?: Array<{
    __typename?: 'User';
    id?: string | null;
    name?: string | null;
    username?: string | null;
    email?: string | null;
    role?: Role | null;
    client_name?: string | null;
    live?: boolean | null;
    active?: boolean | null;
    tabs?: Array<Tab> | null;
    company_lists?: Array<string | null> | null;
    linkup_postings?: boolean | null;
    unified_postings?: boolean | null;
    num_seats?: string | null;
    custom_taxonomy?: CustomTaxonomyEnum | null;
    metadata?: Array<{
      __typename?: 'KeyValueResp';
      key?: MetadataKey | null;
      value?: string | null;
    } | null> | null;
  } | null> | null;
};

export type SavedSetsHealthCheckQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SavedSetsHealthCheckQuery = {
  __typename?: 'Query';
  presets?: Array<{
    __typename?: 'Preset';
    id?: string | null;
    name?: string | null;
    view?: View | null;
    default?: boolean | null;
    shared?: boolean | null;
    filters?: string | null;
  } | null> | null;
};

export type SharedSelectionListHealthCheckQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SharedSelectionListHealthCheckQuery = {
  __typename?: 'Query';
  selectionList?: {
    __typename?: 'SelectionList';
    region?: Array<{
      __typename?: 'GeoRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      label?: string | null;
    } | null> | null;
    country?: Array<{
      __typename?: 'GeoRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      region?: Array<string | null> | null;
      label?: string | null;
    } | null> | null;
    state?: Array<{
      __typename?: 'GeoRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      region?: Array<string | null> | null;
      country?: Array<string | null> | null;
      label?: string | null;
    } | null> | null;
    metro_area?: Array<{
      __typename?: 'GeoRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      region?: Array<string | null> | null;
      country?: Array<string | null> | null;
      state?: Array<string | null> | null;
      label?: string | null;
    } | null> | null;
    job_category?: Array<{
      __typename?: 'RoleRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      topCleanedTitles?: string | null;
      topRawTitles?: string | null;
      label?: string | null;
    } | null> | null;
    role_k150?: Array<{
      __typename?: 'RoleRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      topCleanedTitles?: string | null;
      topRawTitles?: string | null;
      label?: string | null;
      job_category?: string | null;
      role_k50?: string | null;
    } | null> | null;
    seniority?: Array<{
      __typename?: 'RefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      label?: string | null;
    } | null> | null;
  } | null;
};

export type MonthWeekIndexHealthCheckQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MonthWeekIndexHealthCheckQuery = {
  __typename?: 'Query';
  index?: {
    __typename?: 'IndexValues';
    startMonthIndex?: number | null;
    endMonthIndex?: number | null;
    startWeekIndex?: number | null;
    endWeekIndex?: number | null;
    maxWeekIndex?: number | null;
    endMonth?: string | null;
    maxWeek?: string | null;
  } | null;
};

export type CompositionSummaryV3DataQueryVariables = Exact<{
  entities: Array<CompositionV3Ent> | CompositionV3Ent;
  filters: CompositionV3Filters;
  corrections: CompositionV3Corrections;
  role_taxonomy: Scalars['Int']['input'];
  skill_taxonomy: Scalars['Int']['input'];
  breakdown_options: CompositionV3BreakdownOptions;
}>;

export type CompositionSummaryV3DataQuery = {
  __typename?: 'Query';
  composition_v3?: {
    __typename?: 'CompositionV3Resp';
    entities: Array<{
      __typename?: 'CompositionV3RespEnt';
      id: number;
      short_name: string;
      long_name: string;
      metrics: {
        __typename?: 'CompositionV3RespData';
        headcount: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        growth_rate: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        hiring_rate: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        attrition_rate: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
      };
    }>;
  } | null;
};

export type EntityPostingsHealthCheckQueryVariables = Exact<{
  filters?: InputMaybe<PostingFilters>;
  dim1?: InputMaybe<Dimension1>;
}>;

export type EntityPostingsHealthCheckQuery = {
  __typename?: 'Query';
  posting?: Array<{
    __typename: 'Posting2dResponse';
    metadata?: {
      __typename: 'Metadata';
      id?: number | null;
      shortName?: string | null;
      longName?: string | null;
    } | null;
    category?: Array<{
      __typename: 'Posting1dResponse';
      metadata?: {
        __typename: 'Metadata';
        id?: number | null;
        shortName?: string | null;
        longName?: string | null;
      } | null;
      metrics?: {
        __typename: 'PostingMetric';
        salary?: number | null;
        time_to_fill?: number | null;
        active?: number | null;
        new?: number | null;
        removed?: number | null;
        expected_hires?: number | null;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type EntityPostingsRolesHealthCheckQueryVariables = Exact<{
  filters?: InputMaybe<PostingFilters>;
  dim1?: InputMaybe<Dimension1>;
}>;

export type EntityPostingsRolesHealthCheckQuery = {
  __typename?: 'Query';
  posting?: Array<{
    __typename: 'Posting2dResponse';
    metadata?: {
      __typename: 'Metadata';
      id?: number | null;
      shortName?: string | null;
      longName?: string | null;
    } | null;
    category?: Array<{
      __typename: 'Posting1dResponse';
      metadata?: {
        __typename: 'Metadata';
        id?: number | null;
        shortName?: string | null;
        longName?: string | null;
      } | null;
      metrics?: {
        __typename: 'PostingMetric';
        count?: number | null;
        share?: number | null;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type CompanyIndustySelectionListHealthCheckQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CompanyIndustySelectionListHealthCheckQuery = {
  __typename?: 'Query';
  selectionList?: {
    __typename?: 'SelectionList';
    company?: Array<{
      __typename?: 'CompanyRefInfo';
      id?: string | null;
      shortName?: string | null;
      rank?: number | null;
      ticker?: string | null;
      longName?: string | null;
      ricsK50Id?: string | null;
      ricsK400Id?: string | null;
      sedol?: string | null;
      isin?: string | null;
      rcid?: string | null;
      label?: string | null;
      industry?: string | null;
      rics_k50?: string | null;
      rics_k400?: string | null;
    } | null> | null;
    industry?: Array<{
      __typename?: 'RefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      label?: string | null;
    } | null> | null;
    rics_k10?: Array<{
      __typename?: 'RicsRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      label?: string | null;
    } | null> | null;
    rics_k50?: Array<{
      __typename?: 'RicsRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      rics_k10?: string | null;
      label?: string | null;
    } | null> | null;
    rics_k400?: Array<{
      __typename?: 'RicsRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      rics_k10?: string | null;
      rics_k50?: string | null;
    } | null> | null;
  } | null;
};

export type GeographySummaryMapDataQueryVariables = Exact<{
  query: MapCoordsReq;
}>;

export type GeographySummaryMapDataQuery = {
  __typename?: 'Query';
  mapCoords: {
    __typename?: 'MapCoordsResp';
    region?: Array<
      Array<{
        __typename?: 'MapCoordsItem';
        id: number;
        name: string;
        lat: number;
        lon: number;
      }>
    > | null;
    country?: Array<
      Array<{
        __typename?: 'MapCoordsItem';
        id: number;
        name: string;
        lat: number;
        lon: number;
      }>
    > | null;
    msa?: Array<
      Array<{
        __typename?: 'MapCoordsItem';
        id: number;
        name: string;
        lat: number;
        lon: number;
      }>
    > | null;
  };
};

export type GetCompensationDataHealthCheckQueryVariables = Exact<{
  filters?: InputMaybe<CompensationFilters>;
  dim1?: InputMaybe<Dimension1>;
  dim2?: InputMaybe<CompensationDimension>;
}>;

export type GetCompensationDataHealthCheckQuery = {
  __typename?: 'Query';
  compensation?: Array<{
    __typename: 'CompensationResponse';
    dimension?: CompensationDimension | null;
    metadata?: {
      __typename: 'Metadata';
      id?: number | null;
      shortName?: string | null;
    } | null;
    category?: Array<{
      __typename: 'CompensationCategory';
      metadata?: {
        __typename: 'Metadata';
        id?: number | null;
        shortName?: string | null;
      } | null;
      metrics?: {
        __typename: 'CompensationMetrics';
        count?: number | null;
        share?: number | null;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type GetScreenerDataHealthCheckQueryVariables = Exact<{
  filters: ScreenerReq;
}>;

export type GetScreenerDataHealthCheckQuery = {
  __typename?: 'Query';
  screener: {
    __typename: 'ScreenerResp';
    pagination: { __typename: 'ScreenerRespPagination'; total_results: number };
    entities: Array<{
      __typename: 'ScreenerRespEntity';
      short_name: string;
      long_name: string;
      entity_id: number;
      headcount: Array<number>;
      inflow: Array<number>;
      outflow: Array<number>;
      hiring: Array<number>;
      attrition: Array<number>;
      growth: Array<number>;
      growth_yoy: Array<number>;
      salary: Array<number>;
      tenure: Array<number>;
      entity_info: {
        __typename: 'EntityInfo';
        company_info?: {
          __typename: 'ScreenerRespCompanyInfo';
          description: string;
          email: string;
          founder_api: boolean;
          founder_black: boolean;
          founder_female: boolean;
          founder_hispanic: boolean;
          founder_male: boolean;
          founder_multiple: boolean;
          founder_native: boolean;
          founder_white: boolean;
          funding_stage: string;
          hq_country: string;
          hq_metro_area: string;
          hq_region: string;
          hq_state: string;
          is_public: boolean;
          last_funding_amount?: number | null;
          last_funding_year?: number | null;
          linkedin_url: string;
          phone_number: string;
          rcid: number;
          rics_k10: string;
          rics_k50: string;
          rics_k400: string;
          total_funding_amount?: number | null;
          ultimate_parent_name?: string | null;
          ultimate_parent_rcid?: number | null;
          valuation?: number | null;
          website: string;
          year_founded: number;
        } | null;
      };
    }>;
  };
};

export type UserSearchHealthCheckQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;

export type UserSearchHealthCheckQuery = {
  __typename?: 'Query';
  userSearch?: Array<{
    __typename: 'User';
    id?: string | null;
    name?: string | null;
    email?: string | null;
    client_name?: string | null;
    active?: boolean | null;
    live?: boolean | null;
  } | null> | null;
};

export type ReportConfigHealthCheckQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ReportConfigHealthCheckQuery = {
  __typename?: 'Query';
  reports_validation: Array<{
    __typename: 'ReportsValidationResponse';
    report_validation?: {
      __typename: 'ReportValidation';
      id: number;
      report_type: ReportTypeEnum;
      label: string;
      description: string;
      sample_link?: string | null;
      category: Array<string>;
      main_entity: Array<{
        __typename: 'ReportValidationEntity';
        selection_list: Array<string>;
        limit: number;
        required: boolean;
        label: string;
        description: string;
      } | null>;
      comparison_entities?: Array<{
        __typename: 'ReportValidationEntity';
        selection_list: Array<string>;
        limit: number;
        required: boolean;
        label: string;
        description: string;
      } | null> | null;
      filters?: Array<{
        __typename: 'ReportValidationEntity';
        selection_list: Array<string>;
        limit: number;
        required: boolean;
        label: string;
        description: string;
      } | null> | null;
    } | null;
  } | null>;
};

export type TalentDiscoveryV3HealthCheckQueryVariables = Exact<{
  query?: InputMaybe<TalentDiscoveryReqV3>;
}>;

export type TalentDiscoveryV3HealthCheckQuery = {
  __typename?: 'Query';
  talent_discovery_search_v3: {
    __typename: 'TalentDiscoveryRespV3';
    columns: Array<string>;
    users?: Array<{
      __typename: 'TalentDiscoveryRespUserV3';
      RCID: number;
      first_name: string;
      last_name: string;
      current_company: string;
      current_title: string;
      email: string;
      user_location: string;
      salary_total: number;
    } | null> | null;
    pagination?: {
      __typename: 'TalentDiscoveryRespPageV3';
      tot_pages_num: number;
      tot_users_num: number;
    } | null;
  };
};

export type CompositionTooltipQueryVariables = Exact<{
  entities: Array<CompositionV2Entity> | CompositionV2Entity;
  filters: CompositionV2FullSnapshotFilters;
}>;

export type CompositionTooltipQuery = {
  __typename?: 'Query';
  composition_v2_tooltip?: {
    __typename?: 'CompositionV2FullSnapshotResp';
    entities: Array<{
      __typename?: 'CompositionV2FullSnapshotEntResp';
      scaled: {
        __typename?: 'CompositionV2EntRespData';
        headcount: Array<{
          __typename?: 'EntityWideDataPoint';
          id: number;
          value?: number | null;
        }>;
        salary: Array<{
          __typename?: 'EntityWideDataPoint';
          id: number;
          value?: number | null;
        }>;
      };
    }>;
  } | null;
};

export type PostingTooltipQueryVariables = Exact<{
  dim1?: InputMaybe<Dimension1>;
  filters?: InputMaybe<PostingFilters>;
}>;

export type PostingTooltipQuery = {
  __typename?: 'Query';
  posting?: Array<{
    __typename?: 'Posting2dResponse';
    metadata?: {
      __typename?: 'Metadata';
      id?: number | null;
      shortName?: string | null;
      longName?: string | null;
    } | null;
    category?: Array<{
      __typename?: 'Posting1dResponse';
      metadata?: { __typename?: 'Metadata'; shortName?: string | null } | null;
      metrics?: {
        __typename?: 'PostingMetric';
        time_to_fill?: number | null;
        active?: number | null;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type CompositionHeadcountOnlyV3QueryVariables = Exact<{
  entities: Array<CompositionV3Ent> | CompositionV3Ent;
  filters: CompositionV3Filters;
  corrections: CompositionV3Corrections;
  role_taxonomy: Scalars['Int']['input'];
  skill_taxonomy: Scalars['Int']['input'];
  breakdown_options: CompositionV3BreakdownOptions;
}>;

export type CompositionHeadcountOnlyV3Query = {
  __typename?: 'Query';
  composition_v3?: {
    __typename?: 'CompositionV3Resp';
    entities: Array<{
      __typename?: 'CompositionV3RespEnt';
      id: number;
      short_name: string;
      long_name: string;
      metrics: {
        __typename?: 'CompositionV3RespData';
        headcount: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
      };
    }>;
  } | null;
};

export type CompositionV3DataQueryVariables = Exact<{
  entities: Array<CompositionV3Ent> | CompositionV3Ent;
  filters: CompositionV3Filters;
  corrections: CompositionV3Corrections;
  role_taxonomy: Scalars['Int']['input'];
  skill_taxonomy: Scalars['Int']['input'];
  breakdown_options: CompositionV3BreakdownOptions;
  cache_options?: InputMaybe<ResponseCacheOptions>;
}>;

export type CompositionV3DataQuery = {
  __typename?: 'Query';
  composition_v3?: {
    __typename?: 'CompositionV3Resp';
    entities: Array<{
      __typename?: 'CompositionV3RespEnt';
      id: number;
      short_name: string;
      long_name: string;
      metrics: {
        __typename?: 'CompositionV3RespData';
        headcount: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        tenure: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        salary: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        growth_rate: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        hiring_rate: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        attrition_rate: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        gender: Array<{
          __typename?: 'Breakdown';
          id: number;
          rank: number;
          short_name: string;
          long_name: string;
          headcount: Array<{
            __typename?: 'BrkDataPoint';
            id: number;
            count: number;
            share: number;
          }>;
        }>;
        ethnicity: Array<{
          __typename?: 'Breakdown';
          id: number;
          rank: number;
          short_name: string;
          long_name: string;
          headcount: Array<{
            __typename?: 'BrkDataPoint';
            id: number;
            count: number;
            share: number;
          }>;
        }>;
        role: Array<{
          __typename?: 'Breakdown';
          id: number;
          rank: number;
          short_name: string;
          long_name: string;
          headcount: Array<{
            __typename?: 'BrkDataPoint';
            id: number;
            count: number;
            share: number;
          }>;
        }>;
        geography: Array<{
          __typename?: 'Breakdown';
          id: number;
          rank: number;
          short_name: string;
          long_name: string;
          headcount: Array<{
            __typename?: 'BrkDataPoint';
            id: number;
            count: number;
            share: number;
          }>;
        }>;
        seniority: Array<{
          __typename?: 'Breakdown';
          id: number;
          rank: number;
          short_name: string;
          long_name: string;
          headcount: Array<{
            __typename?: 'BrkDataPoint';
            id: number;
            count: number;
            share: number;
          }>;
        }>;
        education: Array<{
          __typename?: 'Breakdown';
          id: number;
          rank: number;
          short_name: string;
          long_name: string;
          headcount: Array<{
            __typename?: 'BrkDataPoint';
            id: number;
            count: number;
            share: number;
          }>;
        }>;
        rics: Array<{
          __typename?: 'Breakdown';
          id: number;
          rank: number;
          short_name: string;
          long_name: string;
          headcount: Array<{
            __typename?: 'BrkDataPoint';
            id: number;
            count: number;
            share: number;
          }>;
        }>;
        skills: Array<{
          __typename?: 'Breakdown';
          id: number;
          rank: number;
          short_name: string;
          long_name: string;
          headcount: Array<{
            __typename?: 'BrkDataPoint';
            id: number;
            count: number;
            share: number;
          }>;
        }>;
      };
    }>;
  } | null;
};

export type CompositionV3EntityDataQueryVariables = Exact<{
  entities: Array<CompositionV3Ent> | CompositionV3Ent;
  filters: CompositionV3Filters;
  corrections: CompositionV3Corrections;
  role_taxonomy: Scalars['Int']['input'];
  skill_taxonomy: Scalars['Int']['input'];
  breakdown_options: CompositionV3BreakdownOptions;
}>;

export type CompositionV3EntityDataQuery = {
  __typename?: 'Query';
  composition_v3?: {
    __typename?: 'CompositionV3Resp';
    entities: Array<{
      __typename?: 'CompositionV3RespEnt';
      id: number;
      short_name: string;
      long_name: string;
    }>;
  } | null;
};

export type CompositionV3TooltipQueryVariables = Exact<{
  entities: Array<CompositionV3Ent> | CompositionV3Ent;
  filters: CompositionV3Filters;
  corrections: CompositionV3Corrections;
  role_taxonomy: Scalars['Int']['input'];
  skill_taxonomy: Scalars['Int']['input'];
  breakdown_options: CompositionV3BreakdownOptions;
}>;

export type CompositionV3TooltipQuery = {
  __typename?: 'Query';
  composition_v3?: {
    __typename?: 'CompositionV3Resp';
    entities: Array<{
      __typename?: 'CompositionV3RespEnt';
      id: number;
      short_name: string;
      long_name: string;
      metrics: {
        __typename?: 'CompositionV3RespData';
        headcount: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        growth_rate: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
        salary: Array<{
          __typename?: 'EntWideDataPoint';
          id: number;
          val: number;
        }>;
      };
    }>;
  } | null;
};

export type GetEntityDataV2QueryVariables = Exact<{
  req?: InputMaybe<EntityV2Req>;
}>;

export type GetEntityDataV2Query = {
  __typename?: 'Query';
  entityV2?: {
    __typename?: 'EntityV2Resp';
    entity?: {
      __typename?: 'EntitySummary';
      name?: string | null;
      description?: string | null;
      founded?: string | null;
      headquarters?: string | null;
    } | null;
    competitors?: Array<{
      __typename?: 'EntityV2Competitors';
      closeness: number;
      id: number;
      shortName: string;
      longName: string;
    } | null> | null;
  } | null;
};

export type MonthWeekIndexQueryQueryVariables = Exact<{ [key: string]: never }>;

export type MonthWeekIndexQueryQuery = {
  __typename?: 'Query';
  index?: {
    __typename?: 'IndexValues';
    startMonth?: string | null;
    startMonthIndex?: number | null;
    endMonthIndex?: number | null;
    startWeek?: string | null;
    startWeekIndex?: number | null;
    endWeekIndex?: number | null;
    maxWeekIndex?: number | null;
    endMonth?: string | null;
    maxWeek?: string | null;
  } | null;
};

export type GetPayV2QueryVariables = Exact<{
  req?: InputMaybe<PayV2Req>;
}>;

export type GetPayV2Query = {
  __typename?: 'Query';
  pay_v2?: {
    __typename?: 'PayV2Resp';
    entities: Array<{
      __typename?: 'PayV2EntResp';
      metadata: {
        __typename?: 'EntMetadata';
        id: number;
        short_name: string;
        long_name: string;
      };
      metrics: {
        __typename?: 'PayV2EntRespData';
        overtime: {
          __typename?: 'PayV2EntRespOvertime';
          counts: Array<number>;
          SalaryBase: Array<number>;
          SalaryTotal: Array<number>;
          SalaryHourly: Array<number>;
        };
        histogram: {
          __typename?: 'PayV2EntRespHistogram';
          index: number;
          base: Array<number>;
          total: Array<number>;
          hourly: Array<number>;
        };
        top_companies: Array<{
          __typename?: 'PayV2EntRespHistogram';
          index: number;
          shortName: string;
          longName: string;
          base: Array<number>;
          total: Array<number>;
          hourly: Array<number>;
        }>;
        top_geos: Array<{
          __typename?: 'PayV2EntRespHistogram';
          index: number;
          shortName: string;
          longName: string;
          base: Array<number>;
          total: Array<number>;
          hourly: Array<number>;
        }>;
        top_roles: Array<{
          __typename?: 'PayV2EntRespHistogram';
          index: number;
          shortName: string;
          longName: string;
          base: Array<number>;
          total: Array<number>;
          hourly: Array<number>;
        }>;
      };
    }>;
    refs: { __typename?: 'CompositionV2EntRefs'; months: Array<string> };
  } | null;
};

export type GetPayV2TooltipQueryVariables = Exact<{
  req?: InputMaybe<PayV2Req>;
}>;

export type GetPayV2TooltipQuery = {
  __typename?: 'Query';
  pay_v2?: {
    __typename?: 'PayV2Resp';
    entities: Array<{
      __typename?: 'PayV2EntResp';
      metadata: {
        __typename?: 'EntMetadata';
        id: number;
        short_name: string;
        long_name: string;
      };
      metrics: {
        __typename?: 'PayV2EntRespData';
        histogram: {
          __typename?: 'PayV2EntRespHistogram';
          index: number;
          base: Array<number>;
          total: Array<number>;
          hourly: Array<number>;
        };
      };
    }>;
    refs: { __typename?: 'CompositionV2EntRefs'; months: Array<string> };
  } | null;
};

export type GetPayV2TopGeosQueryVariables = Exact<{
  req?: InputMaybe<PayV2Req>;
}>;

export type GetPayV2TopGeosQuery = {
  __typename?: 'Query';
  pay_v2?: {
    __typename?: 'PayV2Resp';
    entities: Array<{
      __typename?: 'PayV2EntResp';
      metadata: {
        __typename?: 'EntMetadata';
        id: number;
        short_name: string;
        long_name: string;
      };
      metrics: {
        __typename?: 'PayV2EntRespData';
        top_geos: Array<{
          __typename?: 'PayV2EntRespHistogram';
          index: number;
          shortName: string;
          longName: string;
          base: Array<number>;
          total: Array<number>;
          hourly: Array<number>;
        }>;
      };
    }>;
    refs: { __typename?: 'CompositionV2EntRefs'; months: Array<string> };
  } | null;
};

export type PostingDiscoveryQueryQueryVariables = Exact<{
  query?: InputMaybe<PostingDiscoveryReq>;
}>;

export type PostingDiscoveryQueryQuery = {
  __typename?: 'Query';
  posting_discovery_search: {
    __typename?: 'PostingDiscoveryResp';
    columns: Array<string>;
    postings: Array<{
      __typename?: 'PostingDiscoveryRow';
      job_id: number;
      rcid: number;
      company_id: number;
      company_name: string;
      rics_k400: string;
      rics_k50: string;
      rics_k10: string;
      post_date: string;
      role_v3_id: number;
      state: string;
      country: string;
      msa: string;
      city: string;
      region: string;
      seniority: string;
      remote_type: string;
      salary: number;
      skills: Array<string>;
      description: string;
      jobtitle: string;
      posting_url: string;
      location: string;
      expected_hires: number;
    }>;
    pagination?: {
      __typename?: 'PostingDiscoveryRespPage';
      tot_pages_num: number;
      tot_postings_num: number;
    } | null;
    map_data: Array<{
      __typename?: 'PostingDiscoveryGeoData';
      id: number;
      map_data_kind: MapDataKind;
      count: number;
      share: number;
      lat?: number | null;
      lon?: number | null;
      location?: string | null;
    }>;
  };
};

export type PostingsDataQueryVariables = Exact<{
  filters?: InputMaybe<PostingFilters>;
  dim1?: InputMaybe<Dimension1>;
  skip_share_of_postings_scaling?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type PostingsDataQuery = {
  __typename?: 'Query';
  posting?: Array<{
    __typename?: 'Posting2dResponse';
    metadata?: {
      __typename?: 'Metadata';
      id?: number | null;
      shortName?: string | null;
      longName?: string | null;
    } | null;
    category?: Array<{
      __typename?: 'Posting1dResponse';
      metadata?: {
        __typename?: 'Metadata';
        id?: number | null;
        shortName?: string | null;
        longName?: string | null;
      } | null;
      metrics?: {
        __typename?: 'PostingMetric';
        salary?: number | null;
        time_to_fill?: number | null;
        active?: number | null;
        new?: number | null;
        removed?: number | null;
        expected_hires?: number | null;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type PostingsRolesDataQueryVariables = Exact<{
  filters?: InputMaybe<PostingFilters>;
  dim1?: InputMaybe<Dimension1>;
  skip_share_of_postings_scaling?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type PostingsRolesDataQuery = {
  __typename?: 'Query';
  posting?: Array<{
    __typename?: 'Posting2dResponse';
    metadata?: {
      __typename?: 'Metadata';
      id?: number | null;
      shortName?: string | null;
      longName?: string | null;
    } | null;
    category?: Array<{
      __typename?: 'Posting1dResponse';
      metadata?: {
        __typename?: 'Metadata';
        id?: number | null;
        shortName?: string | null;
        longName?: string | null;
      } | null;
      metrics?: {
        __typename?: 'PostingMetric';
        count?: number | null;
        share?: number | null;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type PostingsV3DataQueryVariables = Exact<{
  req: PostingsV3Req;
}>;

export type PostingsV3DataQuery = {
  __typename?: 'Query';
  postings_v3?: {
    __typename?: 'PostingsV3Resp';
    entities: Array<{
      __typename?: 'PostingsV3RespEnt';
      index: number;
      short_name: string;
      long_name: string;
      metrics: {
        __typename?: 'PostingsV3RespData';
        added: Array<{
          __typename?: 'PostingsV3DataPoint';
          id: number;
          val: number;
        }>;
        removed: Array<{
          __typename?: 'PostingsV3DataPoint';
          id: number;
          val: number;
        }>;
        active: Array<{
          __typename?: 'PostingsV3DataPoint';
          id: number;
          val: number;
        }>;
        time_to_fill: Array<{
          __typename?: 'PostingsV3DataPoint';
          id: number;
          val: number;
        }>;
        salary: Array<{
          __typename?: 'PostingsV3DataPoint';
          id: number;
          val: number;
        }>;
        role_counts: Array<{
          __typename?: 'PostingsV3CountItem';
          id: number;
          rank: number;
          short_name: string;
          long_name: string;
          count: number;
          share: number;
        }>;
        company_counts: Array<{
          __typename?: 'PostingsV3CountItem';
          id: number;
          rank: number;
          short_name: string;
          long_name: string;
          count: number;
          share: number;
        }>;
      };
    }>;
  } | null;
};

export type PostingsV3TooltipQueryVariables = Exact<{
  req: PostingsV3Req;
}>;

export type PostingsV3TooltipQuery = {
  __typename?: 'Query';
  postings_v3?: {
    __typename?: 'PostingsV3Resp';
    entities: Array<{
      __typename?: 'PostingsV3RespEnt';
      index: number;
      short_name: string;
      long_name: string;
      metrics: {
        __typename?: 'PostingsV3RespData';
        active: Array<{
          __typename?: 'PostingsV3DataPoint';
          id: number;
          val: number;
        }>;
        time_to_fill: Array<{
          __typename?: 'PostingsV3DataPoint';
          id: number;
          val: number;
        }>;
      };
    }>;
  } | null;
};

export type PostingsGetActiveQueryVariables = Exact<{
  filters?: InputMaybe<PostingFilters>;
  dim1?: InputMaybe<Dimension1>;
  skip_share_of_postings_scaling?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type PostingsGetActiveQuery = {
  __typename?: 'Query';
  posting?: Array<{
    __typename?: 'Posting2dResponse';
    metadata?: {
      __typename?: 'Metadata';
      id?: number | null;
      shortName?: string | null;
      longName?: string | null;
    } | null;
    category?: Array<{
      __typename?: 'Posting1dResponse';
      metadata?: {
        __typename?: 'Metadata';
        id?: number | null;
        shortName?: string | null;
        longName?: string | null;
      } | null;
      metrics?: { __typename?: 'PostingMetric'; active?: number | null } | null;
    } | null> | null;
  } | null> | null;
};

export type QueryTransitionsV3QueryVariables = Exact<{
  req?: InputMaybe<TransitionsV3Req>;
}>;

export type QueryTransitionsV3Query = {
  __typename?: 'Query';
  transitions_v3?: {
    __typename?: 'TransitionsV3Resp';
    entities: Array<{
      __typename?: 'TransitionsV3RespEnt';
      id: number;
      index: number;
      short_name: string;
      long_name: string;
      metrics: {
        __typename?: 'TransitionsV3RespData';
        flows_inflows: {
          __typename?: 'TransitionsV3Flows';
          items: Array<{
            __typename?: 'TransitionsV3FlowsItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
        };
        flows_outflows: {
          __typename?: 'TransitionsV3Flows';
          items: Array<{
            __typename?: 'TransitionsV3FlowsItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
        };
        breakdowns_inflows: {
          __typename?: 'TransitionsV3Breakdowns';
          role: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          rics: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          education: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          seniority: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          geography: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          ethnicity: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          gender: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
        };
        breakdowns_current: {
          __typename?: 'TransitionsV3Breakdowns';
          gender: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          rics: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          education: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          seniority: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          role: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          geography: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          ethnicity: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
        };
        breakdowns_outflows: {
          __typename?: 'TransitionsV3Breakdowns';
          rics: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          education: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          seniority: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          role: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          geography: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          ethnicity: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          gender: Array<{
            __typename?: 'TransitionsV3BrkItem';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
        };
      };
    }>;
  } | null;
};

export type ReferenceListsQueryVariables = Exact<{ [key: string]: never }>;

export type ReferenceListsQuery = {
  __typename?: 'Query';
  highestDegree: Array<{
    __typename?: 'IdNamePair';
    id: number;
    name: string;
  } | null>;
  ethnicity: Array<{
    __typename?: 'IdNamePair';
    id: number;
    name: string;
  } | null>;
  gender: Array<{ __typename?: 'IdNamePair'; id: number; name: string } | null>;
  seniority: Array<{
    __typename?: 'IdNamePair';
    id: number;
    name: string;
  } | null>;
  employmentRelationship: Array<{
    __typename?: 'IdNamePair';
    id: number;
    name: string;
  } | null>;
  workSchedule: Array<{
    __typename?: 'IdNamePair';
    id: number;
    name: string;
  } | null>;
};

export type GetReportConfigQueryVariables = Exact<{ [key: string]: never }>;

export type GetReportConfigQuery = {
  __typename?: 'Query';
  reports_validation: Array<{
    __typename?: 'ReportsValidationResponse';
    report_validation?: {
      __typename?: 'ReportValidation';
      id: number;
      report_type: ReportTypeEnum;
      label: string;
      description: string;
      sample_link?: string | null;
      category: Array<string>;
      main_entity: Array<{
        __typename?: 'ReportValidationEntity';
        selection_list: Array<string>;
        limit: number;
        required: boolean;
        label: string;
        description: string;
      } | null>;
      comparison_entities?: Array<{
        __typename?: 'ReportValidationEntity';
        selection_list: Array<string>;
        limit: number;
        required: boolean;
        label: string;
        description: string;
      } | null> | null;
      filters?: Array<{
        __typename?: 'ReportValidationEntity';
        selection_list: Array<string>;
        limit: number;
        required: boolean;
        label: string;
        description: string;
      } | null> | null;
    } | null;
  } | null>;
};

export type RoleK17000SelectionListQueryVariables = Exact<{
  taxonomyId: CustomRoleTaxonomySelection;
}>;

export type RoleK17000SelectionListQuery = {
  __typename?: 'Query';
  selectionList?: {
    __typename?: 'SelectionList';
    role_taxonomy_k17000?: Array<{
      __typename?: 'RoleTaxonomyRefInfo';
      id?: string | null;
      role_k10?: string | null;
      role_k50?: string | null;
      role_k150?: string | null;
      role_k500?: string | null;
      role_k1500?: string | null;
      role_k15000?: string | null;
    } | null> | null;
  } | null;
};

export type RoleTaxonomyVersionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type RoleTaxonomyVersionsQuery = {
  __typename?: 'Query';
  roleTaxonomies: Array<{
    __typename?: 'RoleTaxonomyMetadata';
    taxonomyId: number;
    taxonomyName: string;
    version: string;
    isLatest: boolean;
  }>;
};

export type RoleV2SelectionListQueryVariables = Exact<{ [key: string]: never }>;

export type RoleV2SelectionListQuery = {
  __typename?: 'Query';
  selectionList?: {
    __typename?: 'SelectionList';
    job_category?: Array<{
      __typename?: 'RoleRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      topCleanedTitles?: string | null;
      topRawTitles?: string | null;
      label?: string | null;
    } | null> | null;
    role_k50?: Array<{
      __typename?: 'RoleRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      topCleanedTitles?: string | null;
      topRawTitles?: string | null;
      label?: string | null;
      job_category?: string | null;
    } | null> | null;
    role_k150?: Array<{
      __typename?: 'RoleRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      topCleanedTitles?: string | null;
      topRawTitles?: string | null;
      label?: string | null;
      job_category?: string | null;
      role_k50?: string | null;
    } | null> | null;
    role_k300?: Array<{
      __typename?: 'RoleRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      topCleanedTitles?: string | null;
      topRawTitles?: string | null;
      label?: string | null;
      job_category?: string | null;
      role_k50?: string | null;
      role_k150?: string | null;
    } | null> | null;
    role_k500?: Array<{
      __typename?: 'RoleRefInfo';
      id?: string | null;
      shortName?: string | null;
      topCleanedTitles?: string | null;
      topRawTitles?: string | null;
      longName?: string | null;
      label?: string | null;
      job_category?: string | null;
      role_k50?: string | null;
      role_k150?: string | null;
      role_k300?: string | null;
    } | null> | null;
    role_k1000?: Array<{
      __typename?: 'RoleRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      topCleanedTitles?: string | null;
      topRawTitles?: string | null;
      label?: string | null;
      job_category?: string | null;
      role_k50?: string | null;
      role_k150?: string | null;
      role_k300?: string | null;
      role_k500?: string | null;
    } | null> | null;
    role_k1250?: Array<{
      __typename?: 'RoleRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      topCleanedTitles?: string | null;
      topRawTitles?: string | null;
      label?: string | null;
      job_category?: string | null;
      role_k50?: string | null;
      role_k150?: string | null;
      role_k300?: string | null;
      role_k500?: string | null;
      role_k1000?: string | null;
    } | null> | null;
    role_k1500?: Array<{
      __typename?: 'RoleRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      topCleanedTitles?: string | null;
      topRawTitles?: string | null;
      label?: string | null;
      job_category?: string | null;
      role_k50?: string | null;
      role_k150?: string | null;
      role_k300?: string | null;
      role_k500?: string | null;
      role_k1000?: string | null;
      role_k1250?: string | null;
    } | null> | null;
  } | null;
};

export type GetSavedSetsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSavedSetsQuery = {
  __typename?: 'Query';
  presets?: Array<{
    __typename?: 'Preset';
    id?: string | null;
    name?: string | null;
    view?: View | null;
    default?: boolean | null;
    shared?: boolean | null;
    filters?: string | null;
  } | null> | null;
};

export type CreatePresetMutationVariables = Exact<{
  name: Scalars['String']['input'];
  view: View;
  filters: Scalars['String']['input'];
}>;

export type CreatePresetMutation = {
  __typename?: 'Mutation';
  createPreset?: {
    __typename?: 'Preset';
    id?: string | null;
    name?: string | null;
    view?: View | null;
    default?: boolean | null;
    shared?: boolean | null;
    filters?: string | null;
  } | null;
};

export type UpdatePresetMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<View>;
  filters?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdatePresetMutation = {
  __typename?: 'Mutation';
  updatePreset?: {
    __typename?: 'Preset';
    id?: string | null;
    name?: string | null;
    view?: View | null;
    default?: boolean | null;
    shared?: boolean | null;
    filters?: string | null;
  } | null;
};

export type DeletePresetMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeletePresetMutation = {
  __typename?: 'Mutation';
  deletePreset?: boolean | null;
};

export type GetSchoolInfoQueryVariables = Exact<{
  name: Scalars['String']['input'];
  page: Scalars['Int']['input'];
}>;

export type GetSchoolInfoQuery = {
  __typename?: 'Query';
  schoolInfo?: Array<{
    __typename?: 'SchoolRefInfo';
    id?: string | null;
    rsid?: string | null;
    name?: string | null;
  } | null> | null;
};

export type GetScreenerDataQueryVariables = Exact<{
  filters: ScreenerReq;
}>;

export type GetScreenerDataQuery = {
  __typename?: 'Query';
  screener: {
    __typename?: 'ScreenerResp';
    pagination: {
      __typename?: 'ScreenerRespPagination';
      total_results: number;
    };
    entities: Array<{
      __typename?: 'ScreenerRespEntity';
      short_name: string;
      long_name: string;
      entity_id: number;
      headcount: Array<number>;
      inflow: Array<number>;
      outflow: Array<number>;
      hiring: Array<number>;
      attrition: Array<number>;
      growth: Array<number>;
      growth_yoy: Array<number>;
      salary: Array<number>;
      tenure: Array<number>;
      entity_info: {
        __typename?: 'EntityInfo';
        company_info?: {
          __typename?: 'ScreenerRespCompanyInfo';
          description: string;
          email: string;
          founder_api: boolean;
          founder_black: boolean;
          founder_female: boolean;
          founder_hispanic: boolean;
          founder_male: boolean;
          founder_multiple: boolean;
          founder_native: boolean;
          founder_white: boolean;
          funding_stage: string;
          hq_country: string;
          hq_metro_area: string;
          hq_region: string;
          hq_state: string;
          is_public: boolean;
          last_funding_amount?: number | null;
          last_funding_year?: number | null;
          linkedin_url: string;
          phone_number: string;
          rcid: number;
          rics_k10: string;
          rics_k50: string;
          rics_k400: string;
          total_funding_amount?: number | null;
          ultimate_parent_name?: string | null;
          ultimate_parent_rcid?: number | null;
          valuation?: number | null;
          website: string;
          year_founded: number;
        } | null;
      };
    }>;
  };
};

export type GetSentimentDataQueryVariables = Exact<{
  filters?: InputMaybe<SentimentV2Filters>;
  dim1?: InputMaybe<Dimension1>;
}>;

export type GetSentimentDataQuery = {
  __typename?: 'Query';
  sentiment?: Array<{
    __typename?: 'SentimentResponseEntity';
    metadata?: {
      __typename?: 'Metadata';
      id?: number | null;
      shortName?: string | null;
      longName?: string | null;
      metadata_type?: string | null;
    } | null;
    result?: {
      __typename?: 'SentimentResult';
      scores?: {
        __typename?: 'SentimentMetrics';
        overall?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        business_outlook?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        career_growth?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        compensation?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        benefits?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        healthcare?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        retirement_pension?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        childcare?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        education_assistance?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        wellness_programs?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        work_life_balance?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        diversity_and_inclusion?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        leadership?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        culture?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        remote_work?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        onboarding?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        mentorship?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        technology?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        promotion_opportunities?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        paid_time_off?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        transparency?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        efficiency_and_bureaucracy?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        product_and_service_quality?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        prestige?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        coworkers?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        mission_and_vision?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        workplace_facilities?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        training?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        clients_and_customers?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        company_growth?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        schedule_flexibility?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        job_security?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        overtime?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        family_support?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        commission?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        independence?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        commute?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        safety?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        internal_communication?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        office_politics?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        harassment?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        honesty?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        ethics?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        commitment?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        compliance?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
        integrity?: Array<{
          __typename?: 'SentimentDataPoint';
          count?: number | null;
          value?: number | null;
          month_id?: number | null;
          weight?: number | null;
        } | null> | null;
      } | null;
    } | null;
    months_refs?: Array<{
      __typename?: 'Metadata';
      id?: number | null;
      shortName?: string | null;
      longName?: string | null;
    } | null> | null;
  } | null> | null;
};

export type GetSentimentSnapshotQueryVariables = Exact<{
  filters?: InputMaybe<SentimentV2Filters>;
  dim1?: InputMaybe<Dimension1>;
}>;

export type GetSentimentSnapshotQuery = {
  __typename?: 'Query';
  sentiment?: Array<{
    __typename?: 'SentimentResponseEntity';
    metadata?: {
      __typename?: 'Metadata';
      id?: number | null;
      shortName?: string | null;
      longName?: string | null;
      metadata_type?: string | null;
    } | null;
    result?: {
      __typename?: 'SentimentResult';
      scores?: {
        __typename?: 'SentimentMetrics';
        overall?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        business_outlook?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        career_growth?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        compensation?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        benefits?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        healthcare?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        retirement_pension?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        childcare?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        education_assistance?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        wellness_programs?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        work_life_balance?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        diversity_and_inclusion?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        leadership?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        culture?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        remote_work?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        onboarding?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        mentorship?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        technology?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        promotion_opportunities?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        paid_time_off?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        transparency?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        efficiency_and_bureaucracy?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        product_and_service_quality?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        prestige?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        coworkers?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        mission_and_vision?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        workplace_facilities?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        training?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        clients_and_customers?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        company_growth?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        schedule_flexibility?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        job_security?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        overtime?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        family_support?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        commission?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        independence?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        commute?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        safety?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        internal_communication?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        office_politics?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        harassment?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        honesty?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        ethics?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        commitment?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        compliance?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
        integrity?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
          weight?: number | null;
        } | null> | null;
      } | null;
    } | null;
    months_refs?: Array<{
      __typename?: 'Metadata';
      id?: number | null;
      shortName?: string | null;
      longName?: string | null;
    } | null> | null;
  } | null> | null;
};

export type GetSentimentMapDataQueryVariables = Exact<{
  filters?: InputMaybe<SentimentV2Filters>;
  dim1?: InputMaybe<Dimension1>;
}>;

export type GetSentimentMapDataQuery = {
  __typename?: 'Query';
  sentiment?: Array<{
    __typename?: 'SentimentResponseEntity';
    metadata?: {
      __typename?: 'Metadata';
      id?: number | null;
      shortName?: string | null;
      longName?: string | null;
      metadata_type?: string | null;
    } | null;
    result?: {
      __typename?: 'SentimentResult';
      scores?: {
        __typename?: 'SentimentMetrics';
        overall?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        business_outlook?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        career_growth?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        compensation?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        benefits?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        healthcare?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        retirement_pension?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        childcare?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        education_assistance?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        wellness_programs?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        work_life_balance?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        diversity_and_inclusion?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        leadership?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        culture?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        remote_work?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        onboarding?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        mentorship?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        technology?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        promotion_opportunities?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        paid_time_off?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        transparency?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        efficiency_and_bureaucracy?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        product_and_service_quality?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        prestige?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        coworkers?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        mission_and_vision?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        workplace_facilities?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        training?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        clients_and_customers?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        company_growth?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        schedule_flexibility?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        job_security?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        overtime?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        family_support?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        commission?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        independence?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        commute?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        safety?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        internal_communication?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        office_politics?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        harassment?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        honesty?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        ethics?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        commitment?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        compliance?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
        integrity?: Array<{
          __typename?: 'SentimentDataPoint';
          value?: number | null;
        } | null> | null;
      } | null;
    } | null;
  } | null> | null;
};

export type SkillV2SelectionListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SkillV2SelectionListQuery = {
  __typename?: 'Query';
  selectionList?: {
    __typename?: 'SelectionList';
    skill_k75?: Array<{
      __typename?: 'SkillRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      topSkills?: string | null;
    } | null> | null;
    skill_k700?: Array<{
      __typename?: 'SkillRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      skill_k75?: string | null;
      topSkills?: string | null;
    } | null> | null;
    skill_k3000?: Array<{
      __typename?: 'SkillRefInfo';
      id?: string | null;
      shortName?: string | null;
      longName?: string | null;
      skill_k75?: string | null;
      skill_k700?: string | null;
      topSkills?: string | null;
    } | null> | null;
  } | null;
};

export type TalentDiscoveryByIdV3QueryVariables = Exact<{
  query?: InputMaybe<TalentDiscoveryByIdReqV3>;
}>;

export type TalentDiscoveryByIdV3Query = {
  __typename?: 'Query';
  talent_discovery_search_by_id_v3: {
    __typename?: 'TalentDiscoveryByIdRespV3';
    users: Array<{
      __typename?: 'TalentDiscoveryByIdUserV3';
      original_user_id: number;
      user_id: number;
      shard: number;
      first_name: string;
      last_name: string;
      education: string;
      user_location: string;
      graduation_year?: number | null;
      work_history: Array<{
        __typename?: 'TalentDiscoveryWorkHistoryItemV3';
        first_name: string;
        last_name: string;
        email: string;
        current_title: string;
        current_company: string;
        employment_relationship: string;
        work_schedule: string;
        start_date: string;
        end_date: string;
        longitude: number;
        latitude: number;
        RCID: number;
        gender: string;
        ethnicity: string;
        location: string;
        highest_degree: string;
        salary_base: number;
        salary_total: number;
        prestige: string;
        remote_suitability: string;
        years_of_experience: number;
        flight_risk: string;
        linkedin_url: string;
        personal_email: string;
        phone_number: string;
        description: string;
        skills: Array<string>;
      }>;
      education_history: Array<{
        __typename?: 'TalentDiscoveryEduHistoryItemV3';
        rsid?: number | null;
        start_date?: string | null;
        end_date?: string | null;
        title?: string | null;
        university_name?: string | null;
      }>;
    }>;
  };
};

export type TalentDiscoveryDataV3QueryVariables = Exact<{
  query?: InputMaybe<TalentDiscoveryReqV3>;
}>;

export type TalentDiscoveryDataV3Query = {
  __typename?: 'Query';
  talent_discovery_search_v3: {
    __typename?: 'TalentDiscoveryRespV3';
    columns: Array<string>;
    users?: Array<{
      __typename?: 'TalentDiscoveryRespUserV3';
      RCID: number;
      current_company: string;
      current_title: string;
      education: string;
      email: string;
      employment_relationship: string;
      end_date: string;
      ethnicity: string;
      first_name: string;
      flight_risk: string;
      gender: string;
      graduation_year?: number | null;
      highest_degree: string;
      last_name: string;
      latitude: number;
      linkedin_url: string;
      location: string;
      longitude: number;
      original_user_id: number;
      personal_email: string;
      phone_number: string;
      prestige: string;
      remote_suitability: string;
      salary_base: number;
      salary_total: number;
      shard: number;
      skills: Array<string>;
      start_date: string;
      user_id: number;
      user_location: string;
      work_schedule: string;
      years_of_experience: number;
      work_history: Array<{
        __typename?: 'TalentDiscoveryWorkHistoryItemV3';
        RCID: number;
        current_company: string;
        current_title: string;
        email: string;
        end_date: string;
        ethnicity: string;
        first_name: string;
        flight_risk: string;
        gender: string;
        highest_degree: string;
        last_name: string;
        latitude: number;
        linkedin_url: string;
        location: string;
        longitude: number;
        personal_email: string;
        phone_number: string;
        prestige: string;
        remote_suitability: string;
        salary_base: number;
        salary_total: number;
        start_date: string;
        years_of_experience: number;
      }>;
      education_history: Array<{
        __typename?: 'TalentDiscoveryEduHistoryItemV3';
        rsid?: number | null;
        start_date?: string | null;
        end_date?: string | null;
        title?: string | null;
        university_name?: string | null;
      }>;
    } | null> | null;
    map_data?: Array<{
      __typename?: 'TalentDiscoveryRespGeoDataV3';
      id: number;
      type: number;
      count: number;
      share: number;
      lat?: number | null;
      lon?: number | null;
      location?: string | null;
    } | null> | null;
    pagination?: {
      __typename?: 'TalentDiscoveryRespPageV3';
      tot_pages_num: number;
      tot_users_num: number;
    } | null;
  };
};

export type TalentDiscoveryMapDataV3QueryVariables = Exact<{
  query?: InputMaybe<TalentDiscoveryReqV3>;
}>;

export type TalentDiscoveryMapDataV3Query = {
  __typename?: 'Query';
  talent_discovery_search_v3: {
    __typename?: 'TalentDiscoveryRespV3';
    columns: Array<string>;
    map_data?: Array<{
      __typename?: 'TalentDiscoveryRespGeoDataV3';
      id: number;
      type: number;
      count: number;
      share: number;
      lat?: number | null;
      lon?: number | null;
      location?: string | null;
    } | null> | null;
  };
};

export type TaxonomyVersionsQueryVariables = Exact<{
  taxonomyType: TaxonomyType;
}>;

export type TaxonomyVersionsQuery = {
  __typename?: 'Query';
  taxonomyVersions: {
    __typename?: 'TaxonomyVersionsResponse';
    versions: Array<string>;
  };
};

export type TaxonomyLatestVersionQueryVariables = Exact<{
  taxonomyType: TaxonomyType;
}>;

export type TaxonomyLatestVersionQuery = {
  __typename?: 'Query';
  taxonomyLatestVersion: {
    __typename?: 'TaxonomyLatestVersionResponse';
    version: string;
  };
};

export type TaxonomyListQueryVariables = Exact<{
  taxonomyType: TaxonomyType;
  taxonomyVersion?: InputMaybe<Scalars['String']['input']>;
}>;

export type TaxonomyListQuery = {
  __typename?: 'Query';
  taxonomyList: {
    __typename?: 'TaxonomyListResponse';
    taxonomies: Array<{
      __typename?: 'Taxonomy';
      id: number;
      name: string;
      version: string;
    }>;
  };
};

export type TaxonomyTreeQueryVariables = Exact<{
  taxonomyType: TaxonomyType;
  taxonomyId: Scalars['Int']['input'];
  taxonomyVersion?: InputMaybe<Scalars['String']['input']>;
  levels?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  includeTitles: Scalars['Boolean']['input'];
}>;

export type TaxonomyTreeQuery = {
  __typename?: 'Query';
  taxonomy: {
    __typename?: 'TaxonomyResponse';
    levels: Array<{
      __typename?: 'TaxonomyLevel';
      id: number;
      tag?: string | null;
      label?: string | null;
    }>;
    nodes: Array<
      {
        __typename?: 'TaxonomyNode';
        children?: Array<
          {
            __typename?: 'TaxonomyNode';
            children?: Array<
              {
                __typename?: 'TaxonomyNode';
                children?: Array<
                  {
                    __typename?: 'TaxonomyNode';
                    children?: Array<
                      {
                        __typename?: 'TaxonomyNode';
                        children?: Array<
                          {
                            __typename?: 'TaxonomyNode';
                            children?: Array<
                              { __typename?: 'TaxonomyNode' } & {
                                ' $fragmentRefs'?: {
                                  TaxonomyNodeFieldsFragment: TaxonomyNodeFieldsFragment;
                                };
                              }
                            > | null;
                          } & {
                            ' $fragmentRefs'?: {
                              TaxonomyNodeFieldsFragment: TaxonomyNodeFieldsFragment;
                            };
                          }
                        > | null;
                      } & {
                        ' $fragmentRefs'?: {
                          TaxonomyNodeFieldsFragment: TaxonomyNodeFieldsFragment;
                        };
                      }
                    > | null;
                  } & {
                    ' $fragmentRefs'?: {
                      TaxonomyNodeFieldsFragment: TaxonomyNodeFieldsFragment;
                    };
                  }
                > | null;
              } & {
                ' $fragmentRefs'?: {
                  TaxonomyNodeFieldsFragment: TaxonomyNodeFieldsFragment;
                };
              }
            > | null;
          } & {
            ' $fragmentRefs'?: {
              TaxonomyNodeFieldsFragment: TaxonomyNodeFieldsFragment;
            };
          }
        > | null;
      } & {
        ' $fragmentRefs'?: {
          TaxonomyNodeFieldsFragment: TaxonomyNodeFieldsFragment;
        };
      }
    >;
  };
};

export type TaxonomyNodeFieldsFragment = {
  __typename?: 'TaxonomyNode';
  id: number;
  name: string;
  count: number;
  titles?: Array<string> | null;
} & { ' $fragmentName'?: 'TaxonomyNodeFieldsFragment' };

export type TransitionV2DataQueryVariables = Exact<{
  req?: InputMaybe<TransitionsReqV2>;
}>;

export type TransitionV2DataQuery = {
  __typename?: 'Query';
  transitionsV2?: {
    __typename?: 'TransitionsRespV2';
    entities: Array<{
      __typename?: 'TransitionsEntRespV2';
      metadata: {
        __typename?: 'EntMetadata';
        id: number;
        short_name: string;
        long_name: string;
        type: string;
      };
      metrics: {
        __typename?: 'TransitionsV2EntData';
        flows: {
          __typename?: 'TransitionsFlows';
          inflows: Array<{
            __typename?: 'FlowsCounts';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          outflows: Array<{
            __typename?: 'FlowsCounts';
            id: number;
            short_name: string;
            long_name: string;
            count: number;
            share: number;
          }>;
          inflows_remaining: {
            __typename?: 'FlowsCounts';
            count: number;
            share: number;
          };
          outflows_remaining: {
            __typename?: 'FlowsCounts';
            count: number;
            share: number;
          };
        };
        breakdowns: {
          __typename?: 'TransitionsBreakdowns';
          role: Array<{
            __typename: 'BrkCounts';
            id: number;
            short_name: string;
            long_name: string;
            current_count: number;
            current_share: number;
            inflows_count: number;
            inflows_share: number;
            outflows_count: number;
            outflows_share: number;
          }>;
          rics: Array<{
            __typename: 'BrkCounts';
            id: number;
            short_name: string;
            long_name: string;
            current_count: number;
            current_share: number;
            inflows_count: number;
            inflows_share: number;
            outflows_count: number;
            outflows_share: number;
          }>;
          geography: Array<{
            __typename: 'BrkCounts';
            id: number;
            short_name: string;
            long_name: string;
            current_count: number;
            current_share: number;
            inflows_count: number;
            inflows_share: number;
            outflows_count: number;
            outflows_share: number;
          }>;
          seniority: Array<{
            __typename: 'BrkCounts';
            id: number;
            short_name: string;
            long_name: string;
            current_count: number;
            current_share: number;
            inflows_count: number;
            inflows_share: number;
            outflows_count: number;
            outflows_share: number;
          }>;
          gender: Array<{
            __typename: 'BrkCounts';
            id: number;
            short_name: string;
            long_name: string;
            current_count: number;
            current_share: number;
            inflows_count: number;
            inflows_share: number;
            outflows_count: number;
            outflows_share: number;
          }>;
          ethnicity: Array<{
            __typename: 'BrkCounts';
            id: number;
            short_name: string;
            long_name: string;
            current_count: number;
            current_share: number;
            inflows_count: number;
            inflows_share: number;
            outflows_count: number;
            outflows_share: number;
          }>;
          education: Array<{
            __typename: 'BrkCounts';
            id: number;
            short_name: string;
            long_name: string;
            current_count: number;
            current_share: number;
            inflows_count: number;
            inflows_share: number;
            outflows_count: number;
            outflows_share: number;
          }>;
        };
      };
    }>;
  } | null;
};

export type GetUserReportsQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type GetUserReportsQuery = {
  __typename?: 'Query';
  users?: Array<{
    __typename?: 'User';
    reports?: Array<{
      __typename?: 'Report';
      uuid?: string | null;
      job_id: number;
      job_name?: string | null;
      name?: string | null;
      client?: string | null;
      status: DeliveryStatus;
      created_at?: string | null;
      updated_at?: string | null;
      report: {
        __typename?: 'ReportResponse';
        reportType: ReportTypeEnum;
        mainEntities: Array<{
          __typename?: 'EntityOutput';
          type: EntityTypeEnum;
          values: Array<string>;
        }>;
        comparisonEntities?: Array<{
          __typename?: 'EntityOutput';
          type: EntityTypeEnum;
          values: Array<string>;
        }> | null;
        filters?: Array<{
          __typename?: 'ReportFilterOutput';
          type: ReportFilterType;
          id: string;
          values: Array<string>;
        }> | null;
      };
    }> | null;
  } | null> | null;
};

export type GetUserDetailsQueryVariables = Exact<{
  ids?: InputMaybe<
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type GetUserDetailsQuery = {
  __typename?: 'Query';
  users?: Array<{
    __typename?: 'User';
    id?: string | null;
    name?: string | null;
    username?: string | null;
    email?: string | null;
    role?: Role | null;
    client_name?: string | null;
    live?: boolean | null;
    active?: boolean | null;
    tabs?: Array<Tab> | null;
    company_lists?: Array<string | null> | null;
    linkup_postings?: boolean | null;
    num_seats?: string | null;
    custom_taxonomy?: CustomTaxonomyEnum | null;
    metadata?: Array<{
      __typename?: 'KeyValueResp';
      key?: MetadataKey | null;
      value?: string | null;
    } | null> | null;
    currency_data?: {
      __typename?: 'CurrencyRefInfo';
      id?: string | null;
      code?: string | null;
      name?: string | null;
      rate?: number | null;
      record_date?: string | null;
      effective_date?: string | null;
    } | null;
  } | null> | null;
};

export type WeekSelectionListQueryVariables = Exact<{ [key: string]: never }>;

export type WeekSelectionListQuery = {
  __typename?: 'Query';
  selectionList?: {
    __typename?: 'SelectionList';
    week?: Array<{
      __typename?: 'WeekRefInfo';
      id?: string | null;
      shortName?: string | null;
    } | null> | null;
  } | null;
};

export const TaxonomyNodeFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaxonomyNodeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TaxonomyNode' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'titles' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'includeTitles' },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaxonomyNodeFieldsFragment, unknown>;
export const GetUserSimpleDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUserSimpleDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserSimpleDetailsQuery,
  GetUserSimpleDetailsQueryVariables
>;
export const GetBasicUserDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBasicUserDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBasicUserDetailsQuery,
  GetBasicUserDetailsQueryVariables
>;
export const AllClientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllClients' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllClientsQuery, AllClientsQueryVariables>;
export const GetAllClientAndUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllClientAndUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'users' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'live' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'active' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'live' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'num_seats' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAllClientAndUsersQuery,
  GetAllClientAndUsersQueryVariables
>;
export const DecryptTalentDiscoveryDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DecryptTalentDiscoveryData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decryptString' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DecryptTalentDiscoveryDataQuery,
  DecryptTalentDiscoveryDataQueryVariables
>;
export const GetNameRecommendationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetNameRecommendations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TalentDiscoveryReqV3' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'talent_discovery_name_recommendations_v3',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'names' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetNameRecommendationsQuery,
  GetNameRecommendationsQueryVariables
>;
export const DeliverablesUserSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DeliverablesUserSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userSearch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'live' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeliverablesUserSearchQuery,
  DeliverablesUserSearchQueryVariables
>;
export const AllClientsTableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllClientsTable' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'num_seats' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'users' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllClientsTableQuery,
  AllClientsTableQueryVariables
>;
export const CreateClientRewriteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateClientRewrite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'client_name' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tabs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'Tab' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'live' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'active' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'linkup_postings' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'num_seats' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'company_lists' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'metadata' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'KeyValue' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'reports_configuration' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ClientReportsConfigInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'custom_taxonomy' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomTaxonomyEnum' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createClientGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'client_name' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'client_name' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tabs' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'tabs' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'live' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'live' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'active' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'active' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'linkup_postings' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'linkup_postings' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'num_seats' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'num_seats' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'company_lists' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'company_lists' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'metadata' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'metadata' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'reports_configuration' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'reports_configuration' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'custom_taxonomy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'custom_taxonomy' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateClientRewriteMutation,
  CreateClientRewriteMutationVariables
>;
export const AdminUserClientSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminUserClientSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userSearch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'live' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminUserClientSearchQuery,
  AdminUserClientSearchQueryVariables
>;
export const AdminImpersonationUserSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminImpersonationUserSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userSearch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'live' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AdminImpersonationUserSearchQuery,
  AdminImpersonationUserSearchQueryVariables
>;
export const GetAllClientUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllClientUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'clientName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'clientName' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'users' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'username' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'live' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'active' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'legacy_id' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAllClientUsersQuery,
  GetAllClientUsersQueryVariables
>;
export const GetAllClientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllClients' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllClientsQuery, GetAllClientsQueryVariables>;
export const GetClientDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetClientDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'company_lists' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tabs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'live' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkup_postings' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'num_seats' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'custom_taxonomy' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data_builder_configuration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'additional_permissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'allow_cusip' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contact_info' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'client_group' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pipeline_type' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'posting_source' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 's3_location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 's3_bucket' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 's3_file_prefix' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 's3_format' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'snowflake_location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'snowflake_db' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'snowflake_schema' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'snowflake_file_prefix',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reports_configuration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaults' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'report_types' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'all_report_types' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetClientDetailsQuery,
  GetClientDetailsQueryVariables
>;
export const UpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'password' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Role' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'client_name' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'active' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'metadata' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'KeyValue' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'name' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'email' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'email' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'username' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'email' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'role' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'role' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'client_name' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'client_name' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'password' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'password' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'active' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'active' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'metadata' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'metadata' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'live' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tabs' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'company_lists' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkup_postings' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'num_seats' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const AddUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'password' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Role' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'client_name' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'active' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'metadata' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'KeyValue' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'name' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'username' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'email' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'email' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'email' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'password' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'password' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'role' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'role' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'client_name' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'client_name' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'active' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'active' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'metadata' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'metadata' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'live' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tabs' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'company_lists' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkup_postings' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'num_seats' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddUserMutation, AddUserMutationVariables>;
export const UpdateClientGroupRewriteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateClientGroupRewrite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'client_name' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tabs' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'Tab' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'live' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'active' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'linkup_postings' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'num_seats' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'metadata' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'KeyValue' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'custom_taxonomy' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomTaxonomyEnum' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'reports_configuration' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ClientReportsConfigInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateClientGroup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'client_name' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'client_name' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tabs' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'tabs' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'live' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'live' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'active' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'active' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'linkup_postings' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'linkup_postings' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'num_seats' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'num_seats' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'metadata' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'metadata' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'custom_taxonomy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'custom_taxonomy' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'reports_configuration' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'reports_configuration' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'company_lists' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tabs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'live' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkup_postings' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'num_seats' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'custom_taxonomy' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateClientGroupRewriteMutation,
  UpdateClientGroupRewriteMutationVariables
>;
export const DeleteUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const ApiKeyManagementDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApiKeyManagement' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IdentityInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableApiKeyEndpoints' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listApiKeys' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'api_keys' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'api_key_id' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'created_at' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'created_by' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'created_by_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endpoints' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApiKeyManagementQuery,
  ApiKeyManagementQueryVariables
>;
export const AvailableApiKeyEndpointsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AvailableApiKeyEndpoints' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableApiKeyEndpoints' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AvailableApiKeyEndpointsQuery,
  AvailableApiKeyEndpointsQueryVariables
>;
export const RegisterApiKeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RegisterApiKey' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RegisterApiKeyInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registerApiKey' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'api_key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'api_key_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegisterApiKeyMutation,
  RegisterApiKeyMutationVariables
>;
export const RemoveApiKeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveApiKey' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'RemoveApiKeyInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeApiKey' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveApiKeyMutation,
  RemoveApiKeyMutationVariables
>;
export const GetGameResultsStatsV2Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetGameResultsStatsV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entities' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'CompositionV3Ent' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3Filters' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'corrections' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3Corrections' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'role_taxonomy' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'skill_taxonomy' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'breakdown_options' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3BreakdownOptions' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filtersSentV2' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SentimentV2Filters' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'msa' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'role_k150' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'seniority' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'payReq' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PayV2Req' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'rawComposition' },
            name: { kind: 'Name', value: 'composition_v3' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'entities' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'entities' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'filters' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'corrections' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'corrections' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'role_taxonomy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'role_taxonomy' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'skill_taxonomy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'skill_taxonomy' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'breakdown_options' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'breakdown_options' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'short_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'long_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'headcount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tenure' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'salary' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'growth_rate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hiring_rate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'attrition_rate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'posting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'msa' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'msa' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'role_k150' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'role_k150' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'seniority' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'seniority' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'provider' },
                      value: {
                        kind: 'ListValue',
                        values: [{ kind: 'IntValue', value: '0' }],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'start_date' },
                      value: {
                        kind: 'StringValue',
                        value: '2020-01-01',
                        block: false,
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'end_date' },
                      value: {
                        kind: 'StringValue',
                        value: '2025-05-19',
                        block: false,
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim1' },
                value: { kind: 'EnumValue', value: 'geography' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim2' },
                value: { kind: 'EnumValue', value: 'date' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shortName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'longName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'time_to_fill' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sentiment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filtersSentV2' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim1' },
                value: { kind: 'EnumValue', value: 'geography' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scores' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'overall' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pay_v2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'payReq' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'short_name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'long_name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'histogram' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'index' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetGameResultsStatsV2Query,
  GetGameResultsStatsV2QueryVariables
>;
export const CurrencySelectionListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CurrencySelectionList' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectionList' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'record_date' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'effective_date' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CurrencySelectionListQuery,
  CurrencySelectionListQueryVariables
>;
export const CreateReportsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createReports' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateReportRequest' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createReports' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'user_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'report_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateReportsMutation,
  CreateReportsMutationVariables
>;
export const DeleteReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteReportMutation,
  DeleteReportMutationVariables
>;
export const RefreshReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RefreshReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refreshReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RefreshReportMutation,
  RefreshReportMutationVariables
>;
export const GetUserResumesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUserResumes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resumes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resume_id' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enriched_data' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'download_link' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserResumesQuery, GetUserResumesQueryVariables>;
export const GetResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'resume_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'download_link' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enriched_data' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetResumeQuery, GetResumeQueryVariables>;
export const SaveResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ResumeRequest' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'resume_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'download_link' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'excel_location' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveResumeMutation, SaveResumeMutationVariables>;
export const DeleteResumeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteResume' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteResume' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteResumeMutation,
  DeleteResumeMutationVariables
>;
export const GetClientDetailsServerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetClientDetailsServer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'users' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetClientDetailsServerQuery,
  GetClientDetailsServerQueryVariables
>;
export const UpdateUserServerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUserServer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserRequest' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserServerMutation,
  UpdateUserServerMutationVariables
>;
export const UserSsoClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserSSOClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userSSOClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client_group' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserSsoClientQuery, UserSsoClientQueryVariables>;
export const CreateUserServerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateUserServer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserRequest' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateUserServerMutation,
  CreateUserServerMutationVariables
>;
export const EntityV2HealthCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EntityV2HealthCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'req' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'EntityV2Req' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'req' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'founded' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'headquarters' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'competitors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'closeness' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EntityV2HealthCheckQuery,
  EntityV2HealthCheckQueryVariables
>;
export const CompositionV3HealthCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompositionV3HealthCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entities' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'CompositionV3Ent' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3Filters' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'corrections' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3Corrections' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'role_taxonomy' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'skill_taxonomy' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'breakdown_options' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3BreakdownOptions' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'composition_v3' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'entities' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'entities' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'filters' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'corrections' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'corrections' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'role_taxonomy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'role_taxonomy' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'skill_taxonomy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'skill_taxonomy' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'breakdown_options' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'breakdown_options' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'short_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'long_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'headcount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'growth_rate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hiring_rate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'attrition_rate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompositionV3HealthCheckQuery,
  CompositionV3HealthCheckQueryVariables
>;
export const TransitionsV2HealthCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TransitionsV2HealthCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'req' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TransitionsReqV2' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitionsV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'req' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'short_name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'long_name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'flows' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'inflows' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'outflows' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'inflows_remaining',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'outflows_remaining',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TransitionsV2HealthCheckQuery,
  TransitionsV2HealthCheckQueryVariables
>;
export const SentimentHealthCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SentimentHealthCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SentimentV2Filters' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dim1' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Dimension1' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sentiment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim1' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dim1' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata_type' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scores' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'overall' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'business_outlook' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'career_growth' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'months_refs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SentimentHealthCheckQuery,
  SentimentHealthCheckQueryVariables
>;
export const AuthHealthCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AuthHealthCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'live' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tabs' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'company_lists' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkup_postings' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unified_postings' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'num_seats' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'custom_taxonomy' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AuthHealthCheckQuery,
  AuthHealthCheckQueryVariables
>;
export const SavedSetsHealthCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SavedSetsHealthCheck' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'presets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'view' } },
                { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shared' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filters' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SavedSetsHealthCheckQuery,
  SavedSetsHealthCheckQueryVariables
>;
export const SharedSelectionListHealthCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SharedSelectionListHealthCheck' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectionList' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'region' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'state' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'region' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'country' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'metro_area' },
                  name: { kind: 'Name', value: 'msa' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'region' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'country' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'job_category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topCleanedTitles' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topRawTitles' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'role_k150' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topCleanedTitles' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topRawTitles' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'job_category' },
                        name: { kind: 'Name', value: 'roleK7' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k50' },
                        name: { kind: 'Name', value: 'roleK50' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'seniority' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SharedSelectionListHealthCheckQuery,
  SharedSelectionListHealthCheckQueryVariables
>;
export const MonthWeekIndexHealthCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MonthWeekIndexHealthCheck' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'index' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startMonthIndex' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'endMonthIndex' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startWeekIndex' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'endWeekIndex' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'maxWeekIndex' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endMonth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxWeek' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MonthWeekIndexHealthCheckQuery,
  MonthWeekIndexHealthCheckQueryVariables
>;
export const CompositionSummaryV3DataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompositionSummaryV3Data' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entities' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'CompositionV3Ent' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3Filters' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'corrections' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3Corrections' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'role_taxonomy' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'skill_taxonomy' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'breakdown_options' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3BreakdownOptions' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'composition_v3' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'entities' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'entities' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'filters' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'corrections' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'corrections' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'role_taxonomy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'role_taxonomy' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'skill_taxonomy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'skill_taxonomy' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'breakdown_options' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'breakdown_options' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'short_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'long_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'headcount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'growth_rate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hiring_rate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'attrition_rate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompositionSummaryV3DataQuery,
  CompositionSummaryV3DataQueryVariables
>;
export const EntityPostingsHealthCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EntityPostingsHealthCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PostingFilters' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dim1' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Dimension1' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'posting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim1' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dim1' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim2' },
                value: { kind: 'EnumValue', value: 'date' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shortName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'longName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'salary' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'time_to_fill' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'new' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'removed' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expected_hires' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EntityPostingsHealthCheckQuery,
  EntityPostingsHealthCheckQueryVariables
>;
export const EntityPostingsRolesHealthCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EntityPostingsRolesHealthCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PostingFilters' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dim1' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Dimension1' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'posting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim1' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dim1' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim2' },
                value: { kind: 'EnumValue', value: 'top' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shortName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'longName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'count' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'share' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EntityPostingsRolesHealthCheckQuery,
  EntityPostingsRolesHealthCheckQueryVariables
>;
export const CompanyIndustySelectionListHealthCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompanyIndustySelectionListHealthCheck' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectionList' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'company' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ticker' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'industry' },
                        name: { kind: 'Name', value: 'industryId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ricsK50Id' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'rics_k50' },
                        name: { kind: 'Name', value: 'ricsK50Id' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ricsK400Id' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'rics_k400' },
                        name: { kind: 'Name', value: 'ricsK400Id' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sedol' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rcid' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'industry' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rics_k10' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rics_k50' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rics_k10' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rics_k400' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rics_k10' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rics_k50' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompanyIndustySelectionListHealthCheckQuery,
  CompanyIndustySelectionListHealthCheckQueryVariables
>;
export const GeographySummaryMapDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GeographySummaryMapData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MapCoordsReq' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mapCoords' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'region' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lon' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'country' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lon' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'msa' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lon' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GeographySummaryMapDataQuery,
  GeographySummaryMapDataQueryVariables
>;
export const GetCompensationDataHealthCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCompensationDataHealthCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'CompensationFilters' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dim1' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Dimension1' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dim2' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'CompensationDimension' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'compensation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim1' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dim1' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim2' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dim2' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dimension' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shortName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'count' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'share' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCompensationDataHealthCheckQuery,
  GetCompensationDataHealthCheckQueryVariables
>;
export const GetScreenerDataHealthCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetScreenerDataHealthCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ScreenerReq' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'screener' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_results' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'short_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'long_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entity_id' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'headcount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inflow' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outflow' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hiring' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attrition' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'growth' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'growth_yoy' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenure' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entity_info' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'company_info' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'email' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'founder_api',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'founder_black',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'founder_female',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'founder_hispanic',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'founder_male',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'founder_multiple',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'founder_native',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'founder_white',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'funding_stage',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hq_country' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'hq_metro_area',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hq_region' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hq_state' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'is_public' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'last_funding_amount',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'last_funding_year',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'linkedin_url',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'phone_number',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rcid' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rics_k10' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rics_k50' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rics_k400' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'total_funding_amount',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'ultimate_parent_name',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'ultimate_parent_rcid',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'valuation' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'website' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'year_founded',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetScreenerDataHealthCheckQuery,
  GetScreenerDataHealthCheckQueryVariables
>;
export const UserSearchHealthCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserSearchHealthCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userSearch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'live' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserSearchHealthCheckQuery,
  UserSearchHealthCheckQueryVariables
>;
export const ReportConfigHealthCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReportConfigHealthCheck' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports_validation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_validation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'report_type' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sample_link' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'main_entity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'selection_list' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'limit' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'required' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'comparison_entities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'selection_list' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'limit' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'required' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'selection_list' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'limit' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'required' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReportConfigHealthCheckQuery,
  ReportConfigHealthCheckQueryVariables
>;
export const TalentDiscoveryV3HealthCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TalentDiscoveryV3HealthCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TalentDiscoveryReqV3' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'talent_discovery_search_v3' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'columns' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'users' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'RCID' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'first_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'last_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'current_company' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'current_title' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user_location' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salary_total' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tot_pages_num' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tot_users_num' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TalentDiscoveryV3HealthCheckQuery,
  TalentDiscoveryV3HealthCheckQueryVariables
>;
export const CompositionTooltipDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompositionTooltip' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entities' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'CompositionV2Entity' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV2FullSnapshotFilters' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'composition_v2_tooltip' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'filters' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'entities' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'entities' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scaled' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'headcount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'salary' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompositionTooltipQuery,
  CompositionTooltipQueryVariables
>;
export const PostingTooltipDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PostingTooltip' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dim1' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Dimension1' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PostingFilters' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'posting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim1' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dim1' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim2' },
                value: { kind: 'EnumValue', value: 'date' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shortName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'time_to_fill' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PostingTooltipQuery, PostingTooltipQueryVariables>;
export const CompositionHeadcountOnlyV3Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompositionHeadcountOnlyV3' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entities' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'CompositionV3Ent' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3Filters' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'corrections' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3Corrections' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'role_taxonomy' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'skill_taxonomy' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'breakdown_options' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3BreakdownOptions' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'composition_v3' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'entities' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'entities' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'filters' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'corrections' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'corrections' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'role_taxonomy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'role_taxonomy' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'skill_taxonomy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'skill_taxonomy' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'breakdown_options' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'breakdown_options' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'short_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'long_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'headcount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompositionHeadcountOnlyV3Query,
  CompositionHeadcountOnlyV3QueryVariables
>;
export const CompositionV3DataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompositionV3Data' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entities' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'CompositionV3Ent' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3Filters' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'corrections' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3Corrections' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'role_taxonomy' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'skill_taxonomy' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'breakdown_options' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3BreakdownOptions' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cache_options' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ResponseCacheOptions' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'composition_v3' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'entities' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'entities' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'filters' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'corrections' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'corrections' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'role_taxonomy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'role_taxonomy' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'skill_taxonomy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'skill_taxonomy' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'breakdown_options' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'breakdown_options' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cache_options' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cache_options' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'short_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'long_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'headcount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tenure' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'salary' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'growth_rate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hiring_rate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'attrition_rate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gender' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rank' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'short_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'long_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'headcount' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ethnicity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rank' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'short_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'long_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'headcount' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rank' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'short_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'long_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'headcount' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'geography' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rank' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'short_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'long_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'headcount' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'seniority' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rank' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'short_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'long_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'headcount' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'education' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rank' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'short_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'long_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'headcount' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rics' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rank' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'short_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'long_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'headcount' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'skills' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rank' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'short_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'long_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'headcount' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompositionV3DataQuery,
  CompositionV3DataQueryVariables
>;
export const CompositionV3EntityDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompositionV3EntityData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entities' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'CompositionV3Ent' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3Filters' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'corrections' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3Corrections' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'role_taxonomy' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'skill_taxonomy' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'breakdown_options' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3BreakdownOptions' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'composition_v3' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'entities' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'entities' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'filters' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'corrections' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'corrections' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'role_taxonomy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'role_taxonomy' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'skill_taxonomy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'skill_taxonomy' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'breakdown_options' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'breakdown_options' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'short_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'long_name' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompositionV3EntityDataQuery,
  CompositionV3EntityDataQueryVariables
>;
export const CompositionV3TooltipDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompositionV3Tooltip' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entities' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'CompositionV3Ent' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3Filters' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'corrections' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3Corrections' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'role_taxonomy' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'skill_taxonomy' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'breakdown_options' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CompositionV3BreakdownOptions' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'composition_v3' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'entities' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'entities' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'filters' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'corrections' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'corrections' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'role_taxonomy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'role_taxonomy' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'skill_taxonomy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'skill_taxonomy' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'breakdown_options' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'breakdown_options' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'short_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'long_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'headcount' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'growth_rate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'salary' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompositionV3TooltipQuery,
  CompositionV3TooltipQueryVariables
>;
export const GetEntityDataV2Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEntityDataV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'req' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'EntityV2Req' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'req' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'founded' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'headquarters' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'competitors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'closeness' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEntityDataV2Query,
  GetEntityDataV2QueryVariables
>;
export const MonthWeekIndexQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MonthWeekIndexQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'index' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'startMonth' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startMonthIndex' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'endMonthIndex' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startWeek' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'startWeekIndex' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'endWeekIndex' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'maxWeekIndex' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endMonth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxWeek' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MonthWeekIndexQueryQuery,
  MonthWeekIndexQueryQueryVariables
>;
export const GetPayV2Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPayV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'req' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PayV2Req' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pay_v2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'req' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'short_name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'long_name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'overtime' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'counts' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'SalaryBase' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'SalaryTotal',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'SalaryHourly',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'histogram' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'index' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'base' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hourly' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'top_companies' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'index' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'shortName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'longName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'base' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hourly' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'top_geos' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'index' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'shortName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'longName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'base' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hourly' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'top_roles' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'index' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'shortName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'longName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'base' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hourly' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'months' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPayV2Query, GetPayV2QueryVariables>;
export const GetPayV2TooltipDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPayV2Tooltip' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'req' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PayV2Req' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pay_v2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'req' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'short_name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'long_name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'histogram' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'index' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'base' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hourly' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'months' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPayV2TooltipQuery,
  GetPayV2TooltipQueryVariables
>;
export const GetPayV2TopGeosDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPayV2TopGeos' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'req' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PayV2Req' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pay_v2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'req' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'short_name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'long_name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'top_geos' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'index' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'shortName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'longName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'base' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'total' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hourly' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'refs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'months' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPayV2TopGeosQuery,
  GetPayV2TopGeosQueryVariables
>;
export const PostingDiscoveryQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PostingDiscoveryQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PostingDiscoveryReq' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'posting_discovery_search' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'postings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'job_id' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'rcid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'company_id' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'company_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rics_k400' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rics_k50' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rics_k10' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'post_date' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role_v3_id' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'country' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'msa' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'region' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seniority' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'remote_type' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'skills' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'jobtitle' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'posting_url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expected_hires' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tot_pages_num' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tot_postings_num' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'map_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'map_data_kind' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'share' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lon' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'columns' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PostingDiscoveryQueryQuery,
  PostingDiscoveryQueryQueryVariables
>;
export const PostingsDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PostingsData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PostingFilters' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dim1' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Dimension1' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'skip_share_of_postings_scaling' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'posting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim1' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dim1' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim2' },
                value: { kind: 'EnumValue', value: 'date' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip_share_of_postings_scaling' },
                value: {
                  kind: 'Variable',
                  name: {
                    kind: 'Name',
                    value: 'skip_share_of_postings_scaling',
                  },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shortName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'longName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'salary' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'time_to_fill' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'new' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'removed' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expected_hires' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PostingsDataQuery, PostingsDataQueryVariables>;
export const PostingsRolesDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PostingsRolesData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PostingFilters' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dim1' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Dimension1' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'skip_share_of_postings_scaling' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'posting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim1' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dim1' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim2' },
                value: { kind: 'EnumValue', value: 'top' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip_share_of_postings_scaling' },
                value: {
                  kind: 'Variable',
                  name: {
                    kind: 'Name',
                    value: 'skip_share_of_postings_scaling',
                  },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shortName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'longName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'count' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'share' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PostingsRolesDataQuery,
  PostingsRolesDataQueryVariables
>;
export const PostingsV3DataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PostingsV3Data' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'req' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PostingsV3Req' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postings_v3' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'req' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'short_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'long_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'added' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'removed' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'time_to_fill' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'salary' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role_counts' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rank' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'short_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'long_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'share' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'company_counts' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rank' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'short_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'long_name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'share' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PostingsV3DataQuery, PostingsV3DataQueryVariables>;
export const PostingsV3TooltipDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PostingsV3Tooltip' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'req' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PostingsV3Req' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postings_v3' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'req' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'short_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'long_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'time_to_fill' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'val' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PostingsV3TooltipQuery,
  PostingsV3TooltipQueryVariables
>;
export const PostingsGetActiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PostingsGetActive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PostingFilters' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dim1' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Dimension1' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'skip_share_of_postings_scaling' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'posting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim1' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dim1' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim2' },
                value: { kind: 'EnumValue', value: 'date' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip_share_of_postings_scaling' },
                value: {
                  kind: 'Variable',
                  name: {
                    kind: 'Name',
                    value: 'skip_share_of_postings_scaling',
                  },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shortName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'longName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PostingsGetActiveQuery,
  PostingsGetActiveQueryVariables
>;
export const QueryTransitionsV3Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'QueryTransitionsV3' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'req' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TransitionsV3Req' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitions_v3' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'req' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'index' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'short_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'long_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'flows_inflows' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'flows_outflows' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'breakdowns_inflows',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'role' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rics' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'education' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'seniority' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'geography' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ethnicity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gender' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'breakdowns_current',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gender' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rics' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'education' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'seniority' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'role' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'geography' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ethnicity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'breakdowns_outflows',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rics' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'education' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'seniority' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'role' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'geography' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ethnicity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gender' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  QueryTransitionsV3Query,
  QueryTransitionsV3QueryVariables
>;
export const ReferenceListsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReferenceLists' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'highestDegree' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ethnicity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'gender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seniority' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'employmentRelationship' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workSchedule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReferenceListsQuery, ReferenceListsQueryVariables>;
export const GetReportConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetReportConfig' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports_validation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_validation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'report_type' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sample_link' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'main_entity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'selection_list' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'limit' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'required' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'comparison_entities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'selection_list' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'limit' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'required' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'selection_list' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'limit' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'required' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetReportConfigQuery,
  GetReportConfigQueryVariables
>;
export const RoleK17000SelectionListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RoleK17000SelectionList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'taxonomyId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CustomRoleTaxonomySelection' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectionList' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'role_taxonomy_k17000' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'taxonomy_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'taxonomyId' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role_k10' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role_k50' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role_k150' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role_k500' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role_k1500' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role_k15000' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RoleK17000SelectionListQuery,
  RoleK17000SelectionListQueryVariables
>;
export const RoleTaxonomyVersionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RoleTaxonomyVersions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roleTaxonomies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'taxonomyId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taxonomyName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isLatest' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RoleTaxonomyVersionsQuery,
  RoleTaxonomyVersionsQueryVariables
>;
export const RoleV2SelectionListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RoleV2SelectionList' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectionList' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'job_category' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topCleanedTitles' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topRawTitles' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'role_k50' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topCleanedTitles' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topRawTitles' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'job_category' },
                        name: { kind: 'Name', value: 'roleK7' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'role_k150' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topCleanedTitles' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topRawTitles' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'job_category' },
                        name: { kind: 'Name', value: 'roleK7' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k50' },
                        name: { kind: 'Name', value: 'roleK50' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'role_k300' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topCleanedTitles' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topRawTitles' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'job_category' },
                        name: { kind: 'Name', value: 'roleK7' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k50' },
                        name: { kind: 'Name', value: 'roleK50' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k150' },
                        name: { kind: 'Name', value: 'roleK150' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'role_k500' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'longName' },
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topCleanedTitles' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topRawTitles' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'job_category' },
                        name: { kind: 'Name', value: 'roleK7' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k50' },
                        name: { kind: 'Name', value: 'roleK50' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k150' },
                        name: { kind: 'Name', value: 'roleK150' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k300' },
                        name: { kind: 'Name', value: 'roleK300' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'role_k1000' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topCleanedTitles' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topRawTitles' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'job_category' },
                        name: { kind: 'Name', value: 'roleK7' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k50' },
                        name: { kind: 'Name', value: 'roleK50' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k150' },
                        name: { kind: 'Name', value: 'roleK150' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k300' },
                        name: { kind: 'Name', value: 'roleK300' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k500' },
                        name: { kind: 'Name', value: 'roleK500' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'role_k1250' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topCleanedTitles' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topRawTitles' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'job_category' },
                        name: { kind: 'Name', value: 'roleK7' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k50' },
                        name: { kind: 'Name', value: 'roleK50' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k150' },
                        name: { kind: 'Name', value: 'roleK150' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k300' },
                        name: { kind: 'Name', value: 'roleK300' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k500' },
                        name: { kind: 'Name', value: 'roleK500' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k1000' },
                        name: { kind: 'Name', value: 'roleK1000' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'role_k1500' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'label' },
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topCleanedTitles' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topRawTitles' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'job_category' },
                        name: { kind: 'Name', value: 'roleK7' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k50' },
                        name: { kind: 'Name', value: 'roleK50' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k150' },
                        name: { kind: 'Name', value: 'roleK150' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k300' },
                        name: { kind: 'Name', value: 'roleK300' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k500' },
                        name: { kind: 'Name', value: 'roleK500' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k1000' },
                        name: { kind: 'Name', value: 'roleK1000' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role_k1250' },
                        name: { kind: 'Name', value: 'roleK1250' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RoleV2SelectionListQuery,
  RoleV2SelectionListQueryVariables
>;
export const GetSavedSetsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSavedSets' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'presets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'view' } },
                { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shared' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filters' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSavedSetsQuery, GetSavedSetsQueryVariables>;
export const CreatePresetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPreset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'view' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'View' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPreset' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'name' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'view' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'view' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'default' },
                      value: { kind: 'BooleanValue', value: false },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'shared' },
                      value: { kind: 'BooleanValue', value: false },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'filters' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'view' } },
                { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shared' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filters' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePresetMutation,
  CreatePresetMutationVariables
>;
export const UpdatePresetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePreset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'view' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'View' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePreset' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'name' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'view' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'view' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'filters' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'view' } },
                { kind: 'Field', name: { kind: 'Name', value: 'default' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shared' } },
                { kind: 'Field', name: { kind: 'Name', value: 'filters' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePresetMutation,
  UpdatePresetMutationVariables
>;
export const DeletePresetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deletePreset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePreset' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeletePresetMutation,
  DeletePresetMutationVariables
>;
export const GetSchoolInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSchoolInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schoolInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'in' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'name' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'page' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rsid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSchoolInfoQuery, GetSchoolInfoQueryVariables>;
export const GetScreenerDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetScreenerData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ScreenerReq' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'screener' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'total_results' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'short_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'long_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entity_id' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'headcount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inflow' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outflow' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hiring' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attrition' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'growth' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'growth_yoy' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenure' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entity_info' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'company_info' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'email' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'founder_api',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'founder_black',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'founder_female',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'founder_hispanic',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'founder_male',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'founder_multiple',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'founder_native',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'founder_white',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'funding_stage',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hq_country' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'hq_metro_area',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hq_region' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hq_state' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'is_public' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'last_funding_amount',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'last_funding_year',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'linkedin_url',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'phone_number',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rcid' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rics_k10' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rics_k50' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rics_k400' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'total_funding_amount',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'ultimate_parent_name',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'ultimate_parent_rcid',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'valuation' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'website' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'year_founded',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetScreenerDataQuery,
  GetScreenerDataQueryVariables
>;
export const GetSentimentDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSentimentData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SentimentV2Filters' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dim1' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Dimension1' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sentiment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim1' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dim1' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata_type' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scores' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'overall' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'business_outlook' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'career_growth' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'compensation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'benefits' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'healthcare' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'retirement_pension',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'childcare' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'education_assistance',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'wellness_programs',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'work_life_balance',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'diversity_and_inclusion',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'leadership' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'culture' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'remote_work' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'onboarding' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mentorship' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'technology' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'promotion_opportunities',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'paid_time_off' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transparency' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'efficiency_and_bureaucracy',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'product_and_service_quality',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'prestige' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coworkers' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'mission_and_vision',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'workplace_facilities',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'training' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'clients_and_customers',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'company_growth' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'schedule_flexibility',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'job_security' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'overtime' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'family_support' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commission' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'independence' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commute' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'safety' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'internal_communication',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'office_politics' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'harassment' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'honesty' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ethics' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commitment' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'compliance' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'integrity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'month_id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'months_refs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSentimentDataQuery,
  GetSentimentDataQueryVariables
>;
export const GetSentimentSnapshotDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSentimentSnapshot' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SentimentV2Filters' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dim1' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Dimension1' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sentiment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim1' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dim1' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata_type' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scores' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'overall' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'business_outlook' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'career_growth' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'compensation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'benefits' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'healthcare' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'retirement_pension',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'childcare' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'education_assistance',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'wellness_programs',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'work_life_balance',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'diversity_and_inclusion',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'leadership' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'culture' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'remote_work' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'onboarding' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mentorship' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'technology' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'promotion_opportunities',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'paid_time_off' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transparency' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'efficiency_and_bureaucracy',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'product_and_service_quality',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'prestige' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coworkers' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'mission_and_vision',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'workplace_facilities',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'training' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'clients_and_customers',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'company_growth' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'schedule_flexibility',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'job_security' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'overtime' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'family_support' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commission' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'independence' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commute' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'safety' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'internal_communication',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'office_politics' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'harassment' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'honesty' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ethics' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commitment' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'compliance' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'integrity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'weight' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'months_refs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSentimentSnapshotQuery,
  GetSentimentSnapshotQueryVariables
>;
export const GetSentimentMapDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSentimentMapData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SentimentV2Filters' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dim1' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Dimension1' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sentiment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filters' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dim1' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'dim1' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata_type' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scores' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'overall' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'business_outlook' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'career_growth' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'compensation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'benefits' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'healthcare' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'retirement_pension',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'childcare' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'education_assistance',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'wellness_programs',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'work_life_balance',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'diversity_and_inclusion',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'leadership' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'culture' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'remote_work' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'onboarding' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mentorship' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'technology' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'promotion_opportunities',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'paid_time_off' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transparency' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'efficiency_and_bureaucracy',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'product_and_service_quality',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'prestige' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coworkers' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'mission_and_vision',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'workplace_facilities',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'training' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'clients_and_customers',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'company_growth' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'schedule_flexibility',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'job_security' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'overtime' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'family_support' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commission' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'independence' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commute' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'safety' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'internal_communication',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'office_politics' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'harassment' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'honesty' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ethics' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commitment' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'compliance' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'integrity' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'value' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSentimentMapDataQuery,
  GetSentimentMapDataQueryVariables
>;
export const SkillV2SelectionListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SkillV2SelectionList' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectionList' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skill_k75' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topSkills' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skill_k700' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'skill_k75' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topSkills' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skill_k3000' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'skill_k75' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'skill_k700' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topSkills' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SkillV2SelectionListQuery,
  SkillV2SelectionListQueryVariables
>;
export const TalentDiscoveryByIdV3Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TalentDiscoveryByIdV3' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TalentDiscoveryByIdReqV3' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'talent_discovery_search_by_id_v3' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'users' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'original_user_id' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user_id' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'shard' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'first_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'last_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'education' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user_location' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'graduation_year' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'work_history' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'first_name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'last_name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'current_title' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'current_company' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'employment_relationship',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'work_schedule' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'start_date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'end_date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'longitude' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'latitude' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'RCID' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gender' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ethnicity' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'highest_degree' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'salary_base' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'salary_total' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'prestige' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'remote_suitability',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'years_of_experience',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'flight_risk' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'linkedin_url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'personal_email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone_number' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'skills' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'education_history' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rsid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'start_date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'end_date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'university_name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TalentDiscoveryByIdV3Query,
  TalentDiscoveryByIdV3QueryVariables
>;
export const TalentDiscoveryDataV3Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TalentDiscoveryDataV3' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TalentDiscoveryReqV3' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'talent_discovery_search_v3' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'columns' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'users' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'RCID' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'current_company' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'current_title' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'education' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'employment_relationship',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'end_date' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ethnicity' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'first_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'flight_risk' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gender' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'graduation_year' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'highest_degree' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'last_name' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'latitude' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkedin_url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longitude' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'original_user_id' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'personal_email' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phone_number' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'prestige' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'remote_suitability' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salary_base' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salary_total' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'shard' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'skills' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'start_date' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user_id' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user_location' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'work_schedule' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'work_history' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'RCID' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'current_company' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'current_title' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'end_date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ethnicity' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'first_name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'flight_risk' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gender' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'highest_degree' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'last_name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'latitude' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'linkedin_url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'longitude' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'personal_email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone_number' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'prestige' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'remote_suitability',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'salary_base' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'salary_total' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'start_date' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'years_of_experience',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'education_history' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rsid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'start_date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'end_date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'university_name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'years_of_experience' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'map_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'share' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lon' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tot_pages_num' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tot_users_num' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TalentDiscoveryDataV3Query,
  TalentDiscoveryDataV3QueryVariables
>;
export const TalentDiscoveryMapDataV3Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TalentDiscoveryMapDataV3' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TalentDiscoveryReqV3' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'talent_discovery_search_v3' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'columns' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'map_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'share' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lon' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TalentDiscoveryMapDataV3Query,
  TalentDiscoveryMapDataV3QueryVariables
>;
export const TaxonomyVersionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaxonomyVersions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'taxonomyType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TaxonomyType' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taxonomyVersions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'taxonomy_type' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'taxonomyType' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'versions' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TaxonomyVersionsQuery,
  TaxonomyVersionsQueryVariables
>;
export const TaxonomyLatestVersionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaxonomyLatestVersion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'taxonomyType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TaxonomyType' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taxonomyLatestVersion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'taxonomy_type' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'taxonomyType' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TaxonomyLatestVersionQuery,
  TaxonomyLatestVersionQueryVariables
>;
export const TaxonomyListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaxonomyList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'taxonomyType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TaxonomyType' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'taxonomyVersion' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taxonomyList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'taxonomy_type' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'taxonomyType' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'taxonomy_version' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'taxonomyVersion' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'taxonomies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'version' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaxonomyListQuery, TaxonomyListQueryVariables>;
export const TaxonomyTreeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TaxonomyTree' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'taxonomyType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TaxonomyType' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'taxonomyId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'taxonomyVersion' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'levels' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeTitles' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taxonomy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'taxonomy_type' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'taxonomyType' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'taxonomy_id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'taxonomyId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'taxonomy_version' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'taxonomyVersion' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'levels' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'levels' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'levels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tag' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'TaxonomyNodeFields' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'children' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'TaxonomyNodeFields',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'children' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'TaxonomyNodeFields',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'children' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'TaxonomyNodeFields',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'children',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'TaxonomyNodeFields',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'children',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'TaxonomyNodeFields',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'children',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'TaxonomyNodeFields',
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TaxonomyNodeFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TaxonomyNode' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'titles' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'includeTitles' },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TaxonomyTreeQuery, TaxonomyTreeQueryVariables>;
export const TransitionV2DataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TransitionV2Data' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'req' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'TransitionsReqV2' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transitionsV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'req' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'req' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'short_name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'long_name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metrics' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'flows' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'inflows' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'outflows' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'inflows_remaining',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'outflows_remaining',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'share',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'breakdowns' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'role' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'current_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'current_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'inflows_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'inflows_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outflows_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outflows_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: '__typename',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rics' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'current_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'current_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'inflows_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'inflows_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outflows_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outflows_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: '__typename',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'geography' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'current_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'current_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'inflows_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'inflows_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outflows_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outflows_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: '__typename',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'seniority' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'current_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'current_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'inflows_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'inflows_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outflows_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outflows_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: '__typename',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gender' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'current_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'current_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'inflows_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'inflows_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outflows_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outflows_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: '__typename',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ethnicity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'current_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'current_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'inflows_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'inflows_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outflows_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outflows_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: '__typename',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'education' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'short_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'long_name',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'current_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'current_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'inflows_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'inflows_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outflows_count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'outflows_share',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: '__typename',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TransitionV2DataQuery,
  TransitionV2DataQueryVariables
>;
export const GetUserReportsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUserReports' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'String' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reports' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'job_id' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'job_name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'client' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'report' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reportType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainEntities' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'values' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'comparisonEntities',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'values' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'filters' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'values' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'created_at' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updated_at' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserReportsQuery, GetUserReportsQueryVariables>;
export const GetUserDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUserDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ids' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'client_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'live' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tabs' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'company_lists' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkup_postings' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'num_seats' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'custom_taxonomy' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency_data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'record_date' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'effective_date' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserDetailsQuery, GetUserDetailsQueryVariables>;
export const WeekSelectionListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WeekSelectionList' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectionList' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'week' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shortName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WeekSelectionListQuery,
  WeekSelectionListQueryVariables
>;
